<script src="../../vue.config.js"></script>
<template>
  <div class="ni-app-submission-form-wrapper">
    <h6>
      <span
        disabled="true"
        title="Unique number auto-assigned to the submission"
        ><a @click="toggleSubmissionView" v-show="showFromTable"
          >{{ fromTable }} > </a
        >Submission - {{ submissionID }}</span
      >
      <b-tag
        type="is-dark"
        v-show="showNextApprover && showForInternalUserOnly"
        class="approver-label"
        >Next Approver: {{ nextApproverName }}</b-tag
      >
      <div class="actions-wrapper" v-show="showActions">
        <b-button
          type="is-info"
          @click="downloadSubmissionFile('report')"
          v-show="showPSUploadButton()"
          >Submissions Report</b-button
        >
        <b-button
          type="is-info"
          @click="downloadSubmissionFile('id')"
          title="This process can take up to 10 minutes when the number of records are 1000 or more."
          >Download Data</b-button
        >
        <b-button
          type="is-info"
          v-show="showForInternalUserOnly"
          @click="downloadSubmissionFile('caId')"
          title="This process can take up to 10 minutes when the number of records are 1000 or more."
          >Download CA Data</b-button
        >
        <b-upload
          class="ni-app-delete-items-button custom-upload-item-level"
          v-model="file"
          @input="uploadItemSubmission"
          v-show="
            showCreateButtons &&
              showItemDetail &&
              (activeTab === 0 || activeTab === 1)
          "
        >
          <a
            class="button is-info"
            title="This process can take up to 10 minutes when the number of records are 1000 or more."
          >
            <span>Upload Data</span>
          </a>
        </b-upload>
        <b-upload
          class="ni-app-delete-items-button custom-upload-item-level"
          v-model="file"
          @input="uploadPortfolioManagement"
          v-show="
            showItemDetail &&
              activeTab === 2 &&
              showPMUploadButton() &&
              canUserEdit
          "
        >
          <a
            class="button is-info"
            title="This process can take up to 10 minutes when the number of records are 1000 or more."
          >
            <span>Upload Data</span>
          </a>
        </b-upload>
        <b-upload
          class="ni-app-delete-items-button custom-upload-item-level"
          v-model="file"
          @input="uploadRegulatoryAffairs"
          v-show="
            showItemDetail &&
              activeTab === 3 &&
              (loginRole === 3 || loginRole === 4 || loginRole === 5) &&
              canUserEdit
          "
        >
          <a
            class="button is-info"
            title="This process can take up to 10 minutes when the number of records are 1000 or more."
          >
            <span>Upload Data</span>
          </a>
        </b-upload>
        <b-upload
          class="ni-app-delete-items-button custom-upload-item-level"
          v-model="file"
          @input="uploadProductServices"
          v-show="
            showItemDetail &&
              activeTab === 4 &&
              showPSUploadButton() &&
              canUserEdit
          "
        >
          <a
            class="button is-info"
            title="This process can take up to 10 minutes when the number of records are 1000 or more."
          >
            <span>Upload Data</span>
          </a>
        </b-upload>
        <b-button
          type="is-info"
          v-show="
            showExitButton &&
              showSubmissionForSupplierUser &&
              showSubmissionDetail
          "
          @click="exitForm"
          outlined
          >Exit</b-button
        >
        <!--Submit button for suppliers-->
        <b-button
          v-show="showCreateButtons"
          type="is-info"
          :disabled="disableCreatorSubmit"
          @click="submitBySubmissionId('S')"
          >Submit</b-button
        >
        <b-button
          type="is-info"
          @click="cancelSubmission"
          outlined
          v-show="showCreateButtons"
          >Cancel</b-button
        >
        <!--Submit button for Approvers-->
        <b-button
          type="is-info"
          @click="submitBySubmissionId('A')"
          v-show="showApproveButtons && canUserEdit"
          :disabled="
            disableApproverSubmitBtn ||
              (supplierErrorCount > 0 && (loginRole === 1 || loginRole === 2))
          "
          >Submit</b-button
        >
        <b-button
          type="is-info"
          @click="promptReworkComments('W1')"
          v-show="
            (showApproveButtons && canUserEdit) ||
              (loginRole === 6 &&
                fromTable === 'View All Submissions' &&
                (nextApproverName === 'Dangerous Goods' ||
                  nextApproverName === 'Regulatory Affairs' ||
                  nextApproverName === 'Product Support' ||
                  nextApproverName === 'Product Services') &&
                submissionStatusIsActive)
          "
          >Send to Re-Work</b-button
        >
        <b-button
          type="is-info"
          @click="reassignSubmission()"
          v-show="
            (showApproveButtons && canUserEdit && showReassignButton()) ||
              (loginRole === 6 &&
                fromTable === 'View All Submissions' &&
                submissionStatusIsActive)
          "
          :disabled="
            supplierErrorCount > 0 && (loginRole === 1 || loginRole === 2)
          "
          >Reassign</b-button
        >
        <b-button
          type="is-info"
          @click="getSubmissionHistory"
          v-show="
            showApproveButtons &&
              showForInternalUserOnly &&
              !submissionStatusIsDraft
          "
          >View History</b-button
        >
        <b-button
          type="is-info"
          outlined
          @click="toggleSubmissionView"
          v-show="
            showSubmissionInReadOnly &&
              !showSubmissionForSupplierUser &&
              !canUserEdit
          "
          >Exit</b-button
        >
        <a class="ni-instructions-doc" target="_blank" :href="instructionspdf">
          <b-icon
            icon="file-document"
            title="New Item Submission Instructions Document for Suppliers"
            v-show="eventType"
            type="is-info"
            custom-size="mdi-48px"
            size="is-medium"
          ></b-icon>
        </a>
      </div>
    </h6>
    <h6 class="page-heading-wrapper">
      <a
        class="page-heading"
        v-show="defaultSubmissionView === 'Submission Detail'"
        >Submission Detail</a
      >
      <a
        class="page-heading"
        v-show="defaultSubmissionView === 'Item Level Detail'"
        >Item Level Detail</a
      >
      <b-field>
        <b-button
          type="is-info"
          class="ni-app-add-item-button"
          title="Add Item"
          v-show="showCreateButtons && showItemDetail && activeTab === 0"
          @click="addRowPOC()"
          >Add</b-button
        >
        <b-button
          type="is-info"
          class="ni-app-delete-items-button"
          title="Delete"
          v-show="showCreateButtons && showItemDetail && activeTab === 0"
          @click="generateDeletePayload"
          >Delete</b-button
        >
        <b-button
          type="is-info"
          class="ni-app-delete-items-button"
          title="Validate"
          v-show="showCreateButtons && showItemDetail"
          @click="validateItemsUnderSubmission"
          :disabled="disableValidateButton"
          >Validate</b-button
        >
        <!--      Action buttons for PM-->
        <b-button
          type="is-success"
          class="ni-app-delete-items-button"
          title="Mark Selected Approve"
          v-show="
            showApproveButtons &&
              showItemDetail &&
              (submissionStatusIsActive || submissionStatusIsReworkForPM) &&
              (loginRole === 1 || loginRole === 2) &&
              activeTab === 2 &&
              canUserEdit
          "
          @click="markSelectedAction('approve')"
          >Mark Selected Approve</b-button
        >
        <b-button
          type="is-danger"
          class="ni-app-delete-items-button"
          title="Mark Selected Reject"
          v-show="
            showApproveButtons &&
              showItemDetail &&
              (submissionStatusIsActive || submissionStatusIsReworkForPM) &&
              (loginRole === 1 || loginRole === 2) &&
              activeTab === 2 &&
              canUserEdit &&
              showStatusActionButtons
          "
          @click="markSelectedAction('reject')"
          >Mark Selected Reject</b-button
        >
        <b-button
          class="view-item-level-history-btn"
          type="is-info"
          @click="
            isComponentFieldsModalActive = true;
            tabToRetrieveFieldHistory.tabName = 'Portfolio Management';
            tabToRetrieveFieldHistory.submissionId = submissionID;
          "
          v-show="showItemDetail && loginRole && activeTab === 2"
          >View Item Level History</b-button
        >
        <!--      Action buttons for RA-->
        <b-button
          type="is-success"
          class="ni-app-delete-items-button"
          title="Mark Selected Approve"
          v-show="
            showApproveButtons &&
              showItemDetail &&
              submissionStatusIsActive &&
              (loginRole === 3 || loginRole === 4 || loginRole === 5) &&
              activeTab === 3 &&
              canUserEdit
          "
          @click="markSelectedAction('approve')"
          >Mark Selected Approve</b-button
        >
        <b-button
          type="is-danger"
          class="ni-app-delete-items-button"
          title="Mark Selected Reject"
          v-show="
            showApproveButtons &&
              showItemDetail &&
              submissionStatusIsActive &&
              (loginRole === 3 || loginRole === 4 || loginRole === 5) &&
              activeTab === 3 &&
              canUserEdit &&
              showStatusActionButtons
          "
          @click="markSelectedAction('reject')"
          >Mark Selected Reject</b-button
        >
        <b-button
          class="view-item-level-history-btn"
          type="is-info"
          @click="
            isComponentFieldsModalActive = true;
            tabToRetrieveFieldHistory.tabName = 'Regulatory Affairs';
            tabToRetrieveFieldHistory.submissionId = submissionID;
          "
          v-show="showItemDetail && loginRole && activeTab === 3"
          >View Item Level History</b-button
        >
        <!--      Action buttons for PS-->
        <b-button
          type="is-success"
          class="ni-app-delete-items-button"
          title="Mark Selected Approve"
          v-show="
            showApproveButtons &&
              showItemDetail &&
              submissionStatusIsActive &&
              loginRole === 6 &&
              activeTab === 4 &&
              canUserEdit
          "
          @click="markSelectedAction('approve')"
          >Mark Selected Approve</b-button
        >
        <b-button
          type="is-danger"
          class="ni-app-delete-items-button"
          title="Mark Selected Reject"
          v-show="
            showApproveButtons &&
              showItemDetail &&
              submissionStatusIsActive &&
              loginRole === 6 &&
              activeTab === 4 &&
              showStatusActionButtons &&
              canUserEdit
          "
          @click="markSelectedAction('reject')"
          >Mark Selected Reject</b-button
        >
        <b-button
          class="view-item-level-history-btn"
          type="is-info"
          @click="
            isComponentFieldsModalActive = true;
            tabToRetrieveFieldHistory.tabName = 'Product Services';
            tabToRetrieveFieldHistory.submissionId = submissionID;
          "
          v-show="showItemDetail && loginRole && activeTab === 4"
          >View Item Level History</b-button
        >
        <b-button
          v-show="defaultSubmissionView === 'Item Level Detail'"
          @click="
            defaultSubmissionView = 'Submission Detail';
            loadSubmissionView(defaultSubmissionView);
          "
          type="is-info"
          class="float-right"
          >View Submission Detail</b-button
        >
        <b-tag
          type="is-light"
          size="is-small"
          class="noedit-label"
          v-show="
            (fromTable === 'View All Submissions' ||
              showSubmissionInReadOnly) &&
              !canUserEdit
          "
          >The Submission cannot be edited in this view. To make edits as a
          supplier, please open it from "My Draft Submissions or My Rework
          Submissions" queues.</b-tag
        >

        <b-button
          v-show="defaultSubmissionView === 'Submission Detail'"
          @click="
            defaultSubmissionView = 'Item Level Detail';
            loadSubmissionView(defaultSubmissionView);
          "
          type="is-info"
          class="float-right "
          >View Item Level Detail</b-button
        >
      </b-field>
    </h6>
    <b-message type="is-danger" v-show="showValidationErrorMessage">
      {{ validationErrorDescription }}
    </b-message>
    <b-message type="is-success" v-show="showSuccessMessage">
      {{ successMessage }}
    </b-message>
    <b-loading :is-full-page="true" :active.sync="isLoading"> </b-loading>
    <section
      class="modal-card-body ni-submission-level-detail-body"
      v-show="showSubmissionDetail"
      v-on:change="checkEventTargetAndSave"
    >
      <div class="submitter-only-wrapper us-region">
        <div class="columns">
          <ValidationProvider
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            :class="[
              loginRole === 1 ? portfolioManagementEditAccess() : '',
              loginRole === 0 ? submissionLevelEditAccess() : '',
              (loginRole === 2
                ? canPmEditSupplierEntry
                  ? ''
                  : portfolioManagementEditAccess()
                : '') ||
              loginRole === 3 ||
              loginRole === 4 ||
              loginRole === 5 ||
              loginRole === 6
                ? submissionLevelEditAccess()
                : ''
            ]"
            class="column view-always"
          >
            <b-field
              label="Vendor ID"
              label-position="on-border"
              :class="classes"
              title="Unique account number assigned to the supplier of the product"
            >
              <v-select
                :clearable="loginRole === 0"
                v-if="showInternalVNs"
                label="name"
                :filterable="false"
                :options="vendorIds"
                v-model="vn"
                @search="fetchVendorIds"
              >
                <template slot="option" slot-scope="vendorId">
                  <div class="d-center">
                    {{ vendorId.name }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="vendorId">
                  <div class="selected d-center">
                    {{ vendorId.name }}
                  </div>
                </template>
                <template slot="no-options" slot-scope="{ search, searching }">
                  <template v-if="searching">
                    Sorry, no matching options.
                  </template>
                  <span v-else class="display-none"></span>
                </template>
              </v-select>
              <b-select v-else v-model="vn" expanded>
                <option v-for="vn in vnList" :value="vn" :key="vn.id">
                  {{ vn }}
                </option>
              </b-select>
            </b-field>
          </ValidationProvider>
          <ValidationProvider
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <b-field
              label="Vendor Name"
              label-position="on-border"
              :class="classes"
              title="Primary supplier of the item; name that appears on purchase orders, invoices, etc."
            >
              <b-input
                type="text"
                :value="vnName"
                disabled
                class="vn-name"
                :class="submissionLevelEditAccess()"
              >
              </b-input>
            </b-field>
          </ValidationProvider>
          <ValidationProvider
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <b-field
              label="Web Site"
              label-position="on-border"
              :class="classes"
              title="Internet address of the supplier (i.e.www.fishersci.com)"
            >
              <b-input
                type="text"
                v-model="website"
                :class="submissionLevelEditAccess()"
              >
              </b-input>
            </b-field>
          </ValidationProvider>
        </div>
        <div class="columns" :class="submissionLevelEditAccess()">
          <ValidationProvider
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <b-field
              label="Submission Description"
              label-position="on-border"
              class="is-6"
              :class="classes"
              title="Description of the submission to be used for the supplier/Fisher to identify the submission easily."
            >
              <b-input
                oninput="if (this.value.length > 200)
                        this.value = this.value.slice(0, 200);"
                type="textarea"
                v-model="submissionDesc"
              >
              </b-input>
            </b-field>
          </ValidationProvider>
          <div class="column">
            <b-field
              label="Created Date"
              label-position="on-border"
              class="column"
              title="Date the submission was created"
            >
              <b-input type="text" v-model="createdDate" disabled="true">
              </b-input>
            </b-field>
            <b-field
              label="Created By"
              label-position="on-border"
              class="column"
              title="Created By"
            >
              <b-input type="text" v-model="createdBy" disabled="true">
              </b-input>
            </b-field>
          </div>
        </div>
        <div class="columns" :class="submissionLevelEditAccess()">
          <ValidationProvider
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <div class="control" :class="classes">
              <b-field
                label="Product Contact Name"
                label-position="on-border"
                title="The name of the supplier representative to contact regarding product information (usually the person who completes this form)"
              >
                <b-input type="text" v-model="prodContactName"> </b-input>
              </b-field>
            </div>
          </ValidationProvider>
          <ValidationProvider
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <div class="control" :class="classes">
              <b-field
                label="Product Contact Email Address"
                label-position="on-border"
                title="The email of the supplier representative to contact regarding product information (usually the person who completes this form)"
              >
                <b-input type="email" v-model="prodContactEmail"> </b-input>
              </b-field>
            </div>
          </ValidationProvider>
          <b-field
            class="column"
            v-if="isUser3P"
            label="Product Launch Date"
            label-position="on-border"
          >
            <b-datepicker
              v-model="launchDate"
              @input="checkEventTargetAndSave"
              :min-date="minDate"
            >
            </b-datepicker>
          </b-field>
          <ValidationProvider
            v-else
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <div class="control" :class="classes">
              <b-field label="Product Launch Date" label-position="on-border">
                <b-datepicker
                  v-model="launchDate"
                  @input="checkEventTargetAndSave"
                  :min-date="minDate"
                >
                </b-datepicker>
              </b-field>
            </div>
          </ValidationProvider>
        </div>
        <div class="columns" :class="submissionLevelEditAccess()">
          <ValidationProvider
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <div class="control" :class="classes">
              <b-field
                label="Regulatory Contact Name"
                label-position="on-border"
                title="The name of the supplier representative to contact regarding regulatory product information"
              >
                <b-input type="text" v-model="regContactName"> </b-input>
              </b-field>
            </div>
          </ValidationProvider>
          <ValidationProvider
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <div class="control" :class="classes">
              <b-field
                label="Regulatory Contact Phone Number"
                label-position="on-border"
                title="The phone number of the supplier representative to contact regarding regulatory product information"
              >
                <b-input type="telephone" v-model="regContactPhone"> </b-input>
              </b-field>
            </div>
          </ValidationProvider>
          <ValidationProvider
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <div class="control" :class="classes">
              <b-field
                label="Regulatory Contact Email Address"
                label-position="on-border"
                title="The email of the supplier representative to contact regarding regulatory product information"
              >
                <b-input type="email" v-model="regContactEmail"> </b-input>
              </b-field>
            </div>
          </ValidationProvider>
        </div>
        <div
          class="columns quality-contact-div"
          :class="submissionLevelEditAccess()"
        >
          <b-field
            class="column"
            v-if="isUser3P"
            label="Quality Contact Name"
            label-position="on-border"
            title="The name of the supplier representative to contact regarding quality product information"
          >
            <b-input type="text" v-model="qualContactName"> </b-input>
          </b-field>
          <ValidationProvider
            v-else
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <div class="control" :class="classes">
              <b-field
                label="Quality Contact Name"
                label-position="on-border"
                title="The name of the supplier representative to contact regarding quality product information"
              >
                <b-input type="text" v-model="qualContactName"> </b-input>
              </b-field>
            </div>
          </ValidationProvider>
          <b-field
            class="column"
            v-if="isUser3P"
            label="Quality Contact Phone Number"
            label-position="on-border"
            title="The phone number of the supplier representative to contact regarding quality product information"
          >
            <b-input type="telephone" v-model="qualContactPhone"> </b-input>
          </b-field>
          <ValidationProvider
            v-else
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <div class="control" :class="classes">
              <b-field
                label="Quality Contact Phone Number"
                label-position="on-border"
                title="The phone number of the supplier representative to contact regarding quality product information"
              >
                <b-input type="telephone" v-model="qualContactPhone"> </b-input>
              </b-field>
            </div>
          </ValidationProvider>
          <b-field
            class="column"
            v-if="isUser3P"
            label="Quality Contact Email Address"
            label-position="on-border"
            title="The email of the supplier representative to contact regarding quality product information"
          >
            <b-input type="email" v-model="qualContactEmail"> </b-input>
          </b-field>
          <ValidationProvider
            v-else
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <div class="control" :class="classes">
              <b-field
                label="Quality Contact Email Address"
                label-position="on-border"
                title="The email of the supplier representative to contact regarding quality product information"
              >
                <b-input type="email" v-model="qualContactEmail"> </b-input>
              </b-field>
            </div>
          </ValidationProvider>
        </div>
        <div class="columns" :class="submissionLevelEditAccess()">
          <div class="column" v-if="isUser3P">
            <b-field
              label="Global Trade Contact Name"
              label-position="on-border"
              title="The name of the supplier representative to contact regarding import/export trade product information"
            >
              <b-input type="text" v-model="tradeContactName"> </b-input>
            </b-field>
          </div>
          <ValidationProvider
            v-else
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <div class="control" :class="classes">
              <b-field
                label="Global Trade Contact Name"
                label-position="on-border"
                title="The name of the supplier representative to contact regarding import/export trade product information"
              >
                <b-input type="text" v-model="tradeContactName"> </b-input>
              </b-field>
            </div>
          </ValidationProvider>
          <div class="column" v-if="isUser3P">
            <b-field
              label="Global Trade Contact Phone Number"
              label-position="on-border"
              title="The phone number of the supplier representative to contact regarding import/export trade product information"
            >
              <b-input type="telephone" v-model="tradeContactPhone"> </b-input>
            </b-field>
          </div>
          <ValidationProvider
            v-else
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <div class="control" :class="classes">
              <b-field
                label="Global Trade Contact Phone Number"
                label-position="on-border"
                title="The phone number of the supplier representative to contact regarding import/export trade product information"
              >
                <b-input type="telephone" v-model="tradeContactPhone">
                </b-input>
              </b-field>
            </div>
          </ValidationProvider>
          <div class="column" v-if="isUser3P">
            <b-field
              label="Global Trade Contact Email Address"
              label-position="on-border"
              title="The email of the supplier representative to contact regarding import/export trade product information"
            >
              <b-input type="email" v-model="tradeContactEmail"> </b-input>
            </b-field>
          </div>
          <ValidationProvider
            v-else
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <div class="control" :class="classes">
              <b-field
                label="Global Trade Contact Email Address"
                label-position="on-border"
                title="The email of the supplier representative to contact regarding import/export trade product information"
              >
                <b-input type="email" v-model="tradeContactEmail"> </b-input>
              </b-field>
            </div>
          </ValidationProvider>
        </div>
        <div class="columns" :class="submissionLevelEditAccess()">
          <div class="column" v-if="isUser3P">
            <b-field
              label="Transportation Contact Name"
              label-position="on-border"
              title="The name of the supplier representative to contact regarding hazardous and/or transportation product information"
            >
              <b-input type="text" v-model="transContactName"> </b-input>
            </b-field>
          </div>
          <ValidationProvider
            v-else
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <div class="control" :class="classes">
              <b-field
                label="Transportation Contact Name"
                label-position="on-border"
                title="The name of the supplier representative to contact regarding hazardous and/or transportation product information"
              >
                <b-input type="text" v-model="transContactName"> </b-input>
              </b-field>
            </div>
          </ValidationProvider>
          <div class="column" v-if="isUser3P">
            <b-field
              label="Transportation Contact Phone Number"
              label-position="on-border"
              title="The phone number of the supplier representative to contact hazardous and/or transportation regulatory product information"
            >
              <b-input type="telephone" v-model="transContactPhone"> </b-input>
            </b-field>
          </div>
          <ValidationProvider
            v-else
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <div class="control" :class="classes">
              <b-field
                label="Transportation Contact Phone Number"
                label-position="on-border"
                title="The phone number of the supplier representative to contact hazardous and/or transportation regulatory product information"
              >
                <b-input type="telephone" v-model="transContactPhone">
                </b-input>
              </b-field>
            </div>
          </ValidationProvider>
          <div class="column" v-if="isUser3P">
            <b-field
              label="Transportation Contact Email Address"
              label-position="on-border"
              title="The email of the supplier representative to contact hazardous and/or transportation regulatory product information"
            >
              <b-input type="email" v-model="transContactEmail"> </b-input>
            </b-field>
          </div>
          <ValidationProvider
            v-else
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <div class="control" :class="classes">
              <b-field
                label="Transportation Contact Email Address"
                label-position="on-border"
                title="The email of the supplier representative to contact hazardous and/or transportation regulatory product information"
              >
                <b-input type="email" v-model="transContactEmail"> </b-input>
              </b-field>
            </div>
          </ValidationProvider>
        </div>
        <div class="columns" :class="submissionLevelEditAccess()">
          <b-field
            label="Comments"
            label-position="on-border"
            class="column is-6"
            title="Any pertinent information that may be valuable to Fisher Scientific that is not requested anywhere else on the form"
          >
            <b-input type="textarea" v-model="supplierComments"> </b-input>
          </b-field>
        </div>
      </div>
      <div class="columns" v-show="suppRewrkReason">
        <b-field
          label="Supplier Rework Reason"
          label-position="on-border"
          class="column is-6"
        >
          <b-input type="textarea" v-model="suppRewrkReason" disabled>
          </b-input>
        </b-field>
      </div>
      <div class="columns" v-show="internalRewrkReason">
        <b-field
          label="Internal Rework Reason"
          label-position="on-border"
          class="column is-6"
        >
          <b-input type="textarea" v-model="internalRewrkReason" disabled>
          </b-input>
        </b-field>
      </div>
      <div
        v-show="showApproveButtons && !submissionStatusIsDraft"
        class="columns"
        :class="canEdit()"
      >
        <b-field
          label="Approver Comments"
          label-position="on-border"
          class="column is-6"
          :class="errorClass && internalComments"
        >
          <b-input type="textarea" v-model="internalComments"> </b-input>
        </b-field>
      </div>
      <div
        :class="
          loginRole === 0 ? 'hideTab' : pmFieldsOnSubmissionLevelEditAccess()
        "
        class="portfolio-management-submission-level-div"
      >
        <h6>Portfolio Management</h6>
        <div class="columns">
          <ValidationProvider
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
            vid="priority"
          >
            <div class="control" :class="classes">
              <b-field label="Priority" label-position="on-border">
                <b-select expanded v-model="priority">
                  <option value=" "></option>
                  <option value="Urgent">Urgent</option>
                  <option value="Normal">Normal</option>
                </b-select>
              </b-field>
            </div>
          </ValidationProvider>
          <ValidationProvider
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <div class="control" :class="classes">
              <b-field label="Business Unit" label-position="on-border">
                <b-select expanded v-model="busUnit">
                  <option value=" "></option>
                  <option value="Research (Franchise)"
                    >Research (Franchise)</option
                  >
                  <option value="Research (3P)">Research (3P)</option>
                  <option value="Healthcare">Healthcare</option>
                  <option value="Safety">Safety</option>
                  <option value="Education">Education</option>
                </b-select>
              </b-field>
            </div>
          </ValidationProvider>
          <b-field
            class="column"
            label="Describe Promotion (include dates)"
            label-position="on-border"
          >
            <b-input type="text" v-model="promotion"> </b-input>
          </b-field>
        </div>
        <div class="columns">
          <ValidationProvider
            rules="oneOf:Next in Series,Pre-Assigned FCAT,FCAT=VCAT,Prefix to VCAT,Suffix to VCAT,50-,Other"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
            vid="fcatSugSeries"
          >
            <div class="control" :class="classes">
              <b-field
                label="Suggested Fisher Catalog Number Series Assignment"
                label-position="on-border"
              >
                <b-select
                  expanded
                  v-model="fcatSugSeries"
                  id="fcatSugSeries"
                  :value="
                    fcatSugSeries === undefined ||
                    fcatSugSeries === '' ||
                    fcatSugSeries === ' '
                      ? (fcatSugSeries = ' ')
                      : ''
                  "
                  title="This process can take up to 10 minutes when the number of records are 1000 or more."
                >
                  <option value=" "></option>
                  <option value="Next in Series">Next in Series</option>
                  <option value="Pre-Assigned FCAT" v-show="!isUser3P"
                    >Pre-Assigned FCAT</option
                  >
                  <option value="FCAT=VCAT">FCAT=VCAT</option>
                  <option value="Prefix to VCAT">Prefix to VCAT</option>
                  <option value="Suffix to VCAT">Suffix to VCAT</option>
                  <option value="50-">50-</option>
                  <option value="Other">Other</option>
                </b-select>
              </b-field>
            </div>
          </ValidationProvider>
          <ValidationProvider
            rules="required_if:fcatSugSeries,Other"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <div class="control" :class="classes">
              <b-field
                label="Description of Other for Suggested FCAT"
                label-position="on-border"
              >
                <b-input type="text" v-model="fcatOther"> </b-input>
              </b-field>
            </div>
          </ValidationProvider>
          <ValidationProvider
            rules="required_if:fcatSugSeries,Prefix to VCAT,Suffix to VCAT"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <div class="control" :class="classes">
              <b-field
                label="Prefix/Suffix to add to FCAT"
                label-position="on-border"
              >
                <b-input type="text" v-model="prefixSuffix"></b-input>
              </b-field>
            </div>
          </ValidationProvider>
          <ValidationProvider
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <div class="control" :class="classes">
              <b-field label="Approver Email" label-position="on-border">
                <b-input
                  type="text"
                  v-model="prodContactEmail"
                  disabled="disabled"
                >
                </b-input>
              </b-field>
            </div>
          </ValidationProvider>
        </div>
        <div class="columns">
          <ValidationProvider
            rules="required"
            :bails="false"
            v-slot="{ classes }"
            immediate
            class="column"
          >
            <div class="control" :class="classes">
              <b-field
                label="Number of Products in this Submission"
                label-position="on-border"
              >
                <b-input
                  type="text"
                  v-model="prodCount"
                  disabled="disabled"
                  class="text-align-right"
                >
                </b-input>
              </b-field>
            </div>
          </ValidationProvider>
          <b-field
            class="column"
            label="Product Line Description of this Submission"
            label-position="on-border"
          >
            <b-input type="text" v-model="prodLineDesc"> </b-input>
          </b-field>
        </div>
      </div>
    </section>
    <b-button
      type="is-danger is-light"
      outlined
      class="gi-custom-filter-applied"
      v-show="
        (giFilterApplied && showItemDetail && activeTab === 0) ||
          (riFilterApplied && showItemDetail && activeTab === 1) ||
          (pmFilterApplied && showItemDetail && activeTab === 2) ||
          (raFilterApplied && showItemDetail && activeTab === 3) ||
          (psFilterApplied && showItemDetail && activeTab === 4)
      "
    >
      Custom Filter Applied
    </b-button>
    <div
      class="general-questions-filter-wrapper"
      v-show="showItemDetail && activeTab === 0"
    >
      <b-dropdown aria-role="menu" trap-focus class="general-questions-filter">
        <button class="button is-info is-outlined" slot="trigger">
          <span>Filter By</span>
        </button>
        <b-dropdown-item aria-role="menu-item" :focusable="false" custom>
          <b-field label="Errored Items">
            <b-select v-model="filterMapErrors">
              <option value=""></option>
              <option value="YES">YES</option>
              <option value="NO">NO</option>
            </b-select>
          </b-field>
          <b-field label="Supplier Catalog Number"
            ><b-input
              type="text"
              :value="filterMapVcat"
              @change.native="filterMapVcat = $event.target.value"
            ></b-input></b-field
          ><b-field label="Manufacturer Name">
            <b-input
              type="text"
              v-model="filterMapManufacturerName"
              @change.native="filterMapManufacturerName = $event.target.value"
            ></b-input>
          </b-field>
          <b-field label="Pricing Expiration Date">
            <b-datepicker
              :min-date="minAppDate"
              v-model="filterMapPricingExpDate"
            ></b-datepicker>
          </b-field>
          <b-field label="UNSPSC Code">
            <b-input
              type="numeric"
              v-model="filterMapUnspscCode"
              @change.native="filterMapUnspscCode = $event.target.value"
            >
            </b-input>
          </b-field>
        </b-dropdown-item>
      </b-dropdown>
      <b-dropdown aria-role="menu" trap-focus class="general-questions-sort">
        <button class="button is-info is-outlined" slot="trigger">
          <span>Sort By</span>
        </button>
        <b-dropdown-item aria-role="menu-item" :focusable="false" custom>
          <b-field label="Field Name">
            <b-select v-model="sortMapFieldName">
              <option value="VCAT"> Supplier Catalog Number </option
              ><option value="MNAME">Manufacturer Name</option>
              <option value="PRCEXPDATE">Pricing Expiration Date</option>
              <option value="UNSPSC">UNSPSC Code</option>
              <option value="LINEERRORS">Line Errors</option>
            </b-select>
          </b-field>
          <b-field label="Order">
            <b-select v-model="sortMapSelectedOrder">
              <option value="asc"> Ascending </option
              ><option value="desc">Descending</option>
            </b-select>
          </b-field>
        </b-dropdown-item>
      </b-dropdown>
      <b-dropdown
        aria-role="menu"
        trap-focus
        class="general-questions-search ni-app-delete-items-button"
      >
        <button class="button is-info is-outlined" slot="trigger">
          <span>Search By</span>
        </button>
        <b-dropdown-item aria-role="menu-item" :focusable="false" custom>
          <b-field label="Field Name">
            <b-select v-model="searchMapFieldName">
              <option value="VCAT">Supplier Catalog Number</option
              ><option value="MNAME">Manufacturer Name</option>
              <option value="PRCEXPDATE">Pricing Expiration Date</option>
              <option value="UNSPSC">UNSPSC Code</option>
            </b-select>
          </b-field>
          <b-field label="Search" v-show="searchMapFieldName !== 'PRCEXPDATE'">
            <b-input
              type="text"
              v-model="searchMapInput"
              @change.native="searchMapInput = $event.target.value"
            ></b-input>
          </b-field>
          <b-field label="Search" v-show="searchMapFieldName === 'PRCEXPDATE'">
            <b-datepicker
              :min-date="minAppDate"
              v-model="pricingExpDate"
            ></b-datepicker>
          </b-field>
        </b-dropdown-item>
      </b-dropdown>
      <b-button
        type="is-info"
        outlined
        @click="loadItemDetailsUnderSubmission()"
        class="item-level-apply-button"
      >
        Apply
      </b-button>
      <b-button
        type="is-info"
        outlined
        @click="
          resetInputs();
          loadItemDetailsUnderSubmission();
        "
        class="item-level-reset-button"
      >
        Reset
      </b-button>
      <b-button
        v-show="showCreateButtons && giTabErrorCount !== 0"
        class="show-errors-btn"
        type="is-danger"
        outlined
        @click="
          errorsModalProps.submissionId = submissionID;
          errorsModalProps.tab = 'GI';
          isViewUploadErrorsModalActive = true;
        "
        >Show Errors</b-button
      >
    </div>
    <div
      class="regulatory-information-filter-wrapper"
      v-show="showItemDetail && activeTab === 1"
    >
      <b-dropdown
        aria-role="menu"
        trap-focus
        class="regulatory-information-filter"
      >
        <button class="button is-info is-outlined" slot="trigger">
          <span>Filter By</span>
        </button>
        <b-dropdown-item aria-role="menu-item" :focusable="false" custom>
          <b-field label="Errored Items">
            <b-select v-model="filterMapRIErrors">
              <option value=""></option>
              <option value="YES">YES</option>
              <option value="NO">NO</option>
            </b-select>
          </b-field>
          <b-field label="Primary Commodity Code"
            ><b-select v-model="filterMapCategory">
              <option value=""></option>
              <option value="Chemicals">
                Chemicals
              </option>
              <option value="Consumables">
                Consumables
              </option>
              <option value="Apparatus">
                Apparatus
              </option>
              <option value="Diagnostics">
                Diagnostics
              </option>
              <option value="Furniture">
                Furniture
              </option>
              <option value="TSCP">
                Training, Services, and Custom Products
              </option>
              <option value="Instruments">
                Instruments
              </option>
              <option value="Equipment">
                Equipment
              </option>
              <option value="NA">NA</option>
            </b-select></b-field
          ><b-field label="Proposition 65">
            <b-select v-model="filterMapProp65">
              <option value=""></option> <option value="Y">Yes</option
              ><option value="N">No</option>
            </b-select>
          </b-field>
          <b-field label="Medical Device">
            <b-select v-model="filterMapMedDevice">
              <option value=""></option><option value="I">I</option
              ><option value="II">II</option>
              <option value="III">III</option>
              <option value="None">None</option>
              <option value="NA">NA</option>
            </b-select>
          </b-field>
        </b-dropdown-item>
      </b-dropdown>
      <b-dropdown
        aria-role="menu"
        trap-focus
        class="regulatory-information-sort"
      >
        <button class="button is-info is-outlined" slot="trigger">
          <span>Sort By</span>
        </button>
        <b-dropdown-item aria-role="menu-item" :focusable="false" custom>
          <b-field label="Field Name">
            <b-select v-model="sortMapRegulatoryField">
              <option value="category">Primary Commodity Code</option
              ><option value="prop65">Proposition 65</option>
              <option value="medDevice">Medical Device</option>
              <option value="lineErrors">Line Errors</option>
            </b-select>
          </b-field>
          <b-field label="Order">
            <b-select v-model="sortMapRegulatorySelectedOrder">
              <option value="asc">Ascending</option
              ><option value="desc">Descending</option>
            </b-select>
          </b-field>
        </b-dropdown-item>
      </b-dropdown>
      <b-dropdown
        aria-role="menu"
        trap-focus
        class="regulatory-information-search ni-app-delete-items-button"
      >
        <button class="button is-info is-outlined" slot="trigger">
          <span>Search By</span>
        </button>
        <b-dropdown-item aria-role="menu-item" :focusable="false" custom>
          <b-field label="Field Name">
            <b-select v-model="searchMapRegulatoryField">
              <option value="category">Primary Commodity Code</option
              ><option value="prop65">Proposition 65</option>
              <option value="medDevice">Medical Device</option>
            </b-select>
          </b-field>
          <b-field
            label="Search"
            v-show="searchMapRegulatoryField === 'category'"
            ><b-select v-model="searchMapRegulatoryInput">
              <option value=""></option>
              <option value="Chemicals">
                Chemicals
              </option>
              <option value="Consumables">
                Consumables
              </option>
              <option value="Apparatus">
                Apparatus
              </option>
              <option value="Diagnostics">
                Diagnostics
              </option>
              <option value="Furniture">
                Furniture
              </option>
              <option value="TSCP">
                Training, Services, and Custom Products
              </option>
              <option value="Instruments">
                Instruments
              </option>
              <option value="Equipment">
                Equipment
              </option>
            </b-select>
          </b-field>
          <b-field
            label="Search"
            v-show="searchMapRegulatoryField === 'prop65'"
          >
            <b-select v-model="searchMapRegulatoryInput">
              <option value=""></option> <option value="Y">Yes</option
              ><option value="N">No</option>
            </b-select>
          </b-field>
          <b-field
            label="Search"
            v-show="searchMapRegulatoryField === 'medDevice'"
          >
            <b-select v-model="searchMapRegulatoryInput">
              <option value=""></option><option value="I">I</option
              ><option value="II">II</option>
              <option value="III">III</option>
              <option value="None">None</option>
            </b-select>
          </b-field>
        </b-dropdown-item>
      </b-dropdown>
      <b-button
        type="is-info"
        outlined
        @click="
          checkRIFilterCriteria();
          canLoadRegulatoryInformationData = {
            loadDetails: true,
            generalQuestionRows: rows,
            actions: {
              fErrors: filterMapRIErrors,
              fCategory: filterMapCategory,
              fProp65: filterMapProp65,
              fMedDevice: filterMapMedDevice,
              soField: sortMapRegulatoryField,
              soOrder: sortMapRegulatorySelectedOrder,
              srFieldName: searchMapRegulatoryField,
              srValue: searchMapRegulatoryInput
            },
            paginationParams: {
              pageIndex: regulatoryPageIndex,
              numberOfRegulatoryItems: numberOfRegulatoryItems
            }
          };
        "
        class="item-level-apply-button"
      >
        Apply
      </b-button>
      <b-button
        type="is-info"
        outlined
        @click="
          resetRegulatoryInputs();
          checkRIFilterCriteria();
          canLoadRegulatoryInformationData = {
            loadDetails: true,
            generalQuestionRows: rows,
            actions: {
              fErrors: filterMapRIErrors,
              fCategory: filterMapCategory,
              fProp65: filterMapProp65,
              fMedDevice: filterMapMedDevice,
              soField: sortMapRegulatoryField,
              soOrder: sortMapRegulatorySelectedOrder,
              srFieldName: searchMapRegulatoryField,
              srValue: searchMapRegulatoryInput
            },
            paginationParams: {
              pageIndex: regulatoryPageIndex,
              numberOfRegulatoryItems: numberOfRegulatoryItems
            }
          };
        "
        class="item-level-reset-button"
      >
        Reset
      </b-button>
      <b-button
        v-show="showCreateButtons && riTabErrorCount !== 0"
        class="show-errors-btn"
        type="is-danger"
        outlined
        @click="
          errorsModalProps.submissionId = submissionID;
          errorsModalProps.tab = 'RI';
          isViewUploadErrorsModalActive = true;
        "
        >Show Errors</b-button
      >
    </div>
    <div
      class="regulatory-information-update-wrapper"
      v-show="showItemDetail && activeTab === 1 && showCreateButtons"
    >
      <b-dropdown
        aria-role="menu"
        trap-focus
        class="regulatory-information-update"
      >
        <button class="button is-info is-outlined" slot="trigger">
          <span>Update Fields</span>
        </button>
        <b-dropdown-item aria-role="menu-item" :focusable="false" custom>
          <b-field label="Mercury">
            <b-select v-model="update.mercury">
              <option value="Y">YES</option>
              <option value="N">NO</option>
            </b-select>
          </b-field>
          <b-field label="Benzene">
            <b-select v-model="update.benzene">
              <option value="Y">YES</option>
              <option value="N">NO</option>
            </b-select>
          </b-field>
          <b-field label="Asbestos">
            <b-select v-model="update.asbestos">
              <option value="Y">YES</option>
              <option value="N">NO</option>
            </b-select>
          </b-field>
          <b-field label="Iodine">
            <b-select v-model="update.iodine">
              <option value="Y">YES</option>
              <option value="N">NO</option>
            </b-select>
          </b-field>
          <b-field label="Radioactive">
            <b-select v-model="update.radioActive">
              <option value="Y">YES</option>
              <option value="N">NO</option>
            </b-select>
          </b-field>
          <b-field label="Pesticides">
            <b-select v-model="update.pesticide">
              <option value="Y">YES</option>
              <option value="N">NO</option>
            </b-select>
          </b-field>
          <b-field label="Alcohol">
            <b-select v-model="update.alcohol">
              <option value="Y">YES</option>
              <option value="N">NO</option>
            </b-select>
          </b-field>
        </b-dropdown-item>
      </b-dropdown>
      <b-button
        type="is-info"
        outlined
        @click="updateRIFields()"
        class="item-level-apply-button"
      >
        Apply
      </b-button>
      <b-button
        type="is-info"
        outlined
        @click="resetRIUpdateFields()"
        class="item-level-reset-button"
      >
        Reset
      </b-button>
      <b-upload
        class="ni-app-delete-items-button custom-upload-item-level"
        v-model="msdsAttachment"
        type="is-info"
        @input="massUploadAttachment('msdsAttachment')"
      >
        <a
          class="button is-info"
          title="This process can take up to 10 minutes when the number of records are 1000 or more."
        >
          <span>Upload Attach SDS</span>
        </a>
      </b-upload>
      <b-upload
        class="ni-app-delete-items-button custom-upload-item-level"
        v-model="batteryAttachment"
        type="is-info"
        title="This process can take up to 10 minutes when the number of records are 1000 or more."
        @input="massUploadAttachment('batteryAttachment')"
      >
        <a
          class="button is-info"
          title="This process can take up to 10 minutes when the number of records are 1000 or more."
        >
          <span>Upload Battery Report</span>
        </a>
      </b-upload>
      <b-upload
        class="ni-app-delete-items-button custom-upload-item-level"
        v-model="insertAttach"
        type="is-info"
        title="This process can take up to 10 minutes when the number of records are 1000 or more."
        @input="massUploadAttachment('insertAttach')"
      >
        <a
          class="button is-info"
          title="This process can take up to 10 minutes when the number of records are 1000 or more."
        >
          <span>Upload Insert/Attachment</span>
        </a>
      </b-upload>
    </div>
    <div
      class="portfolio-management-filter-wrapper"
      v-show="showItemDetail && activeTab === 2"
    >
      <b-dropdown
        aria-role="menu"
        trap-focus
        class="portfolio-management-filter"
      >
        <button class="button is-info is-outlined" slot="trigger">
          <span>Filter By</span>
        </button>
        <b-dropdown-item aria-role="menu-item" :focusable="false" custom>
          <b-field label="Errored Items">
            <b-select v-model="filterMapPMErrors">
              <option value=""></option>
              <option value="YES">YES</option>
              <option value="NO">NO</option>
            </b-select>
          </b-field>
          <b-field label="Suggested Fisher Catalog Number Assignment">
            <b-input
              type="text"
              :value="filterMapFcat"
              @change.native="filterMapFcat = $event.target.value"
            >
            </b-input
          ></b-field>
        </b-dropdown-item>
      </b-dropdown>
      <b-dropdown aria-role="menu" trap-focus class="portfolio-management-sort">
        <button class="button is-info is-outlined" slot="trigger">
          <span>Sort By</span>
        </button>
        <b-dropdown-item aria-role="menu-item" :focusable="false" custom>
          <b-field label="Line Errors">
            <b-select v-model="filterMapPMLineErrors">
              <option value=""></option>
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </b-select>
          </b-field>
        </b-dropdown-item>
      </b-dropdown>
      <b-button
        type="is-info"
        outlined
        @click="
          checkPMFilterCriteria();
          canLoadPortfolioManagementData = {
            loadDetails: true,
            generalQuestionRows: rows,
            actions: {
              fErrors: filterMapPMErrors,
              fLineErrors: filterMapPMLineErrors,
              fCat: filterMapFcat
            },
            paginationParams: {
              pageIndex: pmPageIndex,
              numberOfPMItems: numberOfPMItems
            }
          };
        "
        class="item-level-apply-button"
      >
        Apply
      </b-button>
      <b-button
        type="is-info"
        outlined
        @click="
          filterMapPMErrors = '';
          filterMapPMLineErrors = '';
          checkPMFilterCriteria();
          canLoadPortfolioManagementData = {
            loadDetails: true,
            generalQuestionRows: rows,
            actions: {
              fErrors: filterMapPMErrors,
              fLineErrors: filterMapPMLineErrors
            },
            paginationParams: {
              pageIndex: pmPageIndex,
              numberOfPMItems: numberOfPMItems
            }
          };
        "
        class="item-level-reset-button"
      >
        Reset
      </b-button>
      <b-button
        v-show="
          (pmTabErrorCount !== 0 &&
            submissionStatusIsActive &&
            submissionStatusIsReworkForPM &&
            (loginRole === 1 || loginRole === 2)) ||
            (submissionStatusIsActive && canUserEdit && pmTabErrorCount !== 0)
        "
        class="show-errors-btn"
        type="is-danger"
        outlined
        @click="
          errorsModalProps.submissionId = submissionID;
          errorsModalProps.tab = 'PM';
          isViewUploadErrorsModalActive = true;
        "
        >Show Errors</b-button
      >
      <button
        v-show="loginRole === 1 || loginRole === 2"
        class="button is-info float-right"
        @click="validateApproverAlert"
        :disabled="pmTabErrorCount >= 0"
      >
        <span>Validate</span>
      </button>
    </div>
    <div
      class="regulatory-affairs-filter-wrapper"
      v-show="showItemDetail && activeTab === 3"
    >
      <b-dropdown aria-role="menu" trap-focus class="regulatory-affairs-filter">
        <button class="button is-info is-outlined" slot="trigger">
          <span>Filter By</span>
        </button>
        <b-dropdown-item aria-role="menu-item" :focusable="false" custom>
          <b-field label="Errored Items">
            <b-select v-model="filterMapRAErrors">
              <option value=""></option>
              <option value="YES">YES</option>
              <option value="NO">NO</option>
            </b-select>
          </b-field>
        </b-dropdown-item>
      </b-dropdown>
      <b-dropdown aria-role="menu" trap-focus class="regulatory-affairs-sort">
        <button class="button is-info is-outlined" slot="trigger">
          <span>Sort By</span>
        </button>
        <b-dropdown-item aria-role="menu-item" :focusable="false" custom>
          <b-field label="Line Errors">
            <b-select v-model="filterMapRALineErrors">
              <option value=""></option>
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </b-select>
          </b-field>
        </b-dropdown-item>
      </b-dropdown>
      <b-button
        type="is-info"
        outlined
        @click="
          checkRAFilterCriteria();
          canLoadRegulatoryAffairsData = {
            loadDetails: true,
            generalQuestionRows: rows,
            actions: {
              fErrors: filterMapRAErrors,
              fLineErrors: filterMapRALineErrors
            },
            paginationParams: {
              pageIndex: raPageIndex,
              numberOfRAItems: numberOfRAItems
            }
          };
        "
        class="item-level-apply-button"
      >
        Apply
      </b-button>
      <b-button
        type="is-info"
        outlined
        @click="
          filterMapRAErrors = '';
          filterMapRALineErrors = '';
          checkRAFilterCriteria();
          canLoadRegulatoryAffairsData = {
            loadDetails: true,
            generalQuestionRows: rows,
            actions: {
              fErrors: filterMapRAErrors,
              fLineErrors: filterMapRALineErrors
            },
            paginationParams: {
              pageIndex: raPageIndex,
              numberOfRAItems: numberOfRAItems
            }
          };
        "
        class="item-level-reset-button"
      >
        Reset
      </b-button>
      <b-button
        class="show-errors-btn"
        v-show="raTabErrorCount !== 0"
        type="is-danger"
        outlined
        @click="
          errorsModalProps.submissionId = submissionID;
          errorsModalProps.tab = 'RA';
          isViewUploadErrorsModalActive = true;
        "
        >Show Errors</b-button
      >
      <button
        v-show="loginRole === 3 || loginRole === 4 || loginRole === 5"
        class="button is-info float-right"
        @click="validateApproverAlert"
        :disabled="raTabErrorCount >= 0"
      >
        <span>Validate</span>
      </button>
    </div>
    <div
      class="regulatory-affairs-update-wrapper"
      v-show="
        showItemDetail &&
          activeTab === 3 &&
          submissionStatusIsActive &&
          (loginRole === 3 || loginRole === 4 || loginRole === 5)
      "
    >
      <b-dropdown aria-role="menu" trap-focus class="regulatory-affairs-update">
        <button class="button is-info is-outlined" slot="trigger">
          <span>Update Fields</span>
        </button>
        <b-dropdown-item aria-role="menu-item" :focusable="false" custom>
          <span
            >Please note that the existing control codes for items cannot be
            changed with this update</span
          >
          <b-field label="Control Code">
            <ValidationProvider
              rules="max:5"
              :bails="false"
              v-slot="{ classes }"
              immediate
            >
              <div class="control" :class="classes">
                <b-input
                  type="text"
                  oninput="this.value = this.value.replace(/[^\d]/g, '');"
                  v-model="updateRA.ctrlCode"
                ></b-input>
                <b-tooltip
                  label="Control Code maximum length is 5 characters"
                  type="is-danger"
                  position="is-top"
                >
                  <b-icon
                    type="is-danger"
                    icon="alert-circle"
                    v-show="updateRA.ctrlCode && updateRA.ctrlCode.length > 5"
                  >
                  </b-icon>
                </b-tooltip>
              </div>
            </ValidationProvider>
          </b-field>
          <b-field label="Safety Data Sheet Code">
            <b-select v-model="updateRA.msds">
              <option value="99998">
                99998
              </option>
              <option value="99999">
                99999
              </option>
              <option value="00000">
                00000
              </option>
            </b-select>
          </b-field>
          <b-field label="Bill Of Lading Code" v-show="loginRole === 3">
            <v-select
              :filterable="false"
              :options="bolOptions"
              class="bol"
              v-model="updateRA.bolCode"
              @search="fetchBolValues"
            >
              <template slot="option" slot-scope="bolOption">
                <div class="d-center">
                  {{ bolOption.label }}
                </div>
              </template>
              <template slot="selected-option" slot-scope="bolOption">
                <div class="selected d-center">
                  {{ bolOption.label }}
                </div>
              </template>
              <template slot="no-options" slot-scope="{ search, searching }">
                <template v-if="searching">
                  Sorry, no matching options.
                </template>
                <span v-else class="display-none"></span>
              </template>
            </v-select>
          </b-field>
        </b-dropdown-item>
      </b-dropdown>
      <b-button
        type="is-info"
        outlined
        @click="updateRA.ctrlCode.length <= 5 ? updateRAFields() : ''"
        class="item-level-apply-button"
      >
        Apply
      </b-button>
      <b-button
        type="is-info"
        outlined
        @click="resetRAUpdateFields()"
        class="item-level-reset-button"
      >
        Reset
      </b-button>
    </div>
    <div
      class="product-services-filter-wrapper"
      v-show="showItemDetail && activeTab === 4"
    >
      <b-dropdown aria-role="menu" trap-focus class="product-services-filter">
        <button class="button is-info is-outlined" slot="trigger">
          <span>Filter By</span>
        </button>
        <b-dropdown-item aria-role="menu-item" :focusable="false" custom>
          <b-field label="Errored Items">
            <b-select v-model="filterMapPSErrors">
              <option value=""></option>
              <option value="YES">YES</option>
              <option value="NO">NO</option>
            </b-select>
          </b-field>
        </b-dropdown-item>
      </b-dropdown>
      <b-dropdown aria-role="menu" trap-focus class="product-services-sort">
        <button class="button is-info is-outlined" slot="trigger">
          <span>Sort By</span>
        </button>
        <b-dropdown-item aria-role="menu-item" :focusable="false" custom>
          <b-field label="Line Errors">
            <b-select v-model="filterMapPSLineErrors">
              <option value=""></option>
              <option value="asc">Ascending</option>
              <option value="desc">Descending</option>
            </b-select>
          </b-field>
        </b-dropdown-item>
      </b-dropdown>
      <b-button
        type="is-info"
        outlined
        @click="
          checkPSFilterCriteria();
          canLoadProductServicesData = {
            loadDetails: true,
            generalQuestionRows: rows,
            actions: {
              fErrors: filterMapPSErrors,
              fLineErrors: filterMapPSLineErrors
            },
            paginationParams: {
              pageIndex: psPageIndex,
              numberOfPSItems: numberOfPSItems
            }
          };
        "
        class="item-level-apply-button"
      >
        Apply
      </b-button>
      <b-button
        type="is-info"
        outlined
        @click="
          filterMapPSErrors = '';
          filterMapPSLineErrors = '';
          checkPSFilterCriteria();
          canLoadProductServicesData = {
            loadDetails: true,
            generalQuestionRows: rows,
            actions: {
              fErrors: filterMapPSErrors,
              fLineErrors: filterMapPSLineErrors
            },
            paginationParams: {
              pageIndex: psPageIndex,
              numberOfPSItems: numberOfPSItems
            }
          };
        "
        class="item-level-reset-button"
      >
        Reset
      </b-button>
      <b-button
        class="show-errors-btn"
        v-show="psTabErrorCount !== 0"
        type="is-danger"
        outlined
        @click="
          errorsModalProps.submissionId = submissionID;
          errorsModalProps.tab = 'PS';
          isViewUploadErrorsModalActive = true;
        "
        >Show Errors</b-button
      >
      <button
        v-show="loginRole === 6"
        class="button is-info float-right"
        @click="validateApproverAlert"
        :disabled="psTabErrorCount >= 0"
      >
        <span>Validate</span>
      </button>
    </div>
    <!--  pagination wrapper for General Info  -->
    <div class="pagination-wrapper" v-if="showItemDetail && activeTab === 0">
      <div class="pagination-header">
        <b-button
          v-show="showPreviousButton"
          @click="
            pageIndex = pageIndex - 1;
            loadItemDetailsUnderSubmission();
          "
          >Previous</b-button
        >
        <b-button
          v-show="showFirstButton"
          @click="
            pageIndex = 1;
            loadItemDetailsUnderSubmission();
          "
          >First</b-button
        >
        <span class="page-index"
          >{{ minPageIndex }} to {{ maxPageIndex }} of {{ totalResults }}</span
        >
        <b-button
          v-show="showLastButton"
          @click="
            pageIndex = totalPages;
            loadItemDetailsUnderSubmission();
          "
          >Last</b-button
        >
        <b-button
          v-show="showNextButton"
          @click="
            pageIndex = pageIndex + 1;
            loadItemDetailsUnderSubmission();
          "
          >Next</b-button
        >
        <span class="page-navigator" v-show="totalResults > 10"
          ><span class="show-text">Show</span
          ><b-select
            class="page-display-number"
            v-model="numberOfGeneralQuestionItems"
            @input="
              pageIndex =
                Math.floor(minPageIndex / numberOfGeneralQuestionItems) + 1;
              loadItemDetailsUnderSubmission();
            "
            ><option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </b-select></span
        >
      </div>
    </div>
    <!-- pagination wrapper for Regulatory Info -->
    <div class="pagination-wrapper" v-if="showItemDetail && activeTab === 1">
      <div class="pagination-header">
        <b-button
          v-show="regulatoryShowPreviousButton"
          @click="
            regulatoryPageIndex = regulatoryPageIndex - 1;
            canLoadRegulatoryInformationData = {
              loadDetails: true,
              generalQuestionRows: rows,
              actions: {
                fErrors: filterMapRIErrors,
                fCategory: filterMapCategory,
                fProp65: filterMapProp65,
                fMedDevice: filterMapMedDevice,
                soField: sortMapRegulatoryField,
                soOrder: sortMapRegulatorySelectedOrder,
                srFieldName: searchMapRegulatoryField,
                srValue: searchMapRegulatoryInput
              },
              paginationParams: {
                pageIndex: regulatoryPageIndex,
                numberOfRegulatoryItems: numberOfRegulatoryItems
              }
            };
          "
          >Previous</b-button
        >
        <b-button
          v-show="regulatoryShowFirstButton"
          @click="
            regulatoryPageIndex = 1;
            canLoadRegulatoryInformationData = {
              loadDetails: true,
              generalQuestionRows: rows,
              actions: {
                fErrors: filterMapRIErrors,
                fCategory: filterMapCategory,
                fProp65: filterMapProp65,
                fMedDevice: filterMapMedDevice,
                soField: sortMapRegulatoryField,
                soOrder: sortMapRegulatorySelectedOrder,
                srFieldName: searchMapRegulatoryField,
                srValue: searchMapRegulatoryInput
              },
              paginationParams: {
                pageIndex: regulatoryPageIndex,
                numberOfRegulatoryItems: numberOfRegulatoryItems
              }
            };
          "
          >First</b-button
        >
        <span class="page-index"
          >{{ regulatoryMinPageIndex }} to {{ regulatoryMaxPageIndex }} of
          {{ regulatoryTotalResults }}</span
        >
        <b-button
          v-show="regulatoryShowLastButton"
          @click="
            regulatoryPageIndex = regulatoryTotalPages;
            canLoadRegulatoryInformationData = {
              loadDetails: true,
              generalQuestionRows: rows,
              actions: {
                fErrors: filterMapRIErrors,
                fCategory: filterMapCategory,
                fProp65: filterMapProp65,
                fMedDevice: filterMapMedDevice,
                soField: sortMapRegulatoryField,
                soOrder: sortMapRegulatorySelectedOrder,
                srFieldName: searchMapRegulatoryField,
                srValue: searchMapRegulatoryInput
              },
              paginationParams: {
                pageIndex: regulatoryPageIndex,
                numberOfRegulatoryItems: numberOfRegulatoryItems
              }
            };
          "
          >Last</b-button
        >
        <b-button
          v-show="regulatoryShowNextButton"
          @click="
            regulatoryPageIndex = regulatoryPageIndex + 1;
            canLoadRegulatoryInformationData = {
              loadDetails: true,
              generalQuestionRows: rows,
              actions: {
                fErrors: filterMapRIErrors,
                fCategory: filterMapCategory,
                fProp65: filterMapProp65,
                fMedDevice: filterMapMedDevice,
                soField: sortMapRegulatoryField,
                soOrder: sortMapRegulatorySelectedOrder,
                srFieldName: searchMapRegulatoryField,
                srValue: searchMapRegulatoryInput
              },
              paginationParams: {
                pageIndex: regulatoryPageIndex,
                numberOfRegulatoryItems: numberOfRegulatoryItems
              }
            };
          "
          >Next</b-button
        >
        <span class="page-navigator" v-show="regulatoryTotalResults > 10"
          ><span class="show-text">Show</span
          ><b-select
            class="page-display-number"
            v-model="numberOfRegulatoryItems"
            @input="
              regulatoryPageIndex =
                Math.floor(regulatoryMinPageIndex / numberOfRegulatoryItems) +
                1;
              canLoadRegulatoryInformationData = {
                loadDetails: true,
                generalQuestionRows: rows,
                actions: {
                  fErrors: filterMapRIErrors,
                  fCategory: filterMapCategory,
                  fProp65: filterMapProp65,
                  fMedDevice: filterMapMedDevice,
                  soField: sortMapRegulatoryField,
                  soOrder: sortMapRegulatorySelectedOrder,
                  srFieldName: searchMapRegulatoryField,
                  srValue: searchMapRegulatoryInput
                },
                paginationParams: {
                  pageIndex: regulatoryPageIndex,
                  numberOfRegulatoryItems: numberOfRegulatoryItems
                }
              };
            "
            ><option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </b-select></span
        >
      </div>
    </div>
    <!-- pagination wrapper for Portfolio Management -->
    <div class="pagination-wrapper" v-if="showItemDetail && activeTab === 2">
      <div class="pagination-header">
        <b-button
          v-show="pmShowPreviousButton"
          @click="
            pmPageIndex = pmPageIndex - 1;
            canLoadPortfolioManagementData = {
              loadDetails: true,
              generalQuestionRows: rows,
              actions: {
                fErrors: filterMapPMErrors,
                fLineErrors: filterMapPMLineErrors
              },
              paginationParams: {
                pageIndex: pmPageIndex,
                numberOfPMItems: numberOfPMItems
              }
            };
          "
          >Previous</b-button
        >
        <b-button
          v-show="pmShowFirstButton"
          @click="
            pmPageIndex = 1;
            canLoadPortfolioManagementData = {
              loadDetails: true,
              generalQuestionRows: rows,
              actions: {
                fErrors: filterMapPMErrors,
                fLineErrors: filterMapPMLineErrors
              },
              paginationParams: {
                pageIndex: pmPageIndex,
                numberOfPMItems: numberOfPMItems
              }
            };
          "
          >First</b-button
        >
        <span class="page-index"
          >{{ pmMinPageIndex }} to {{ pmMaxPageIndex }} of
          {{ pmTotalResults }}</span
        >
        <b-button
          v-show="pmShowLastButton"
          @click="
            pmPageIndex = pmTotalPages;
            canLoadPortfolioManagementData = {
              loadDetails: true,
              generalQuestionRows: rows,
              actions: {
                fErrors: filterMapPMErrors,
                fLineErrors: filterMapPMLineErrors
              },
              paginationParams: {
                pageIndex: pmPageIndex,
                numberOfPMItems: numberOfPMItems
              }
            };
          "
          >Last</b-button
        >
        <b-button
          v-show="pmShowNextButton"
          @click="
            pmPageIndex = pmPageIndex + 1;
            canLoadPortfolioManagementData = {
              loadDetails: true,
              generalQuestionRows: rows,
              actions: {
                fErrors: filterMapPMErrors,
                fLineErrors: filterMapPMLineErrors
              },
              paginationParams: {
                pageIndex: pmPageIndex,
                numberOfPMItems: numberOfPMItems
              }
            };
          "
          >Next</b-button
        >
        <span class="page-navigator" v-show="pmTotalResults > 10"
          ><span class="show-text">Show</span
          ><b-select
            class="page-display-number"
            v-model="numberOfPMItems"
            @input="
              pmPageIndex = Math.floor(pmMinPageIndex / numberOfPMItems) + 1;
              canLoadPortfolioManagementData = {
                loadDetails: true,
                generalQuestionRows: rows,
                actions: {
                  fErrors: filterMapPMErrors,
                  fLineErrors: filterMapPMLineErrors
                },
                paginationParams: {
                  pageIndex: pmPageIndex,
                  numberOfPMItems: numberOfPMItems
                }
              };
            "
            ><option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </b-select></span
        >
      </div>
    </div>
    <!-- pagination wrapper for Regulatory Affairs -->
    <div class="pagination-wrapper" v-if="showItemDetail && activeTab === 3">
      <div class="pagination-header">
        <b-button
          v-show="raShowPreviousButton"
          @click="
            raPageIndex = raPageIndex - 1;
            canLoadRegulatoryAffairsData = {
              loadDetails: true,
              generalQuestionRows: rows,
              actions: {
                fErrors: filterMapRAErrors,
                fLineErrors: filterMapRALineErrors
              },
              paginationParams: {
                pageIndex: raPageIndex,
                numberOfRAItems: numberOfRAItems
              }
            };
          "
          >Previous</b-button
        >
        <b-button
          v-show="raShowFirstButton"
          @click="
            raPageIndex = 1;
            canLoadRegulatoryAffairsData = {
              loadDetails: true,
              generalQuestionRows: rows,
              actions: {
                fErrors: filterMapRAErrors,
                fLineErrors: filterMapRALineErrors
              },
              paginationParams: {
                pageIndex: raPageIndex,
                numberOfRAItems: numberOfRAItems
              }
            };
          "
          >First</b-button
        >
        <span class="page-index"
          >{{ raMinPageIndex }} to {{ raMaxPageIndex }} of
          {{ raTotalResults }}</span
        >
        <b-button
          v-show="raShowLastButton"
          @click="
            raPageIndex = raTotalPages;
            canLoadRegulatoryAffairsData = {
              loadDetails: true,
              generalQuestionRows: rows,
              actions: {
                fErrors: filterMapRAErrors,
                fLineErrors: filterMapRALineErrors
              },
              paginationParams: {
                pageIndex: raPageIndex,
                numberOfRAItems: numberOfRAItems
              }
            };
          "
          >Last</b-button
        >
        <b-button
          v-show="raShowNextButton"
          @click="
            raPageIndex = raPageIndex + 1;
            canLoadRegulatoryAffairsData = {
              loadDetails: true,
              generalQuestionRows: rows,
              actions: {
                fErrors: filterMapRAErrors,
                fLineErrors: filterMapRALineErrors
              },
              paginationParams: {
                pageIndex: raPageIndex,
                numberOfRAItems: numberOfRAItems
              }
            };
          "
          >Next</b-button
        >
        <span class="page-navigator" v-show="raTotalResults > 10"
          ><span class="show-text">Show</span
          ><b-select
            class="page-display-number"
            v-model="numberOfRAItems"
            @input="
              raPageIndex = Math.floor(raMinPageIndex / numberOfRAItems) + 1;
              canLoadRegulatoryAffairsData = {
                loadDetails: true,
                generalQuestionRows: rows,
                actions: {
                  fErrors: filterMapRAErrors,
                  fLineErrors: filterMapRALineErrors
                },
                paginationParams: {
                  pageIndex: raPageIndex,
                  numberOfRAItems: numberOfRAItems
                }
              };
            "
            ><option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </b-select></span
        >
      </div>
    </div>
    <!-- pagination wrapper for Product Services -->
    <div class="pagination-wrapper" v-if="showItemDetail && activeTab === 4">
      <div class="pagination-header">
        <b-button
          v-show="psShowPreviousButton"
          @click="
            psPageIndex = psPageIndex - 1;
            canLoadProductServicesData = {
              loadDetails: true,
              generalQuestionRows: rows,
              actions: {
                fErrors: filterMapPSErrors,
                fLineErrors: filterMapPSLineErrors
              },
              paginationParams: {
                pageIndex: psPageIndex,
                numberOfPSItems: numberOfPSItems
              }
            };
          "
          >Previous</b-button
        >
        <b-button
          v-show="psShowFirstButton"
          @click="
            psPageIndex = 1;
            canLoadProductServicesData = {
              loadDetails: true,
              generalQuestionRows: rows,
              actions: {
                fErrors: filterMapPSErrors,
                fLineErrors: filterMapPSLineErrors
              },
              paginationParams: {
                pageIndex: psPageIndex,
                numberOfPSItems: numberOfPSItems
              }
            };
          "
          >First</b-button
        >
        <span class="page-index"
          >{{ psMinPageIndex }} to {{ psMaxPageIndex }} of
          {{ psTotalResults }}</span
        >
        <b-button
          v-show="psShowLastButton"
          @click="
            psPageIndex = psTotalPages;
            canLoadProductServicesData = {
              loadDetails: true,
              generalQuestionRows: rows,
              actions: {
                fErrors: filterMapPSErrors,
                fLineErrors: filterMapPSLineErrors
              },
              paginationParams: {
                pageIndex: psPageIndex,
                numberOfPSItems: numberOfPSItems
              }
            };
          "
          >Last</b-button
        >
        <b-button
          v-show="psShowNextButton"
          @click="
            psPageIndex = psPageIndex + 1;
            canLoadProductServicesData = {
              loadDetails: true,
              generalQuestionRows: rows,
              actions: {
                fErrors: filterMapPSErrors,
                fLineErrors: filterMapPSLineErrors
              },
              paginationParams: {
                pageIndex: psPageIndex,
                numberOfPSItems: numberOfPSItems
              }
            };
          "
          >Next</b-button
        >
        <span class="page-navigator" v-show="psTotalResults > 10"
          ><span class="show-text">Show</span
          ><b-select
            class="page-display-number"
            v-model="numberOfPSItems"
            @input="
              psPageIndex =
                Math.floor(psMinPageIndex / numberOfRegulatoryItems) + 1;
              canLoadProductServicesData = {
                loadDetails: true,
                generalQuestionRows: rows,
                actions: {
                  fErrors: filterMapPSErrors,
                  fLineErrors: filterMapPSLineErrors
                },
                paginationParams: {
                  pageIndex: psPageIndex,
                  numberOfPSItems: numberOfPSItems
                }
              };
            "
            ><option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </b-select></span
        >
      </div>
    </div>
    <section v-show="showItemDetail" class="tabs-wrapper">
      <b-tabs v-model="activeTab" type="is-toggle is-info" expanded>
        <b-tab-item
          label="General Information"
          class="ni-app-general-info-tab"
          :class="generalInformationEditAccess()"
        >
          <table id="ni-general-info-table">
            <thead>
              <tr>
                <th>Line No.</th>
                <th class="select-checkbox-cell">
                  <b-checkbox
                    :disabled="showSubmissionInReadOnly"
                    v-model="selectAllChecked"
                    type="is-info"
                    size="is-large"
                    title="Select All"
                  ></b-checkbox>
                </th>
                <th class="no-header-label" v-show="showCreateButtons"></th>
                <th
                  v-for="columnData in generalInfoFields.generalInfoColumns"
                  :key="columnData.id"
                >
                  <label :class="columnData.className" :title="columnData.title"
                    >{{ columnData.label }}
                    <div v-if="columnData.subLabel">
                      <a @click="cooCodes()">{{ columnData.subLabel }}</a>
                    </div></label
                  >
                </th>
              </tr>
            </thead>
            <tbody class="ni-app-general-info-tbody">
              <tr
                v-for="(row, index) in rows"
                :key="row.id"
                :class="[row.genlQstnId ? 'row-' + row.genlQstnId : 'newRow']"
                @click="onRowClick($event)"
                @change="!isLoading ? changeOnRow($event, index, row) : ''"
              >
                <ValidationObserver>
                  <td class="line-number">{{ row.lineNumber }}</td>
                  <td class="select-checkbox-cell">
                    <b-checkbox
                      :disabled="showSubmissionInReadOnly"
                      type="is-info"
                      size="is-large"
                      v-model="checkboxGroup"
                      :native-value="row.genlQstnId"
                    ></b-checkbox>
                  </td>
                  <td
                    class="copy-item-option-cell"
                    :value="row"
                    v-show="showCreateButtons"
                  >
                    <b-button
                      type="is-info"
                      title="Copy Item"
                      :disabled="showSubmissionInReadOnly"
                      @click="copySelectedItemToSubmission(row)"
                      outlined
                      >Copy</b-button
                    >
                  </td>
                  <td class="line-errors">{{ row.lineErrors }}</td>
                  <td>
                    <ValidationProvider
                      rules="required"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div
                        class="control"
                        :class="[
                          classes,
                          vcatRequired && tooltipIndex === index
                            ? 'top-minus-25'
                            : ''
                        ]"
                      >
                        <b-tooltip
                          class="vcat-tooltip"
                          v-show="vcatRequired && tooltipIndex === index"
                          label="Supplier Catalog Number is required to save this record"
                          always
                          position="is-top"
                          type="is-danger"
                          multilined
                        >
                        </b-tooltip>
                        <b-input
                          type="text"
                          class="vcat"
                          oninput="this.value = this.value.replace(/[^a-zA-Z0-9 ./\\\\-]/g, '');if (this.value.length > 25)
                        this.value = this.value.slice(0, 25);"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'vcat',
                              row.vcat
                            )
                          "
                          :value="row.vcat"
                          @change.native="row.vcat = $event.target.value"
                        >
                        </b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required|max:30"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          class="desc30"
                          oninput="this.value = this.value.replace(/[^a-zA-Z0-9 ./\\\\-]/g, '');"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'desc30',
                              row.desc30
                            )
                          "
                          :value="row.desc30"
                          @change.native="row.desc30 = $event.target.value"
                        ></b-input>
                        <b-tooltip
                          label="Item Description 30 maximum length is 30 characters in order to save this record"
                          type="is-danger"
                          position="is-top"
                        >
                          <b-icon
                            type="is-danger"
                            icon="alert-circle"
                            v-show="row.desc30 && row.desc30.length > 30"
                          >
                          </b-icon>
                        </b-tooltip>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-tooltip
                          :label="row.desc240 ? row.desc240 : ''"
                          type="is-light"
                          position="is-bottom"
                        >
                          <b-input
                            type="text"
                            class="desc240"
                            oninput="this.value = this.value.replace(/[^a-zA-Z0-9 .%/\\\\\)\(\]\[-]/g, ''); if (this.value.length > 240)
                          this.value = this.value.slice(0, 240);"
                            v-bind:class="
                              isApiErrorField(
                                row.psfsNewItemGenlQstnErrTbs,
                                'desc240',
                                row.desc240
                              )
                            "
                            :value="row.desc240"
                            @change.native="row.desc240 = $event.target.value"
                          ></b-input>
                        </b-tooltip>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      v-if="isUser3PGQtab"
                      rules="required"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          class="desc1000"
                          oninput="this.value = this.value.replace(/[^a-zA-Z0-9 .%/\\\\\)\(\]\[-]/g, ''); if (this.value.length > 1000)
                          this.value = this.value.slice(0, 1000);"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'desc1000',
                              row.desc1000
                            )
                          "
                          :value="row.desc1000"
                          @change.native="row.desc1000 = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                    <b-input
                      v-else
                      type="text"
                      class="desc1000"
                      oninput="this.value = this.value.replace(/[^a-zA-Z0-9 .%/\\\\\)\(\]\[-]/g, ''); if (this.value.length > 1000)
                          this.value = this.value.slice(0, 1000);"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'desc1000',
                          row.desc1000
                        )
                      "
                      :value="row.desc1000"
                      @change.native="row.desc1000 = $event.target.value"
                    ></b-input>
                  </td>
                  <td>
                    <b-input
                      type="text"
                      class="brand"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'brand',
                          row.brand
                        )
                      "
                      :value="row.brand"
                      @change.native="row.brand = $event.target.value"
                    ></b-input>
                  </td>
                  <td>
                    <ValidationProvider
                      v-if="isUser3PGQtab"
                      rules="max:11"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          class="key1"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'key1',
                              row.key1
                            )
                          "
                          :value="row.key1"
                          @change.native="row.key1 = $event.target.value"
                        ></b-input>
                        <b-tooltip
                          label="Keyword 1 maximum length is 11 characters in order to save this record"
                          type="is-danger"
                          position="is-top"
                        >
                          <b-icon
                            type="is-danger"
                            icon="alert-circle"
                            v-show="row.key1 && row.key1.length > 11"
                          >
                          </b-icon>
                        </b-tooltip>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      v-else
                      rules="required|max:11"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          class="key1"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'key1',
                              row.key1
                            )
                          "
                          :value="row.key1"
                          @change.native="row.key1 = $event.target.value"
                        ></b-input>
                        <b-tooltip
                          label="Keyword 1 maximum length is 11 characters in order to save this record"
                          type="is-danger"
                          position="is-top"
                        >
                          <b-icon
                            type="is-danger"
                            icon="alert-circle"
                            v-show="row.key1 && row.key1.length > 11"
                          >
                          </b-icon>
                        </b-tooltip>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="max:11"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          class="key2"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'key2',
                              row.key2
                            )
                          "
                          :value="row.key2"
                          @change.native="row.key2 = $event.target.value"
                        ></b-input>
                        <b-tooltip
                          label="Keyword 2 maximum length is 11 characters in order to save this record"
                          type="is-danger"
                          position="is-top"
                        >
                          <b-icon
                            type="is-danger"
                            icon="alert-circle"
                            v-show="row.key2 && row.key2.length > 11"
                          >
                          </b-icon>
                        </b-tooltip>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="max:11"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          class="key3"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'key3',
                              row.key3
                            )
                          "
                          :value="row.key3"
                          @change.native="row.key3 = $event.target.value"
                        ></b-input>
                        <b-tooltip
                          label="Keyword 3 maximum length is 11 characters in order to save this record"
                          type="is-danger"
                          position="is-top"
                        >
                          <b-icon
                            type="is-danger"
                            icon="alert-circle"
                            v-show="row.key3 && row.key3.length > 11"
                          >
                          </b-icon>
                        </b-tooltip>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="max:11"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          class="key4"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'key4',
                              row.key4
                            )
                          "
                          :value="row.key4"
                          @change.native="row.key4 = $event.target.value"
                        ></b-input>
                        <b-tooltip
                          label="Keyword 4 maximum length is 11 characters in order to save this record"
                          type="is-danger"
                          position="is-top"
                        >
                          <b-icon
                            type="is-danger"
                            icon="alert-circle"
                            v-show="row.key4 && row.key4.length > 11"
                          >
                          </b-icon>
                        </b-tooltip>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="max:11"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          class="key5"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'key5',
                              row.key5
                            )
                          "
                          :value="row.key5"
                          @change.native="row.key5 = $event.target.value"
                        ></b-input>
                        <b-tooltip
                          label="Keyword 5 maximum length is 11 characters in order to save this record"
                          type="is-danger"
                          position="is-top"
                        >
                          <b-icon
                            type="is-danger"
                            icon="alert-circle"
                            v-show="row.key5 && row.key5.length > 11"
                          >
                          </b-icon>
                        </b-tooltip>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <a
                      v-if="row.imageAttachmentName"
                      class="imageAttachment has-text-info"
                    >
                      <span
                        :title="'Download ' + row.imageAttachmentName"
                        class="attachment-title download-image-attachment"
                        @click="
                          downloadImageAttachment(
                            row.imageAttachmentName,
                            row.genlQstnId
                          )
                        "
                        >{{ row.imageAttachmentName }} </span
                      >&nbsp;&nbsp;&nbsp;<a
                        @click="deleteImageAttachment(row.genlQstnId)"
                        class="delete-attachment"
                        title="Delete Image Attachment"
                      >
                        <b-icon icon="delete" type="is-info" size="is-small">
                        </b-icon
                      ></a>
                    </a>
                    <b-upload
                      v-else
                      @input="
                        uploadImageAttachment(imageAttachment, row.genlQstnId)
                      "
                      class="imageAttachment upload upload-attachment"
                      v-model="imageAttachment"
                    >
                      <a class="button">
                        <span>Upload</span>
                      </a>
                    </b-upload>
                  </td>
                  <td>
                    <b-input
                      v-if="
                        validateErrorObj.validateValue === 'Y' &&
                          row.psfsNewItemGenlQstnErrTbs &&
                          row.psfsNewItemGenlQstnErrTbs.length === 0
                      "
                      type="text"
                      class="manufacturerName"
                      oninput="if (this.value.length > 50)
                          this.value = this.value.slice(0, 50);"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'manufacturerName',
                          row.manufacturerName
                        )
                      "
                      :value="row.manufacturerName"
                      @change.native="
                        row.manufacturerName = $event.target.value
                      "
                    >
                    </b-input>
                    <ValidationProvider
                      v-else-if="
                        validateErrorObj.validateValue === 'N' ||
                          (validateErrorObj.validateValue === 'Y' &&
                            row.psfsNewItemGenlQstnErrTbs &&
                            row.psfsNewItemGenlQstnErrTbs.length > 0)
                      "
                      rules="required"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          class="manufacturerName"
                          oninput="if (this.value.length > 50)
                          this.value = this.value.slice(0, 50);"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'manufacturerName',
                              row.manufacturerName
                            )
                          "
                          :value="row.manufacturerName"
                          @change.native="
                            row.manufacturerName = $event.target.value
                          "
                        >
                        </b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <b-input
                      v-if="
                        validateErrorObj.validateValue === 'Y' &&
                          row.psfsNewItemGenlQstnErrTbs &&
                          row.psfsNewItemGenlQstnErrTbs.length === 0
                      "
                      type="text"
                      class="mcat"
                      oninput="if (this.value.length > 25)
                          this.value = this.value.slice(0, 25);"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'mcat',
                          row.mcat
                        )
                      "
                      :value="row.mcat"
                      @change.native="row.mcat = $event.target.value"
                    ></b-input>
                    <ValidationProvider
                      v-else-if="
                        validateErrorObj.validateValue === 'N' ||
                          (validateErrorObj.validateValue === 'Y' &&
                            row.psfsNewItemGenlQstnErrTbs &&
                            row.psfsNewItemGenlQstnErrTbs.length > 0)
                      "
                      rules="required"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          class="mcat"
                          oninput="if (this.value.length > 25)
                          this.value = this.value.slice(0, 25);"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'mcat',
                              row.mcat
                            )
                          "
                          :value="row.mcat"
                          @change.native="row.mcat = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required|min_value:1"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value.replace(/[^0-9]/g, ''); if (this.value.length > 4)
                          this.value = this.value.slice(0, 4);"
                          class="mfgLeadTime"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'mfgLeadTime',
                              row.mfgLeadTime
                            )
                          "
                          :value="row.mfgLeadTime"
                          @change.native="row.mfgLeadTime = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="oneOf:EA,PR,DZ,PK,CS"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                      vid="su"
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="su"
                          v-model="row.su"
                          @input="updateSuDependentValues(row)"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'su',
                              row.su
                            )
                          "
                          :value="
                            row.su === undefined ? (row.su = ' ') : row.su
                          "
                        >
                          <option value=" "></option
                          ><option value="EA">Each</option
                          ><option value="PR">Pair</option
                          ><option value="DZ">Dozen</option
                          ><option value="PK">Pack</option
                          ><option value="CS">Case</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      :rules="{
                        required: true,
                        checkValidBasedOnSu: { suVal: '@su' },
                        min_value: 1
                      }"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          :disabled="disableBasedOnSu(row.su)"
                          oninput="this.value = this.value.replace(/[^\d.]/g, '')
                        .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.length > 9)
                          this.value = this.value.slice(0, 9);"
                          class="suQty"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'suQty',
                              row.suQty
                            )
                          "
                          :value="row.suQty"
                          @change.native="row.suQty = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="oneOf:EA,PR"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="unitUse"
                          :disabled="row.su === 'EA' || row.su === 'PR'"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'unitUse',
                              row.unitUse
                            )
                          "
                          v-model="row.unitUse"
                          :value="
                            row.unitUse === undefined
                              ? (row.unitUse = ' ')
                              : row.unitUse
                          "
                        >
                          <option value=" "></option>
                          <option value="EA">Each</option>
                          <option value="PR">Pair</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required|min_value:0.01"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');  if (this.value.split('.')[0].length > 5)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 5) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 5);"
                          class="suWt"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'suWt',
                              row.suWt
                            )
                          "
                          :disabled="isUser3PGQtab"
                          :value="
                            row.suWt !== undefined
                              ? addTwoZeros(row.suWt)
                              : row.suWt
                          "
                          @change.native="row.suWt = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required|min_value:0.01"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');  if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3);"
                          class="suLen"
                          :disabled="isUser3PGQtab"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'suLen',
                              row.suLen
                            )
                          "
                          :value="
                            row.suLen !== undefined
                              ? addTwoZeros(row.suLen)
                              : row.suLen
                          "
                          @change.native="row.suLen = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required|min_value:0.01"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3); "
                          class="suWid"
                          :disabled="isUser3PGQtab"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'suWid',
                              row.suWid
                            )
                          "
                          :value="
                            row.suWid !== undefined
                              ? addTwoZeros(row.suWid)
                              : row.suWid
                          "
                          @change.native="row.suWid = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required|min_value:0.01"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3);"
                          class="suHt"
                          :disabled="isUser3PGQtab"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'suHt',
                              row.suHt
                            )
                          "
                          :value="
                            row.suHt !== undefined
                              ? addTwoZeros(row.suHt)
                              : row.suHt
                          "
                          @change.native="row.suHt = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      v-if="row.category === 'Chemicals'"
                      rules="required"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                      vid="pkgSzQty"
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 6)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 6) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 6);"
                          class="pkgSzQty"
                          v-bind:class="[
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'pkgSzQty',
                              row.pkgSzQty
                            ),
                            isFieldEditable(row)
                          ]"
                          :value="
                            row.pkgSzQty !== undefined
                              ? addTwoZeros(row.pkgSzQty)
                              : row.pkgSzQty
                          "
                          @change.native="row.pkgSzQty = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      v-else
                      immediate
                      vid="pkgSzQty"
                      v-slot="{ classes }"
                      rules="required_if:pkgSzUnt"
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value.replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 6)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 6) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 6);"
                          class="pkgSzQty"
                          v-bind:class="[
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'pkgSzQty',
                              row.pkgSzQty
                            ),
                            isFieldEditable(row)
                          ]"
                          :value="
                            row.pkgSzQty !== undefined
                              ? addTwoZeros(row.pkgSzQty)
                              : row.pkgSzQty
                          "
                          @change.native="row.pkgSzQty = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      v-if="row.category === 'Chemicals'"
                      rules="oneOf:IN,FT,YD,UM,MM,CM,MT,OZ,PT,QT,GL,UL,ML,LT,DO,LB,GT,UG,MG,GR,KG,PP,RN,TS,MU,UN,KU,UC,MC,CI"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                      vid="pkgSzUnt"
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="pkgSzUnt"
                          v-model="row.pkgSzUnt"
                          v-bind:class="[
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'pkgSzUnt',
                              row.pkgSzUnt
                            ),
                            isFieldEditable(row)
                          ]"
                          :value="
                            row.pkgSzUnt === undefined
                              ? (row.pkgSzUnt = ' ')
                              : row.pkgSzUnt
                          "
                        >
                          <option value=" "></option
                          ><option value="IN">IN - Inches</option>
                          <option value="FT">FT - Feet</option>
                          <option value="YD">YD - Yards</option>
                          <option value="UM">UM - Micrometer</option>
                          <option value="MM">MM - Millimeters</option>
                          <option value="CM">CM - Centimeters</option>
                          <option value="MT">MT - Meters</option>
                          <option value="OZ">OZ - Ounce (Liquid)</option>
                          <option value="PT">PT - Pint</option>
                          <option value="QT">QT - Quart</option>
                          <option value="GL">GL - Gallon</option>
                          <option value="UL">UL - Microliter</option>
                          <option value="ML">ML - MilliLiter</option>
                          <option value="LT">LT - Liter</option>
                          <option value="DO">DO - Ounce (Dry)</option>
                          <option value="LB">LB - Pounds</option>
                          <option value="GT">GT - Metric Gross Ton</option>
                          <option value="UG">UG - Microgram</option>
                          <option value="MG">MG - Milligram</option>
                          <option value="GR">GR - Gram</option>
                          <option value="KG">KG - Kilogram</option>
                          <option value="PP">PP - Prep</option>
                          <option value="RN">RN - Reaction</option>
                          <option value="TS">TS - Test</option>
                          <option value="MU">MU - Milliunit</option>
                          <option value="UN">UN - Unit</option>
                          <option value="KU">KU - Kilounit</option>
                          <option value="UC">UC - Microcurie</option>
                          <option value="MC">MC - Millicurie</option>
                          <option value="CI">CI - Curie</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      v-else
                      immediate
                      vid="pkgSzUnt"
                      v-slot="{ classes }"
                      rules="required_if:pkgSzQty"
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="pkgSzUnt"
                          v-model="row.pkgSzUnt"
                          v-bind:class="[
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'pkgSzUnt',
                              row.pkgSzUnt
                            ),
                            isFieldEditable(row)
                          ]"
                          :value="
                            row.pkgSzUnt === undefined
                              ? (row.pkgSzUnt = ' ')
                              : row.pkgSzUnt
                          "
                        >
                          <option value=" "></option
                          ><option value="IN">IN - Inches</option>
                          <option value="FT">FT - Feet</option>
                          <option value="YD">YD - Yards</option>
                          <option value="UM">UM - Micrometer</option>
                          <option value="MM">MM - Millimeters</option>
                          <option value="CM">CM - Centimeters</option>
                          <option value="MT">MT - Meters</option>
                          <option value="OZ">OZ - Ounce (Liquid)</option>
                          <option value="PT">PT - Pint</option>
                          <option value="QT">QT - Quart</option>
                          <option value="GL">GL - Gallon</option>
                          <option value="UL">UL - Microliter</option>
                          <option value="ML">ML - MilliLiter</option>
                          <option value="LT">LT - Liter</option>
                          <option value="DO">DO - Ounce (Dry)</option>
                          <option value="LB">LB - Pounds</option>
                          <option value="GT">GT - Metric Gross Ton</option>
                          <option value="UG">UG - Microgram</option>
                          <option value="MG">MG - Milligram</option>
                          <option value="GR">GR - Gram</option>
                          <option value="KG">KG - Kilogram</option>
                          <option value="PP">PP - Prep</option>
                          <option value="RN">RN - Reaction</option>
                          <option value="TS">TS - Test</option>
                          <option value="MU">MU - Milliunit</option>
                          <option value="UN">UN - Unit</option>
                          <option value="KU">KU - Kilounit</option>
                          <option value="UC">UC - Microcurie</option>
                          <option value="MC">MC - Millicurie</option>
                          <option value="CI">CI - Curie</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <b-select
                      class="suppUom"
                      v-model="row.suppUom"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'suppUom',
                          row.suppUom
                        )
                      "
                      :value="
                        row.suppUom === undefined
                          ? (row.suppUom = ' ')
                          : row.suppUom
                      "
                    >
                      <option value=" "></option
                      ><option value="CS">Case</option>
                      <option value="EA">Each</option>
                      <option value="PK">Pack</option>
                      <option value="PR">Pair</option>
                      <option value="NA">NA</option>
                    </b-select>
                  </td>
                  <td>
                    <ValidationProvider
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value.replace(/[^0-9]/g, ''); if (this.value.length > 4)
                          this.value = this.value.slice(0, 4);"
                          class="suppConv"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'suppConv',
                              row.suppConv
                            )
                          "
                          :value="row.suppConv"
                          @change.native="row.suppConv = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      :rules="{ valOfAu: { suVal: '@su' } }"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                      vid="au"
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="au"
                          @input="updateAuDependentValues(row)"
                          :disabled="row.su === 'CS'"
                          v-model="row.au"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'au',
                              row.au
                            )
                          "
                          :value="
                            row.au === undefined ? (row.au = ' ') : row.au
                          "
                        >
                          <option value=" "></option
                          ><option value="DZ">Dozen</option>
                          <option value="PK">Pack</option>
                          <option value="CS">Case</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:au,DZ,PK,CS"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value.replace(/[^0-9]/g, ''); if (this.value.length > 10)
                          this.value = this.value.slice(0, 10);"
                          class="auQty"
                          :disabled="disableAuQtyIf(row.su, row.au)"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'auQty',
                              row.auQty
                            )
                          "
                          :value="row.auQty"
                          @change.native="row.auQty = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      name="field"
                      rules="required_if:au,DZ,PK,CS"
                      :bails="false"
                      v-slot="{
                        classes
                      }"
                      immediate
                      ><div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 5)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 5) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 5);"
                          class="auWt"
                          :disabled="
                            row.su === 'CS' ||
                              row.au === '' ||
                              row.au === ' ' ||
                              row.au === undefined
                          "
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'auWt',
                              row.auWt
                            )
                          "
                          :value="
                            row.auWt !== undefined
                              ? addTwoZeros(row.auWt)
                              : row.auWt
                          "
                          @change.native="row.auWt = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      name="field"
                      rules="required_if:au,DZ,PK,CS"
                      :bails="false"
                      v-slot="{
                        classes
                      }"
                      immediate
                      ><div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3); "
                          class="auLen"
                          :disabled="
                            row.su === 'CS' ||
                              row.au === '' ||
                              row.au === ' ' ||
                              row.au === undefined
                          "
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'auLen',
                              row.auLen
                            )
                          "
                          :value="
                            row.auLen !== undefined
                              ? addTwoZeros(row.auLen)
                              : row.auLen
                          "
                          @change.native="row.auLen = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      name="field"
                      rules="required_if:au,DZ,PK,CS"
                      :bails="false"
                      v-slot="{
                        classes
                      }"
                      immediate
                      ><div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3); "
                          class="auWid"
                          :disabled="
                            row.su === 'CS' ||
                              row.au === '' ||
                              row.au === ' ' ||
                              row.au === undefined
                          "
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'auWid',
                              row.auWid
                            )
                          "
                          :value="
                            row.auWid !== undefined
                              ? addTwoZeros(row.auWid)
                              : row.auWid
                          "
                          @change.native="row.auWid = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      name="field"
                      rules="required_if:au,DZ,PK,CS"
                      :bails="false"
                      v-slot="{
                        classes
                      }"
                      immediate
                      ><div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 3)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 3) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 3);"
                          class="auHt"
                          :disabled="
                            row.su === 'CS' ||
                              row.au === '' ||
                              row.au === ' ' ||
                              row.au === undefined
                          "
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'auHt',
                              row.auHt
                            )
                          "
                          :value="
                            row.auHt !== undefined
                              ? addTwoZeros(row.auHt)
                              : row.auHt
                          "
                          @change.native="row.auHt = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required|min_value:0.0001"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          @input="calculateDiscount(row)"
                          oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{4})./g, '$1'); if (this.value.split('.')[0].length > 7)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 7) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 7);"
                          class="suCost"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'suCost',
                              row.suCost
                            )
                          "
                          :value="
                            row.suCost !== undefined
                              ? addFourZeros(row.suCost)
                              : row.suCost
                          "
                          @change.native="row.suCost = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required|min_value:0.01"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          @input="calculateDiscount(row)"
                          oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 7)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 7) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 7);"
                          class="suList"
                          v-bind:class="[
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'suList',
                              row.suList
                            ),
                            isSuListValueValid(row)
                          ]"
                          :value="
                            row.suList !== undefined
                              ? addTwoZeros(row.suList)
                              : row.suList
                          "
                          @change.native="row.suList = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:au,DZ,PK,CS"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1'); if (this.value.split('.')[0].length > 7)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 7) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 7);"
                          class="auList"
                          :disabled="
                            row.su === 'CS' ||
                              row.au === '' ||
                              row.au === ' ' ||
                              row.au === undefined
                          "
                          v-bind:class="[
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'auList',
                              row.auList
                            ),
                            isAuListValueValid(row)
                          ]"
                          :value="
                            row.auList !== undefined
                              ? addTwoZeros(row.auList)
                              : row.auList
                          "
                          @change.native="row.auList = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider :bails="false" v-slot="{ classes }">
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');"
                          class="discnt"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'discnt',
                              row.discnt
                            )
                          "
                          :value="
                            row.discnt !== undefined
                              ? addPercentMode(row.discnt)
                              : row.discnt
                          "
                          @change.native="row.discnt = $event.target.value"
                          disabled="disabled"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-datepicker
                          placeholder="Select a date..."
                          icon="calendar-today"
                          class="ncExpDt"
                          :min-date="minNcExpDt"
                          v-model="row.ncExpDt"
                          @input="changeOnRow($event, index, row)"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'ncExpDt',
                              row.ncExpDt
                            )
                          "
                        >
                        </b-datepicker>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                      vid="custSpecific"
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="custSpecific"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'custSpecific',
                              row.custSpecific
                            )
                          "
                          v-model="row.custSpecific"
                          :value="
                            row.custSpecific === undefined
                              ? (row.custSpecific = ' ')
                              : row.custSpecific
                          "
                        >
                          <option value=" "></option>
                          <option value="Y">Yes</option>
                          <option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:custSpecific,Y"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          class="custSpecificName"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'custSpecificName',
                              row.custSpecificName
                            )
                          "
                          :value="row.custSpecificName"
                          @change.native="
                            row.custSpecificName = $event.target.value
                          "
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:custSpecific,Y"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                          class="custSpecificAcct"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'custSpecificAcct',
                              row.custSpecificAcct
                            )
                          "
                          :value="row.custSpecificAcct"
                          @change.native="
                            row.custSpecificAcct = $event.target.value
                          "
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <b-select
                      class="insideDelivery"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'insideDelivery',
                          row.insideDelivery
                        )
                      "
                      v-model="row.insideDelivery"
                      :value="
                        row.insideDelivery === undefined
                          ? (row.insideDelivery = ' ')
                          : row.insideDelivery
                      "
                    >
                      <option value=" "></option>
                      <option value="Y">Yes</option>
                      <option value="N">No</option>
                    </b-select>
                  </td>
                  <td>
                    <b-input
                      type="text"
                      oninput="this.value = this.value.replace(/[^0-9]/g, ''); if (this.value.length > 8)
                          this.value = this.value.slice(0, 8);;"
                      class="unspsc"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'unspsc',
                          row.unspsc
                        )
                      "
                      :value="row.unspsc"
                      @change.native="row.unspsc = $event.target.value"
                    ></b-input>
                  </td>
                  <td>
                    <ValidationProvider
                      :rules="{ required: isUser3PGQtab ? false : true }"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <v-select
                          :filterable="false"
                          :options="countryOriginOptions"
                          class="countryOrigin"
                          v-model="row.countryOrigin"
                          @search="fetchCountryOrigin"
                          @input="changeOnRow($event, index, row)"
                          :disabled="loginRole === 3"
                          :title="row.countryOrigin"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'countryOrigin',
                              row.countryOrigin
                            )
                          "
                        >
                          <template
                            slot="option"
                            slot-scope="countryOriginOption"
                          >
                            <div class="d-center">
                              {{ countryOriginOption.label }}
                            </div>
                          </template>
                          <template
                            slot="selected-option"
                            slot-scope="countryOriginOption"
                            title="countryOriginOption"
                          >
                            <div class="selected d-center">
                              {{ countryOriginOption.label }}
                            </div>
                          </template>
                          <template
                            slot="no-options"
                            slot-scope="{ search, searching }"
                          >
                            <template v-if="searching">
                              Sorry, no matching options.
                            </template>
                            <span v-else class="display-none"></span>
                          </template>
                        </v-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="oneOf:Y,N"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                      vid="haz"
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="haz"
                          v-model="row.haz"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'haz',
                              row.haz
                            )
                          "
                          :value="
                            row.haz === undefined ? (row.haz = ' ') : row.haz
                          "
                        >
                          <option value=" "></option
                          ><option value="Y">Yes</option
                          ><option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:haz,Y"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                          class="unNa"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'unNa',
                              row.unNa
                            )
                          "
                          :value="row.unNa"
                          @change.native="row.unNa = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:haz,Y"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                          class="hazcls"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'hazcls',
                              row.hazcls
                            )
                          "
                          :value="row.hazcls"
                          @change.native="row.hazcls = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:haz,Y"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          class="psn"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'psn',
                              row.psn
                            )
                          "
                          :value="row.psn"
                          @change.native="row.psn = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      :rules="{ valOfPackgrp: { hazVal: '@haz' } }"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="packgrp"
                          v-model="row.packgrp"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'packgrp',
                              row.packgrp
                            )
                          "
                          :value="
                            row.packgrp === undefined
                              ? (row.packgrp = ' ')
                              : row.packgrp
                          "
                        >
                          <option value=" "></option>
                          <option value="I">I</option>
                          <option value="II">II</option>
                          <option value="III">III</option>
                          <option value="None">None</option>
                          <option value="NA">NA</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <b-input
                      type="text"
                      class="hibc"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'hibc',
                          row.hibc
                        )
                      "
                      :value="row.hibc"
                      @change.native="row.hibc = $event.target.value"
                    ></b-input>
                  </td>
                  <td>
                    <b-input
                      v-if="isUser3PGQtab"
                      type="text"
                      class="ti text-align-right"
                      oninput="this.value = this.value.replace(/[^0-9]/g, '');if (this.value.length > 5)
                        this.value = this.value.slice(0, 5);"
                      :value="row.ti"
                      @change.native="row.ti = $event.target.value"
                    ></b-input>
                    <ValidationProvider
                      v-else
                      rules="required"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          class="ti text-align-right"
                          oninput="this.value = this.value.replace(/[^0-9]/g, '');if (this.value.length > 5)
                        this.value = this.value.slice(0, 5);"
                          :value="row.ti"
                          @change.native="row.ti = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <b-input
                      v-if="isUser3PGQtab"
                      type="text"
                      class="hi text-align-right"
                      oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                      :value="row.hi"
                      @change.native="row.hi = $event.target.value"
                    ></b-input>
                    <ValidationProvider
                      v-else
                      rules="required"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          class="hi text-align-right"
                          oninput="this.value = this.value.replace(/[^0-9]/g, '')"
                          :value="row.hi"
                          @change.native="row.hi = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <b-select
                      v-if="isUser3PGQtab"
                      class="buildStockOrder"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'buildStockOrder',
                          row.buildStockOrder
                        )
                      "
                      v-model="row.buildStockOrder"
                      :value="
                        row.buildStockOrder === undefined
                          ? (row.buildStockOrder = ' ')
                          : row.buildStockOrder
                      "
                    >
                      <option value=" "></option
                      ><option value="Build to Stock">Build to Stock</option
                      ><option value="Build to Order">Build to Order</option>
                      <option value="NA">NA</option>
                    </b-select>
                    <ValidationProvider
                      v-else
                      rules="oneOf:Build to Stock,Build to Order,NA"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="buildStockOrder"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'buildStockOrder',
                              row.buildStockOrder
                            )
                          "
                          v-model="row.buildStockOrder"
                          :value="
                            row.buildStockOrder === undefined
                              ? (row.buildStockOrder = ' ')
                              : row.buildStockOrder
                          "
                        >
                          <option value=" "></option
                          ><option value="Build to Stock">Build to Stock</option
                          ><option value="Build to Order"
                            >Build to Order</option
                          >
                          <option value="NA">NA</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="oneOf:S,L,NA"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                      vid="serLot"
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="serLot"
                          @input="updateShlfLf(row)"
                          v-model="row.serLot"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'serLot',
                              row.serLot
                            )
                          "
                          :value="
                            row.serLot === undefined
                              ? (row.serLot = ' ')
                              : row.serLot
                          "
                        >
                          <option value=" "></option
                          ><option value="S">Serial</option
                          ><option value="L">Lot</option>
                          <option value="NA">NA</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      v-if="isUser3PGQtab"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                      vid="shlfLf"
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="shlfLf"
                          v-model="row.shlfLf"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'shlfLf',
                              row.shlfLf
                            )
                          "
                          :value="
                            row.shlfLf === undefined
                              ? (row.shlfLf = ' ')
                              : row.shlfLf
                          "
                        >
                          <option value=" "></option
                          ><option value="Y">Yes</option
                          ><option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      v-else
                      rules="oneOf:Y,N"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                      vid="shlfLf"
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="shlfLf"
                          v-model="row.shlfLf"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'shlfLf',
                              row.shlfLf
                            )
                          "
                          :value="
                            row.shlfLf === undefined
                              ? (row.shlfLf = ' ')
                              : row.shlfLf
                          "
                        >
                          <option value=" "></option
                          ><option value="Y">Yes</option
                          ><option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:shlfLf,Y|max_value:3650"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value.replace(/[^0-9]/g, ''); if(this.value > 3650) this.value = 3650; this.value === '' ? '' : this.value = +this.value"
                          class="shlfLfNum"
                          v-bind:class="[
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'shlfLfNum',
                              row.shlfLfNum
                            ),
                            row.shlfLfNum === 0 || row.shlfLfNum < row.srcRcv
                              ? 'is-danger'
                              : ''
                          ]"
                          :value="row.shlfLfNum"
                          @change.native="row.shlfLfNum = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      v-if="row.serLot === 'L' || row.shlfLf === 'Y'"
                      rules="required"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value.replace(/[^0-9]/g, ''); if (this.value.length > 3)
        this.value = this.value.slice(0, 3);"
                          class="srcRcv"
                          v-bind:class="[
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'srcRcv',
                              row.srcRcv
                            ),
                            row.srcRcv === 0 || row.srcRcv < row.srcExp
                              ? 'is-danger'
                              : ''
                          ]"
                          :value="row.srcRcv"
                          @change.native="row.srcRcv = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                    <b-input
                      v-else
                      type="text"
                      oninput="this.value = this.value.replace(/[^0-9]/g, ''); if (this.value.length > 3)
        this.value = this.value.slice(0, 3);"
                      class="srcRcv"
                      v-bind:class="[
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'srcRcv',
                          row.srcRcv
                        ),
                        row.srcRcv === 0 || row.srcRcv < row.srcExp
                          ? 'is-danger'
                          : ''
                      ]"
                      :value="row.srcRcv"
                      @change.native="row.srcRcv = $event.target.value"
                    ></b-input>
                  </td>
                  <td>
                    <ValidationProvider
                      v-if="row.serLot === 'L' || row.shlfLf === 'Y'"
                      rules="required"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value.replace(/[^0-9]/g, ''); if (this.value.length > 3)
        this.value = this.value.slice(0, 3);"
                          class="srcExp"
                          v-bind:class="[
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'srcExp',
                              row.srcExp
                            ),
                            row.srcExp === 0 ? 'is-danger' : ''
                          ]"
                          :value="row.srcExp"
                          @change.native="row.srcExp = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                    <b-input
                      v-else
                      type="text"
                      oninput="this.value = this.value.replace(/[^0-9]/g, ''); if (this.value.length > 3)
        this.value = this.value.slice(0, 3);"
                      class="srcExp"
                      v-bind:class="[
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'srcExp',
                          row.srcExp
                        ),
                        row.srcExp === 0 ? 'is-danger' : ''
                      ]"
                      :value="row.srcExp"
                      @change.native="row.srcExp = $event.target.value"
                    ></b-input>
                  </td>
                  <td>
                    <b-input
                      type="text"
                      oninput="this.value = this.value.replace(/[^0-9]/g, ''); if (this.value.length > 5)
                          this.value = this.value.slice(0, 5);"
                      class="wrnt"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'wrnt',
                          row.wrnt
                        )
                      "
                      :value="row.wrnt"
                      @change.native="row.wrnt = $event.target.value"
                    ></b-input>
                  </td>
                  <td>
                    <b-select
                      v-if="isUser3PGQtab"
                      class="instl"
                      v-model="row.instl"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'instl',
                          row.instl
                        )
                      "
                      :value="
                        row.instl === undefined ? (row.instl = ' ') : row.instl
                      "
                    >
                      <option value=" "></option><option value="Y">Yes</option
                      ><option value="N">No</option>
                    </b-select>
                    <ValidationProvider
                      v-else
                      rules="oneOf:Y,N"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="instl"
                          v-model="row.instl"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'instl',
                              row.instl
                            )
                          "
                          :value="
                            row.instl === undefined
                              ? (row.instl = ' ')
                              : row.instl
                          "
                        >
                          <option value=" "></option
                          ><option value="Y">Yes</option
                          ><option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <b-select
                      class="vlt"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'vlt',
                          row.vlt
                        )
                      "
                      v-model="row.vlt"
                      :value="row.vlt === undefined ? (row.vlt = ' ') : row.vlt"
                      :title="row.vlt"
                    >
                      <option value=" "></option
                      ><option value="110">110</option>
                      <option value="115">115</option>
                      <option value="120">120</option>
                      <option value="220">220</option>
                      <option value="230">230</option>
                      <option value="380">380</option>
                      <option value="110/240">110/240</option>
                      <option value="120/240">120/240</option>
                      <option value="208/240">208/240</option>
                      <option value="240/380">240/380</option>
                    </b-select>
                  </td>
                  <td>
                    <b-select
                      class="hz"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'hz',
                          row.hz
                        )
                      "
                      v-model="row.hz"
                      :value="row.hz === undefined ? (row.hz = ' ') : row.hz"
                      :title="row.hz"
                    >
                      <option value=" "></option><option value="50">50</option>
                      <option value="60">60</option>
                      <option value="25/60">25/60</option>
                      <option value="50/60">50/60</option>
                    </b-select>
                  </td>
                  <td>
                    <b-select
                      class="phs"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'phs',
                          row.phs
                        )
                      "
                      v-model="row.phs"
                      :value="row.phs === undefined ? (row.phs = ' ') : row.phs"
                    >
                      <option value=" "></option><option value="1">1</option>
                      <option value="2">2</option>
                      <option value="3">3</option>
                      <option value="None">None</option>
                    </b-select>
                  </td>
                  <td>
                    <b-input
                      type="text"
                      class="replCat"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'replCat',
                          row.replCat
                        )
                      "
                      :value="row.replCat"
                      @change.native="row.replCat = $event.target.value"
                    ></b-input>
                  </td>
                  <td>
                    <b-input
                      type="text"
                      class="accessory"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'accessory',
                          row.accessory
                        )
                      "
                      :value="row.accessory"
                      @change.native="row.accessory = $event.target.value"
                    ></b-input>
                  </td>
                  <td>
                    <b-select
                      class="accessoryType"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'accessoryType',
                          row.accessoryType
                        )
                      "
                      v-model="row.accessoryType"
                      :value="
                        row.accessoryType === undefined
                          ? (row.accessoryType = ' ')
                          : row.accessoryType
                      "
                    >
                      <option value=" "></option>
                      <option value="(001) Accessory">(001) Accessory</option>
                      <option value="(002) Required Item"
                        >(002) Required Item</option
                      >
                      <option value="(003) Replacement Part"
                        >(003) Replacement Part</option
                      >
                      <option value="(004) Related Item"
                        >(004) Related Item</option
                      >
                      <option value="(005) Often Bought with"
                        >(005) Often Bought with</option
                      >
                      <option value="(006) Related Services"
                        >(006) Related Services</option
                      >
                      <option value="(007) Secondary Services"
                        >(007) Secondary Services</option
                      >
                    </b-select>
                  </td>

                  <td>
                    <ValidationProvider
                      rules="required_if:compCat1Num"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                      vid="compCat1Name"
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          class="compCat1Name"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'compCat1Name',
                              row.compCat1Name
                            )
                          "
                          :value="row.compCat1Name"
                          @change.native="
                            row.compCat1Name = $event.target.value
                          "
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:compCat1Name"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                      vid="compCat1Num"
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          class="compCat1Num"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'compCat1Num',
                              row.compCat1Num
                            )
                          "
                          :value="row.compCat1Num"
                          @change.native="row.compCat1Num = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:compCat1Num"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          class="compCat1Equ"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'compCat1Equ',
                              row.compCat1Equ
                            )
                          "
                          :value="row.compCat1Equ"
                          @change.native="row.compCat1Equ = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <b-input
                      type="text"
                      class="compCat1Comm"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'compCat1Comm',
                          row.compCat1Comm
                        )
                      "
                      :value="row.compCat1Comm"
                      @change.native="row.compCat1Comm = $event.target.value"
                    ></b-input>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:compCat2Num"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                      vid="compCat2Name"
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          class="compCat2Name"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'compCat2Name',
                              row.compCat2Name
                            )
                          "
                          :value="row.compCat2Name"
                          @change.native="
                            row.compCat2Name = $event.target.value
                          "
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:compCat2Name"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                      vid="compCat2Num"
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          class="compCat2Num"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'compCat2Num',
                              row.compCat2Num
                            )
                          "
                          :value="row.compCat2Num"
                          @change.native="row.compCat2Num = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:compCat2Num"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          class="compCat2Equ"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'compCat2Equ',
                              row.compCat2Equ
                            )
                          "
                          :value="row.compCat2Equ"
                          @change.native="row.compCat2Equ = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <b-input
                      type="text"
                      class="compCat2Comm"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'compCat2Comm',
                          row.compCat2Comm
                        )
                      "
                      :value="row.compCat2Comm"
                      @change.native="row.compCat2Comm = $event.target.value"
                    ></b-input>
                  </td>
                  <td>
                    <ValidationProvider
                      v-if="isUser3PGQtab"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                      vid="greenProd"
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="greenProd"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'greenProd',
                              row.greenProd
                            )
                          "
                          v-model="row.greenProd"
                          :value="
                            row.greenProd === undefined
                              ? (row.greenProd = ' ')
                              : row.greenProd
                          "
                        >
                          <option value=" "></option
                          ><option value="Y">Yes</option
                          ><option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      v-else
                      rules="oneOf:Y,N"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                      vid="greenProd"
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="greenProd"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'greenProd',
                              row.greenProd
                            )
                          "
                          v-model="row.greenProd"
                          :value="
                            row.greenProd === undefined
                              ? (row.greenProd = ' ')
                              : row.greenProd
                          "
                        >
                          <option value=" "></option
                          ><option value="Y">Yes</option
                          ><option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:greenProd,Y"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="greenEcoFriendly"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'greenEcoFriendly',
                              row.greenEcoFriendly
                            )
                          "
                          v-model="row.greenEcoFriendly"
                          :value="
                            row.greenEcoFriendly === undefined
                              ? (row.greenEcoFriendly = ' ')
                              : row.greenEcoFriendly
                          "
                        >
                          <option value=" "></option
                          ><option value="Y">Yes</option
                          ><option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:greenProd,Y"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="greenEnergyStar"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'greenEnergyStar',
                              row.greenEnergyStar
                            )
                          "
                          v-model="row.greenEnergyStar"
                          :value="
                            row.greenEnergyStar === undefined
                              ? (row.greenEnergyStar = ' ')
                              : row.greenEnergyStar
                          "
                        >
                          <option value=" "></option
                          ><option value="Y">Yes</option
                          ><option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:greenProd,Y"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="greenSealApproval"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'greenSealApproval',
                              row.greenSealApproval
                            )
                          "
                          v-model="row.greenSealApproval"
                          :value="
                            row.greenSealApproval === undefined
                              ? (row.greenSealApproval = ' ')
                              : row.greenSealApproval
                          "
                        >
                          <option value=" "></option
                          ><option value="Y">Yes</option
                          ><option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:greenProd,Y"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="greenBiobased"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'greenBiobased',
                              row.greenBiobased
                            )
                          "
                          v-model="row.greenBiobased"
                          :value="
                            row.greenBiobased === undefined
                              ? (row.greenBiobased = ' ')
                              : row.greenBiobased
                          "
                        >
                          <option value=" "></option
                          ><option value="Y">Yes</option
                          ><option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:greenProd,Y"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="greenFemp"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'greenFemp',
                              row.greenFemp
                            )
                          "
                          v-model="row.greenFemp"
                          :value="
                            row.greenFemp === undefined
                              ? (row.greenFemp = ' ')
                              : row.greenFemp
                          "
                        >
                          <option value=" "></option
                          ><option value="Y">Yes</option
                          ><option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:greenProd,Y"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="greenEpa"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'greenEpa',
                              row.greenEpa
                            )
                          "
                          v-model="row.greenEpa"
                          :value="
                            row.greenEpa === undefined
                              ? (row.greenEpa = ' ')
                              : row.greenEpa
                          "
                        >
                          <option value=" "></option
                          ><option value="Y">Yes</option
                          ><option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:greenProd,Y"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="greenOzoneFree"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'greenOzoneFree',
                              row.greenOzoneFree
                            )
                          "
                          v-model="row.greenOzoneFree"
                          :value="
                            row.greenOzoneFree === undefined
                              ? (row.greenOzoneFree = ' ')
                              : row.greenOzoneFree
                          "
                        >
                          <option value=" "></option
                          ><option value="Y">Yes</option
                          ><option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:greenProd,Y"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="greenNontoxic"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'greenNontoxic',
                              row.greenNontoxic
                            )
                          "
                          v-model="row.greenNontoxic"
                        >
                          <option value=" "></option
                          ><option value="Y">Yes</option
                          ><option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:greenProd,Y"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="greenRecyc"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'greenRecyc',
                              row.greenRecyc
                            )
                          "
                          v-model="row.greenRecyc"
                          :value="
                            row.greenRecyc === undefined
                              ? (row.greenRecyc = ' ')
                              : row.greenRecyc
                          "
                        >
                          <option value=" "></option
                          ><option value="Y">Yes</option
                          ><option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:greenProd,Y"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="greenMaterial"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'greenMaterial',
                              row.greenMaterial
                            )
                          "
                          v-model="row.greenMaterial"
                          :value="
                            row.greenMaterial === undefined
                              ? (row.greenMaterial = ' ')
                              : row.greenMaterial
                          "
                        >
                          <option value=" "></option
                          ><option value="Y">Yes</option
                          ><option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:greenProd,Y"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="greenRman"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'greenRman',
                              row.greenRman
                            )
                          "
                          v-model="row.greenRman"
                          :value="
                            row.greenRman === undefined
                              ? (row.greenRman = ' ')
                              : row.greenRman
                          "
                        >
                          <option value=" "></option
                          ><option value="Y">Yes</option
                          ><option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:greenProd,Y"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="greenPrime"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'greenPrime',
                              row.greenPrime
                            )
                          "
                          v-model="row.greenPrime"
                          :value="
                            row.greenPrime === undefined
                              ? (row.greenPrime = ' ')
                              : row.greenPrime
                          "
                        >
                          <option value=" "></option
                          ><option value="Y">Yes</option
                          ><option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:greenProd,Y"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="greenNeshap"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'greenNeshap',
                              row.greenNeshap
                            )
                          "
                          v-model="row.greenNeshap"
                          :value="
                            row.greenNeshap === undefined
                              ? (row.greenNeshap = ' ')
                              : row.greenNeshap
                          "
                        >
                          <option value=" "></option
                          ><option value="Y">Yes</option
                          ><option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:greenProd,Y"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="greenEpeat"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'greenEpeat',
                              row.greenEpeat
                            )
                          "
                          v-model="row.greenEpeat"
                          :value="
                            row.greenEpeat === undefined
                              ? (row.greenEpeat = ' ')
                              : row.greenEpeat
                          "
                        >
                          <option value=" "></option
                          ><option value="Y">Yes</option
                          ><option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      v-if="isUser3PGQtab"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                      vid="caAvailability"
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="caAvailability"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'caAvailability',
                              row.caAvailability
                            )
                          "
                          v-model="row.caAvailability"
                          :value="
                            row.caAvailability === undefined
                              ? (row.caAvailability = ' ')
                              : row.caAvailability
                          "
                        >
                          <option value=" "></option
                          ><option value="Y">Yes</option
                          ><option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      v-else
                      rules="oneOf:Y,N"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                      vid="caAvailability"
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="caAvailability"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'caAvailability',
                              row.caAvailability
                            )
                          "
                          v-model="row.caAvailability"
                          :value="
                            row.caAvailability === undefined
                              ? (row.caAvailability = ' ')
                              : row.caAvailability
                          "
                        >
                          <option value=" "></option
                          ><option value="Y">Yes</option
                          ><option value="N">No</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      rules="required_if:caAvailability,Y"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                      vid="caCurrency"
                    >
                      <div class="control" :class="classes">
                        <b-select
                          class="caCurrency"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'caCurrency',
                              row.caCurrency
                            )
                          "
                          v-model="row.caCurrency"
                          :value="
                            row.caCurrency === undefined
                              ? (row.caCurrency = ' ')
                              : row.caCurrency
                          "
                        >
                          <option value=" "></option
                          ><option value="USD">USD</option
                          ><option value="CDN">CDN</option>
                        </b-select>
                      </div>
                    </ValidationProvider>
                  </td>
                  <td>
                    <ValidationProvider
                      v-if="
                        (row.category === 'Equipment' &&
                          row.caAvailability === 'Y') ||
                          row.caCurrency === 'CDN'
                      "
                      rules="required"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{4})./g, '$1'); if (this.value.split('.')[0].length > 7)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 7) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 7);"
                          class="caSuCost text-align-right"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'caSuCost',
                              row.caSuCost
                            )
                          "
                          :value="
                            row.caSuCost !== undefined
                              ? addFourZeros(row.caSuCost)
                              : row.caSuCost
                          "
                          @change.native="row.caSuCost = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                    <b-input
                      v-else
                      type="text"
                      oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{3})./g, '$1'); if (this.value.split('.')[0].length > 7)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 7) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 7);"
                      class="caSuCost text-align-right"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'caSuCost',
                          row.caSuCost
                        )
                      "
                      :value="
                        row.caSuCost !== undefined
                          ? addThreeZeros(row.caSuCost)
                          : row.caSuCost
                      "
                      @change.native="row.caSuCost = $event.target.value"
                    ></b-input>
                  </td>
                  <td>
                    <ValidationProvider
                      v-if="
                        (row.category === 'Equipment' &&
                          row.caAvailability === 'Y') ||
                          row.caCurrency === 'CDN'
                      "
                      rules="required"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if (this.value.split('.')[0].length > 7)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 7) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 7);"
                          class="caSuList text-align-right"
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'caSuList',
                              row.caSuList
                            )
                          "
                          :value="
                            row.caSuList !== undefined
                              ? addTwoZeros(row.caSuList)
                              : row.caSuList
                          "
                          @change.native="row.caSuList = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                    <b-input
                      v-else
                      type="text"
                      oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if (this.value.split('.')[0].length > 7)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 7) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 7);"
                      class="caSuList text-align-right"
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'caSuList',
                          row.caSuList
                        )
                      "
                      :value="
                        row.caSuList !== undefined
                          ? addTwoZeros(row.caSuList)
                          : row.caSuList
                      "
                      @change.native="row.caSuList = $event.target.value"
                    ></b-input>
                  </td>
                  <td>
                    <ValidationProvider
                      v-if="
                        (row.category === 'Equipment' &&
                          row.caAvailability === 'Y') ||
                          (row.caCurrency === 'CDN' && row.au !== undefined)
                      "
                      rules="required"
                      :bails="false"
                      v-slot="{ classes }"
                      immediate
                    >
                      <div class="control" :class="classes">
                        <b-input
                          type="text"
                          oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if (this.value.split('.')[0].length > 7)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 7) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 7);"
                          class="caAuList text-align-right"
                          :disabled="
                            row.su === 'CS' ||
                              row.au === '' ||
                              row.au === ' ' ||
                              row.au === undefined
                          "
                          v-bind:class="
                            isApiErrorField(
                              row.psfsNewItemGenlQstnErrTbs,
                              'caAuList',
                              row.caAuList
                            )
                          "
                          :value="
                            row.caAuList !== undefined
                              ? addTwoZeros(row.caAuList)
                              : row.caAuList
                          "
                          @change.native="row.caAuList = $event.target.value"
                        ></b-input>
                      </div>
                    </ValidationProvider>
                    <b-input
                      v-else
                      type="text"
                      oninput="this.value = this.value
      .replace(/[^\d.]/g, '')
      .replace(/(\..*)\./g, '$1')
      .replace(/(\.[\d]{2})./g, '$1');if (this.value.split('.')[0].length > 7)
                          this.value.split('.')[1] ? this.value = this.value.split('.')[0].slice(0, 7) + '.' + this.value.split('.')[1] : this.value = this.value.split('.')[0].slice(0, 7);"
                      class="caAuList text-align-right"
                      :disabled="
                        row.su === 'CS' ||
                          row.au === '' ||
                          row.au === ' ' ||
                          row.au === undefined
                      "
                      v-bind:class="
                        isApiErrorField(
                          row.psfsNewItemGenlQstnErrTbs,
                          'caAuList',
                          row.caAuList
                        )
                      "
                      :value="
                        row.caAuList !== undefined
                          ? addTwoZeros(row.caAuList)
                          : row.caAuList
                      "
                      @change.native="row.caAuList = $event.target.value"
                    ></b-input>
                  </td>
                </ValidationObserver>
              </tr>
            </tbody>
          </table>
        </b-tab-item>
        <b-tab-item
          label="Regulatory Information"
          class="ni-app-regulatory-info-tab"
          :class="regulatoryInformationEditAccess()"
        >
          <RegulatoryInformationTabComponent
            @disableCreatorSubmitFromRegulatory="validateSubmitWrtRegulatory"
            @disableValidate="disableValidateButton = true"
            @enableValidate="disableValidateButton = false"
            @riTabErrorCount="updateRiErrorCount"
            @riTabSupplierTabsErrorCountForSuperUser="
              updateSupplierTabsErrorCountForSuperUser
            "
            @regulatoryPaginationParams="updateRegulatoryPaginationWrapper"
            :submissionIdForRegulatoryInformation="submissionID"
            :loadRegulatoryInformationData="canLoadRegulatoryInformationData"
          ></RegulatoryInformationTabComponent>
        </b-tab-item>
        <b-tab-item
          :visible="showPortfolioManagementTab"
          label="Portfolio Management"
          class="ni-app-portfolio-management-tab"
          :class="portfolioManagementEditAccess()"
        >
          <PortfolioManagementTabComponent
            @pmPaginationParams="updatePMPaginationWrapper"
            @enablePMApproverSubmit="enableApproverSubmit"
            @disablePMApproverSubmit="disableApproverSubmit"
            @errorCountOnPSUpdate="setValidateErrorCountForPS"
            @pmErrorCountForSuperUser="updatePmErrorCountForSuperUser"
            @pmTabErrorCount="updatePmErrorCount"
            @selectedRowIdsForPortfolioManagement="rowsToMarkApprovedOrRejected"
            :submissionIdForPortfolioManagement="submissionID"
            :loadPortfolioManagementData="canLoadPortfolioManagementData"
          ></PortfolioManagementTabComponent>
        </b-tab-item>
        <b-tab-item
          :visible="showRegulatoryAffairsTab"
          label="Regulatory Affairs"
          class="ni-app-regulatory-affairs-tab"
          :class="regulatoryAffairsEditAccess()"
        >
          <RegulatoryAffairsTabComponent
            @raPaginationParams="updateRAPaginationWrapper"
            @raTabErrorCount="updateRaErrorCount"
            @enableRAApproverSubmit="enableApproverSubmit"
            @disableRAApproverSubmit="disableApproverSubmit"
            @selectedRowIdsForRegulatoryAffairs="rowsToMarkApprovedOrRejected"
            :submissionIdForRegulatoryAffairs="submissionID"
            :loadRegulatoryAffairsData="canLoadRegulatoryAffairsData"
          ></RegulatoryAffairsTabComponent>
        </b-tab-item>
        <b-tab-item
          :visible="showProductServicesTab"
          label="Product Services"
          class="ni-app-product-services-tab"
          :class="productServicesEditAccess()"
        >
          <ProductServicesTabComponent
            @psPaginationParams="updatePSPaginationWrapper"
            @psTabErrorCount="updatePSTabErrorCountForSuperUser"
            @selectedRowIdsForProductServices="rowsToMarkApprovedOrRejected"
            :submissionIdForProductServices="submissionID"
            :loadProductServicesData="canLoadProductServicesData"
          ></ProductServicesTabComponent>
        </b-tab-item>
      </b-tabs>
    </section>
    <!--history popup-->
    <b-modal
      :active.sync="isComponentModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <SubmissionHistory v-bind="formProps"></SubmissionHistory>
    </b-modal>
    <b-modal
      :active.sync="isComponentFieldsModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <SubmissionFieldsHistory
        v-bind="tabToRetrieveFieldHistory"
      ></SubmissionFieldsHistory>
    </b-modal>
    <b-modal
      :active.sync="isReassignComponentModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <ReassignSubmission
        v-bind="reAssignSubmisionProps"
        @goToHomePage="closeFormAfterSubmit"
        :submissionIdForReaasign="submissionID"
      ></ReassignSubmission>
    </b-modal>
    <b-modal
      :active.sync="isCooComponentModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <CountryCodes
        v-bind="cooProps"
        @goToHomePage="closeFormAfterSubmit"
      ></CountryCodes>
    </b-modal>
    <b-modal
      :active.sync="isCasConfirmationModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <CasConfirmation
        @goToHomePage="closeFormAfterSubmit"
        :sIdForCASConfirm="submissionID"
        :casRejectionReason="rejectionReason"
      ></CasConfirmation>
    </b-modal>
    <b-modal
      :active.sync="isViewUploadErrorsModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <ViewUploadErrorsModal
        v-bind="errorsModalProps"
        @goToHomePage="closeFormAfterSubmit"
      ></ViewUploadErrorsModal>
    </b-modal>
  </div>
</template>

<script>
import $ from "jquery";
import vSelect from "vue-select";
import scrollToTop from "../mixins/scrollToTop.js";
import SubmissionHistory from "../components/SubmissionHistory.vue";
import SubmissionFieldsHistory from "./SubmissionFieldsHistory.vue";
import RegulatoryInformationTabComponent from "../components/RegulatoryInformationTabComponent.vue";
import RegulatoryAffairsTabComponent from "../components/RegulatoryAffairsTabComponent.vue";
import ProductServicesTabComponent from "../components/ProductServicesTabComponent.vue";
import PortfolioManagementTabComponent from "../components/PortfolioManagementTabComponent.vue";
import BSelect from "buefy/src/components/select/Select";
import BDropdownItem from "buefy/src/components/dropdown/DropdownItem";
import BButton from "buefy/src/components/button/Button";
import BInput from "buefy/src/components/input/Input";
import BDatepicker from "buefy/src/components/datepicker/Datepicker";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import BTabItem from "buefy/src/components/tabs/TabItem";
import ReassignSubmission from "../components/ReassignSubmission.vue";
import CountryCodes from "../components/CountryCodes.vue";
import CasConfirmation from "../components/CasConfirmation.vue";
import ViewUploadErrorsModal from "../components/ViewUploadErrorsModal.vue";
import instructionspdf from "../assets/docs/New Item Supplier Instructions.pdf";

extend("required", {
  validate(value) {
    return {
      required: true,
      valid: [" ", "", null, undefined, 0].indexOf(value) === -1
    };
  },
  computesRequired: true
});

extend("regexUpto4Decimals", {
  validate(value) {
    return {
      required: true,
      valid: /^\d*\.?\d{0,4}$/.test(value)
    };
  },
  computesRequired: true
});

//dependency validations for general info tab
extend("valOfAu", {
  params: ["suVal"],
  validate: (value, { suVal }) => {
    if (
      (suVal === "PK" && value === " ") ||
      (suVal === "PK" && value === "CS")
    ) {
      return true;
    } else if (suVal !== "PK") {
      return true;
    }
  }
});

extend("checkValidBasedOnSu", {
  params: ["suVal"],
  validate: (value, { suVal }) => {
    if (suVal === "PK" || suVal === "CS") {
      if (value >= "1" || value >= 1) {
        return true;
      }
    } else {
      return true;
    }
    return false;
  }
});

extend("valOfPackgrp", {
  params: ["hazVal"],
  validate: (value, { hazVal }) => {
    if (hazVal === "Y") {
      if (value === " ") {
        return false;
      }
    }
    return true;
  }
});

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

export default {
  name: "SubmissionForm",
  components: {
    RegulatoryAffairsTabComponent,
    BTabItem,
    BDatepicker,
    BInput,
    BButton,
    BDropdownItem,
    BSelect,
    SubmissionHistory,
    SubmissionFieldsHistory,
    ReassignSubmission,
    RegulatoryInformationTabComponent,
    CountryCodes,
    CasConfirmation,
    ViewUploadErrorsModal,
    ProductServicesTabComponent,
    PortfolioManagementTabComponent,
    vSelect
  },
  mixins: [scrollToTop],
  data() {
    return {
      instructionspdf,
      minDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        new Date().getDate()
      ),
      vendorIds: [],
      countryOriginOptions: [],
      loginRole: 0,
      activeTab: 0,
      pageIndex: 1,
      minPageIndex: "",
      maxPageIndex: "",
      totalResults: "",
      totalPages: "",
      showPreviousButton: true,
      showFirstButton: true,
      showLastButton: true,
      showNextButton: true,
      numberOfGeneralQuestionItems: 10,
      showInternalVNs: false,
      regulatoryPageIndex: 1,
      regulatoryMinPageIndex: "",
      regulatoryMaxPageIndex: "",
      regulatoryTotalResults: "",
      regulatoryTotalPages: "",
      regulatoryShowPreviousButton: true,
      regulatoryShowNextButton: true,
      regulatoryShowFirstButton: true,
      regulatoryShowLastButton: true,
      numberOfRegulatoryItems: 10,
      pmPageIndex: 1,
      pmMinPageIndex: "",
      pmMaxPageIndex: "",
      pmTotalResults: "",
      pmTotalPages: "",
      pmShowPreviousButton: true,
      pmShowNextButton: true,
      pmShowFirstButton: true,
      pmShowLastButton: true,
      numberOfPMItems: 10,
      raPageIndex: 1,
      raMinPageIndex: "",
      raMaxPageIndex: "",
      raTotalResults: "",
      raTotalPages: "",
      raShowPreviousButton: true,
      raShowNextButton: true,
      raShowFirstButton: true,
      raShowLastButton: true,
      numberOfRAItems: 10,
      psPageIndex: 1,
      psMinPageIndex: "",
      psMaxPageIndex: "",
      psTotalResults: "",
      psTotalPages: "",
      psShowPreviousButton: true,
      psShowNextButton: true,
      psShowFirstButton: true,
      psShowLastButton: true,
      numberOfPSItems: 10,
      isLoading: false,
      showFromTable: false,
      showNextApprover: false,
      canUserEdit: false,
      canPmEditSupplierEntry: false,
      submissionStatusIsDraft: false,
      showSubmissionInReadOnly: false,
      showForInternalUserOnly: false,
      submissionStatusIsActive: false,
      showSubmissionForSupplierUser: false,
      showProductServicesTab: false,
      showPortfolioManagementTab: false,
      showRegulatoryAffairsTab: false,
      showStatusActionButtons: false,
      supplierErrorCount: 0,
      errorClass: "",
      nextApproverName: "",
      vcatRequired: false,
      tooltipIndex: "",
      rowIds: [],
      countVar: false,
      selectAllChecked: false,
      checkboxGroup: [],
      selectedRows: [],
      rowChecked: false,
      rows: [],
      regulatoryRows: [],
      apiRowEntries: [],
      genQId: "",
      defaultSubmissionView: "Submission Detail",
      showSubmissionDetail: true,
      showItemDetail: false,
      showActions: false,
      fromTable: "",
      formType: "",
      submissionID: "",
      submissionStatus: "",
      vn: "",
      vnName: "",
      isUserEditingVnsInternal: false,
      isUser3P: false,
      isUser3PGQtab: false,
      website: "",
      prodContactName: "",
      prodContactEmail: "",
      regContactName: "",
      regContactPhone: "",
      regContactEmail: "",
      qualContactName: "",
      qualContactPhone: "",
      qualContactEmail: "",
      tradeContactName: "",
      tradeContactPhone: "",
      tradeContactEmail: "",
      transContactName: "",
      transContactPhone: "",
      transContactEmail: "",
      supplierComments: "",
      suppRewrkReason: "",
      internalRewrkReason: "",
      internalComments: "",
      priority: " ",
      busUnit: " ",
      promotion: "",
      fcatSugSeries: " ",
      fcatOther: "",
      prefixSuffix: "",
      prodCount: "",
      launchDate: null,
      prodLineDesc: "",
      createdBy: "",
      createdDate: "",
      file: null,
      imageAttachment: null,
      submissionDesc: "",
      validationErrorDescription: "",
      showValidationErrorMessage: false,
      showSuccessMessage: false,
      showErrorNotification: false,
      showCreateButtons: false,
      disableCreatorSubmit: true,
      validateErrorObj: "",
      disableApproverSubmitBtn: true,
      disableValidateButton: false,
      showApproveButtons: false,
      showReworkButton: false,
      showExitButton: false,
      successMessage: "",
      errorMessage: "",
      msdsAttachment: null,
      batteryAttachment: null,
      insertAttach: null,
      vnList: [],
      generalInfoFields: {
        generalInfoColumns: [
          {
            className: "",
            field: "line",
            label: "Line Errors",
            title: ""
          },
          {
            className: "",
            field: "vcat",
            label: "Supplier Catalog Number",
            title:
              "The  supplier's catalog number to be used on Fisher purchase orders for accurate identity. Only allowable special characters are . / \\ -"
          },
          {
            className: "",
            field: "desc30",
            label: "Item Description - 30 Characters",
            title:
              "Item description should contain customary abbreviations of the item attributes.  It begins with a noun followed by additional information to describe it and must contain the standard unit of measure and quantity within the standard unit of measure (smallest saleable unit) for any unit other than each (EA), pair (PR), and dozen (DZ). Only allowable special characters are . / \\ -"
          },
          {
            className: "",
            field: "desc240",
            label: "Item Description - 240 Characters",
            title:
              "Use the following format:  category of the product, subcategory(if applicable), second subcategory(if applicable), trade or brand name, model(if applicable), primary detail, secondary detail, tertiary detail, up to 5 additional details, application, and packaging configuration. Only allowable special characters are . / \\ - ( ) [ ] %"
          },
          {
            className: "",
            field: "desc1000",
            label: "Item Description - 1000 Characters",
            title:
              "Use the following format:  category of the product, subcategory(if applicable), second subcategory(if applicable), trade or brand name, model(if applicable), primary detail, secondary detail, tertiary detail, up to 5 additional details, application, and packaging configuration. Only allowable special characters are . / \\ - ( ) [ ] %"
          },
          {
            className: "",
            field: "brand",
            label: "Brand",
            title: "Brand name or particular name assigned to the product"
          },
          {
            className: "",
            field: "key1",
            label: "Keyword(1)",
            title:
              "Synonyms, nouns, and adjectives that are used to search for an item when the catalog number is unknown"
          },
          {
            className: "",
            field: "key2",
            label: "Keyword(2)",
            title:
              "Synonyms, nouns, and adjectives that are used to search for an item when the catalog number is unknown"
          },
          {
            className: "",
            field: "key3",
            label: "Keyword(3)",
            title:
              "Synonyms, nouns, and adjectives that are used to search for an item when the catalog number is unknown"
          },
          {
            className: "",
            field: "key4",
            label: "Keyword(4)",
            title:
              "Synonyms, nouns, and adjectives that are used to search for an item when the catalog number is unknown"
          },
          {
            className: "",
            field: "key5",
            label: "Keyword(5)",
            title:
              "Synonyms, nouns, and adjectives that are used to search for an item when the catalog number is unknown"
          },
          {
            className: "attach-image-label",
            field: "",
            label: "Attach Image",
            title:
              "Upload your product image via the Upload link, using your catalog number as the file name.  Following formats are accepted: jpg, eps, and tiff.  Minimum of 300 dpi"
          },
          {
            className: "",
            field: "manufacturerName",
            label: "Manufacturer Name",
            title:
              "The name of the manufacturer of the part (if different than supplier name)"
          },
          {
            className: "",
            field: "mcat",
            label: "Manufacturer Catalog Number",
            title:
              "The manufacturer's catalog number to be used on Fisher purchase orders for accurate identity if different than supplier catalog number"
          },
          {
            className: "",
            field: "mfgLeadTime",
            label: "Manufacturer Lead-Time",
            title:
              "The time measured from when a supplier receives an order for a product to when the supplier ships that product"
          },
          {
            className: "",
            field: "su",
            label: "Standard Unit",
            title:
              "The smallest saleable packaged unit inside the supplier selling unit of measure (Alternate Unit)"
          },
          {
            className: "",
            field: "suQty",
            label: "Standard Unit Quantity",
            title:
              "Number of units contained in the standard unit. If Standard Unit = EA or PR, Standard Unit Quantity = 1. If Standard Unit = DZ, Standard Unit Quantity = 12"
          },
          {
            className: "",
            field: "unitUse",
            label: "Unit of Use",
            title: "The smallest unit in which an item can be used"
          },
          {
            className: "",
            field: "suWt",
            label: "Standard Unit Weight",
            title: "Weight of the packaged Standard Unit in pounds (99999.99)"
          },
          {
            className: "",
            field: "suLen",
            label: "Standard Unit Length",
            title: "Length of the packaged Standard Unit in inches (999.99)"
          },
          {
            className: "",
            field: "suWid",
            label: "Standard Unit Width",
            title: "Width of the packaged Standard Unit in inches (999.99)"
          },
          {
            className: "",
            field: "suHt",
            label: "Standard Unit Height",
            title: "Height of the packaged Standard Unit in inches (999.99)"
          },
          {
            className: "",
            field: "pkgSzQty",
            label: "Package Size Quantity",
            title:
              "Numeric amount of chemical in a container ( i.e. if description indicates 100mL, the Package Size Quantity = 100) (999999.99)"
          },
          {
            className: "",
            field: "pkgSzUnt",
            label: "Package Size Unit",
            title:
              "The unit of the Package Size Quantity ( i.e. if description indicates 100mL, the Package Size Unit = mL)"
          },
          {
            className: "",
            field: "suppUom",
            label: "Supplier UOM",
            title: ""
          },
          {
            className: "",
            field: "suppConv",
            label: "Conversion from Supplier to Fisher",
            title: ""
          },
          {
            className: "",
            field: "au",
            label: "Alternate Unit",
            title:
              "Supplier's selling unit of measure that will appear on the Fisher Scientific purchase order"
          },
          {
            className: "",
            field: "auQty",
            label: "Alternate Unit Quantity",
            title: "Number of Standard Units in Alternate Unit.  "
          },
          {
            className: "",
            field: "auWt",
            label: "Alternate Unit Weight",
            title: "Weight of the packaged Alternate Unit in pounds (99999.99)"
          },
          {
            className: "",
            field: "auLen",
            label: "Alternate Unit Length",
            title: "Length of the packaged Alternate Unit in inches (999.99)"
          },
          {
            className: "",
            field: "auWid",
            label: "Alternate Unit Width",
            title:
              "Alternate Unit Width - width of the packaged Alternate Unit in inches (required if Alternate Unit exists) (999.99)"
          },
          {
            className: "",
            field: "auHt",
            label: "Alternate Unit Height",
            title: "Height of the packaged Alternate Unit in inches (999.99)"
          },
          {
            className: "",
            field: "suCost",
            label: "Standard Unit Cost",
            title:
              "Net cost after discounts that will appear on the supplier's invoice; based on the standard unit of measure (9999999.9999)"
          },
          {
            className: "",
            field: "suList",
            label: "Standard Unit List",
            title:
              "Supplier's suggested list price for the Standard Unit (9999999.99)"
          },
          {
            className: "",
            field: "auList",
            label: "Alternate Unit List",
            title:
              "Supplier's suggested list price for the Alternate Unit (9999999.99)"
          },
          {
            className: "",
            field: "discnt",
            label: "Discount %",
            title:
              "Discount to be applied to the Standard Unit List Price of the item – displayed as a decimal."
          },
          {
            className: "",
            field: "ncExpDt",
            label: "Pricing Expiration Date",
            title:
              "Date when the cost and list price provided expires (YYYYMMDD)"
          },
          {
            className: "",
            field: "custSpecific",
            label: "Customer Specific Item",
            title:
              "Is this catalog item being created specific to a customer for exclusive purchase?"
          },
          {
            className: "",
            field: "custSpecificName",
            label: "Customer Specific - Customer Name",
            title:
              "Please provide the name of the Customer this item is specific to"
          },
          {
            className: "",
            field: "custSpecificAcct",
            label: "Customer Specific - Customer Account",
            title:
              "Please provide the account of the Customer this item is specific to. Enter N/A if the account is unknown"
          },
          {
            className: "",
            field: "insideDelivery",
            label: "Recommended Inside Delivery",
            title: "Is Inside Delivery recommended for this product?"
          },
          {
            className: "",
            field: "unspsc",
            label: "UNSPSC Code",
            title:
              "An 8-digit product commodity code as determined by the UNSPSC hierarchical coding system. For number, see http://unspsc.org"
          },
          {
            className: "",
            field: "countryOrigin",
            label: "Country of Origin",
            subLabel: "Click here to view the codes",
            title:
              "The country where a product is manufactured, produced or grown"
          },
          {
            className: "",
            field: "haz",
            label: "Hazardous",
            title:
              "Indicates yes(Y) or no(N) if the item is hazardous for transportation"
          },
          {
            className: "",
            field: "unNa",
            label: "UN/NA#",
            title:
              "United Nations/North American number assigned to a hazardous material by the Department of Transportation"
          },
          {
            className: "",
            field: "hazcls",
            label: "Hazard Class",
            title: "Number that identifies the hazard of the material "
          },
          {
            className: "",
            field: "psn",
            label: "Proper Shipping Name (PSN)",
            title: "Shipping name for the product"
          },
          {
            className: "",
            field: "packgrp",
            label: "Packing Group",
            title:
              "Select the highest degree of hazard (I), second highest (II), lowest (III), or none (blank), based on the severity of the hazard"
          },
          {
            className: "",
            field: "hibc",
            label: "Health Industry Bar Code",
            title:
              "Begin with +, followed by four positions designating the labeler's identification code, followed by the Fisher catalog number (thirteen positions which will be assigned by Fisher  -  supplier should leave this blank).  The next two positions represent the coding for the standard and alternate unit of measure code.  The assignment is as follows: 1(unit of use), 2(case), 7(open), 8(pallet), 9(open).  The characters 0(zero) and (blank) are not defined in the HIBC structure and therefore should not be used"
          },
          {
            className: "",
            field: "ti",
            label: "Units on a Pallet",
            title:
              "Number of Units per layer on a Pallet (ex. 12 cartons per layer)"
          },
          {
            className: "",
            field: "hi",
            label: "Pallet layers",
            title:
              "Pallet Layers - number of layers on the pallet. If not applicable, enter 0. Number of layers high (ex. 6 layers)"
          },
          {
            className: "",
            field: "buildStockOrder",
            label: "Build to Stock or Build to Order",
            title: "Stocking strategy of the supplier"
          },
          {
            className: "",
            field: "serLot",
            label: "Serial / Lot Control",
            title:
              "Select S for serial or L for lot if the item has a serial or lot number that requires recording or control or No"
          },
          {
            className: "",
            field: "shlfLf",
            label: "Shelf Life",
            title: "Does this product have a shelf life?"
          },
          {
            className: "",
            field: "shlfLfNum",
            label: "Shelf Life (Days)",
            title:
              "The product's shelf life in number of days.\n Please leave the field blank if the product does not require a shelf life.\n If a value is entered, review Source Receiving & Expiration Days.\n Shelf life days must be greater than or equal to the source receiving days."
          },
          {
            className: "",
            field: "srcRcv",
            label: "Source Receiving Days",
            title:
              "Number of days of shelf life the supplier will guarantee for a product being delivered to Fisher Scientific.\n Source Receiving Days must be greater than or equal to the Source Expiration days."
          },
          {
            className: "",
            field: "srcExp",
            label: "Source Expiration Days",
            title:
              "Number of days of shelf life that Fisher Scientific will guarantee for an item that is delivered to a customer"
          },
          {
            className: "",
            field: "wrnt",
            label: "Warranty Period",
            title: "The product's warranty in number of days"
          },
          {
            className: "",
            field: "instl",
            label: "Installation",
            title:
              "Is technical service assistance for set-up or instructions for the customer on usage required?"
          },
          {
            className: "",
            field: "vlt",
            label: "Volts",
            title: "Electrical potential in volts"
          },
          {
            className: "",
            field: "hz",
            label: "HZ",
            title: "Number of cycles per second"
          },
          {
            className: "",
            field: "phs",
            label: "Phase",
            title: "Electrical characteristic. Select 1, 2, 3, or None"
          },
          {
            className: "",
            field: "replCat",
            label: "Replace Catalog Number",
            title:
              "The Fisher or Vendor Catalog Number of a product being replaced due to a supplier's discontinuation will be entered as a substitute to the discontinued item"
          },
          {
            className: "",
            field: "accessory",
            label: "Accessory",
            title:
              "Please provide the main product catalog number that correlates to this accessory. This accessory will display on the Fishersci.com product page to display the components available for equipment and instrumentation units they wish to purchase"
          },
          {
            className: "",
            field: "accessoryType",
            label: "Accessory Type",
            title: "Type of accessory"
          },
          {
            className: "",
            field: "compCat1Name",
            label: "Competitor 1 Name",
            title:
              "Competitor’s name (mfg or distributor) correlated with Competitor Catalog Number 1"
          },
          {
            className: "",
            field: "compCat1Num",
            label: "Competitor 1 Catalog Number",
            title: "Competitor’s catalog number for exact or like item"
          },
          {
            className: "",
            field: "compCat1Equ",
            label: "Competitor 1 Equivalency",
            title:
              "Defines degree of likeness between FROM and TO item. Exact = same exact product including branding. Technical Equivalent = all major product specifications match, branding and packaging may differ.  Functional Equivalent = some product specifications may vary but will function similarly, branding and packaging may differ"
          },
          {
            className: "",
            field: "compCat1Comm",
            label: "Competitor 1 Comments",
            title: "Highlight differences between FROM and TO item"
          },
          {
            className: "",
            field: "compCat2Name",
            label: "Competitor 2 Name",
            title:
              "Competitor’s name (mfg or distributor) correlated with Competitor Catalog Number 2"
          },
          {
            className: "",
            field: "compCat2Num",
            label: "Competitor 2 Catalog Number",
            title: "Competitor’s catalog number for exact or like item"
          },
          {
            className: "",
            field: "compCat2Equ",
            label: "Competitor 2 Equivalency",
            title:
              "Defines degree of likeness between FROM and TO item.  Exact = same exact product including branding.  Technical Equivalent = all major product specifications match, branding and packaging may differ.  Functional Equivalent = some product specifications may vary but will function similarly, branding and packaging may differ."
          },
          {
            className: "",
            field: "compCat2Comm",
            label: "Competitor 2 Comments",
            title: "Highlight differences between FROM and TO item"
          },
          {
            className: "",
            field: "greenProd",
            label: "Green Product",
            title: "Does this product have a low environmental impact?"
          },
          {
            className: "",
            field: "greenEcoFriendly",
            label: "Environmentally Friendly",
            title: "General GREEN claims including energy efficiency"
          },
          {
            className: "",
            field: "greenEnergyStar",
            label: "Energy Star",
            title:
              "Specific claim that product has been certified under the Energy Star program"
          },
          {
            className: "",
            field: "greenSealApproval",
            label: "Green Seal of Approval",
            title:
              "Specific claim that product has been certified under the Green Seal program"
          },
          {
            className: "",
            field: "greenBiobased",
            label: "BioBased",
            title:
              "Product has received BioPreferred certification from the USDA"
          },
          {
            className: "",
            field: "greenFemp",
            label: "FEMP Energy Efficient Item",
            title:
              "Specific claim that product has been certified under the FEMP program"
          },
          {
            className: "",
            field: "greenEpa",
            label: "U.S. EPA Significant New Alternatives Program",
            title:
              "Specific claim that product has been certified under the EPA SNAP program"
          },
          {
            className: "",
            field: "greenOzoneFree",
            label: "Ozone Free",
            title: "Must not contain any ozone-depleting substances"
          },
          {
            className: "",
            field: "greenNontoxic",
            label: "Non-Toxic",
            title:
              "Products based on OSHA and DOT regulations that are not toxic"
          },
          {
            className: "",
            field: "greenRecyc",
            label: "Recyclable Waste",
            title:
              "Must qualify claim by stating what aspects of product/package can be recycled, supported by scientific evidence showing ability to decompose in environment, and the rate and extent of degradation.  Must have competent and reliable substantiation that product will completely break down and return to nature within a reasonably short time (< 1 year) after disposal."
          },
          {
            className: "",
            field: "greenMaterial",
            label: "Manufactured with recycled, natural or renewable material",
            title:
              "Recycled claims must have been diverted from waste stream either pre- or post-consumer. For pre-consumer, vendor must prove that material would have entered waste stream, but for recycling. If partially recycled, disclose percentage by weight of recycled content. If recycled content consists of reconditioned parts, the identity of those parts should be disclosed. Source of renewable energy should be specified, however, do not make unqualified renewable energy claims if any significant part of the manufacturing energy source is powered by fossil fuels. Unless those fossil fuels are offset by Renewable Energy Certificates (REC’s)."
          },
          {
            className: "",
            field: "greenRman",
            label: "Comprehensive Procurement",
            title:
              "Specific claim that product has been certified by the US EPA Recovered Material Advisory Notice (RMAN) standard"
          },
          {
            className: "",
            field: "greenPrime",
            label: "PRIME",
            title:
              "Specific claim that product has been certified by the US Navy Plastics Removal in Marine Environment program"
          },
          {
            className: "",
            field: "greenNeshap",
            label: "NESHAP",
            title:
              "Specific claim that the product has been certified by the National Emission Standards for Hazardous Air Pollutants program"
          },
          {
            className: "",
            field: "greenEpeat",
            label: "EPEAT",
            title:
              "Specific claim that product has been certified by the Electronic Product Environment Assessment Tool"
          },
          {
            className: "",
            field: "caAvailability",
            label: "Canada Availability",
            title: "Is this part offered for sale in Canada?"
          },
          {
            className: "",
            field: "caCurrency",
            label: "Currency",
            title:
              "For parts available in Canada -  Are the Cost and List dollar amounts in CDN or US?"
          },
          {
            className: "",
            field: "caSuCost",
            label: "Canada Standard Unit Cost",
            title:
              "Net cost after discounts that will appear on the supplier's invoice; based on the standard unit of measure (9999999.9999). Please enter if currency is CDN or if different than USD amount"
          },
          {
            className: "",
            field: "caSuList",
            label: "Canada Standard Unit List",
            title:
              "Supplier's suggested list price for the Standard Unit (9999999.99). Please enter if currency is CDN or if different than USD amount"
          },
          {
            className: "",
            field: "caAuList",
            label: "Canada Alternate Unit List",
            title:
              "Supplier's suggested list price for the Alternate Unit (9999999.99). Please enter if currency is CDN or if different than USD amount"
          }
        ]
      },
      isFirstApprover: false,
      update: {
        mercury: "N",
        benzene: "N",
        asbestos: "N",
        iodine: "N",
        radioActive: "N",
        pesticide: "N",
        alcohol: "N"
      },
      updateRA: {
        ctrlCode: "",
        msds: "",
        bolCode: ""
      },
      bolOptions: [],
      giFilterApplied: false,
      riFilterApplied: false,
      pmFilterApplied: false,
      raFilterApplied: false,
      psFilterApplied: false,
      filterMapErrors: "",
      filterMapVcat: "",
      filterMapFcat: "",
      filterMapManufacturerName: "",
      filterMapPricingExpDate: null,
      filterMapUnspscCode: "",
      sortMapFieldName: "",
      sortMapSelectedOrder: "",
      searchMapFieldName: "",
      searchMapInput: "",
      pricingExpDate: null,
      filterMapRIErrors: "",
      filterMapCategory: "",
      filterMapProp65: "",
      filterMapMedDevice: "",
      sortMapRegulatoryField: "",
      sortMapRegulatorySelectedOrder: "",
      searchMapRegulatoryField: "",
      searchMapRegulatoryInput: "",
      filterMapRAErrors: "",
      filterMapRALineErrors: "",
      filterMapPMErrors: "",
      filterMapPMLineErrors: "",
      filterMapPSErrors: "",
      filterMapPSLineErrors: "",
      isComponentModalActive: false,
      isComponentFieldsModalActive: false,
      isReassignComponentModalActive: false,
      isCooComponentModalActive: false,
      isCasConfirmationModalActive: false,
      isViewUploadErrorsModalActive: false,
      showPsTabErrors: false,
      canLoadRegulatoryInformationData: {
        loadDetails: false,
        generalQuestionRows: [],
        actions: [],
        paginationParams: []
      },
      canLoadProductServicesData: {
        loadDetails: false,
        generalQuestionRows: [],
        actions: [],
        paginationParams: []
      },
      canLoadRegulatoryAffairsData: {
        loadDetails: false,
        generalQuestionRows: [],
        actions: [],
        paginationParams: []
      },
      canLoadPortfolioManagementData: {
        loadDetails: false,
        generalQuestionRows: [],
        actions: [],
        paginationParams: []
      },
      formProps: {
        historyData: []
      },
      tabToRetrieveFieldHistory: {
        tabName: [],
        submissionId: []
      },
      reAssignSubmisionProps: {
        mcsList: []
      },
      cooProps: {
        cooList: []
      },
      errorsModalProps: {
        region: "us",
        submissionId: [],
        tab: []
      },
      minAppDate: new Date("Jan 01 2020"),
      minNcExpDt: new Date(),
      psnTooltipIndex: null,
      supplierTabsErrorCountForSuperUser: "",
      pmErrorCountForSuperUser: "",
      psTabErrorCount: "",
      raTabErrorCount: "",
      pmTabErrorCount: "",
      riTabErrorCount: "",
      giTabErrorCount: "",
      rejectionReason: ""
    };
  },
  props: ["eventType"],
  watch: {
    disableApproverSubmitBtn() {
      //always enable approver submit btn for loginRole === 1
      if (this.loginRole === 1) {
        this.enableApproverSubmit();
      }
    },
    vn(newValue, oldValue) {
      if (
        this.loginRole === 0 ||
        this.loginRole === 1 ||
        this.loginRole === 2
      ) {
        if (newValue === this.vn && oldValue !== "") {
          this.validateVendorChange();
        }
      }
    },
    activeTab: function(tabIndex) {
      if (tabIndex === 0) {
        if (this.loginRole !== 0) {
          if (this.rows.length === 0) {
            this.loadItemDetailsUnderSubmission();
          }
        } else {
          this.loadItemDetailsUnderSubmission();
        }
      } else if (tabIndex === 1) {
        if (this.loginRole !== 0) {
          var riRowsCount = document.querySelector(
            ".ni-app-regulatory-info-tbody"
          ).rows.length;
          if (riRowsCount === 0) {
            this.canLoadRegulatoryInformationData = {
              loadDetails: true,
              generalQuestionRows: this.rows,
              actions: {
                fErrors: this.filterMapRIErrors,
                fCategory: this.filterMapCategory,
                fProp65: this.filterMapProp65,
                fMedDevice: this.filterMapMedDevice,
                soField: this.sortMapRegulatoryField,
                soOrder: this.sortMapRegulatorySelectedOrder,
                srFieldName: this.searchMapRegulatoryField,
                srValue: this.searchMapRegulatoryInput
              },
              paginationParams: {
                pageIndex: this.regulatoryPageIndex,
                numberOfRegulatoryItems: this.numberOfRegulatoryItems
              }
            };
          }
        } else {
          this.canLoadRegulatoryInformationData = {
            loadDetails: true,
            generalQuestionRows: this.rows,
            actions: {
              fErrors: this.filterMapRIErrors,
              fCategory: this.filterMapCategory,
              fProp65: this.filterMapProp65,
              fMedDevice: this.filterMapMedDevice,
              soField: this.sortMapRegulatoryField,
              soOrder: this.sortMapRegulatorySelectedOrder,
              srFieldName: this.searchMapRegulatoryField,
              srValue: this.searchMapRegulatoryInput
            },
            paginationParams: {
              pageIndex: this.regulatoryPageIndex,
              numberOfRegulatoryItems: this.numberOfRegulatoryItems
            }
          };
        }
      } else if (tabIndex === 2) {
        var pmRowsCount = document.querySelector(
          ".ni-app-portfolio-management-tbody"
        ).rows.length;
        if (pmRowsCount === 0) {
          this.canLoadPortfolioManagementData = {
            loadDetails: true,
            generalQuestionRows: this.rows,
            actions: {
              fErrors: this.filterMapPMErrors,
              fLineErrors: this.filterMapPMLineErrors
            },
            paginationParams: {
              pageIndex: this.pmPageIndex,
              numberOfPMItems: this.numberOfPMItems
            }
          };
        }
      } else if (tabIndex === 3) {
        var raRowsCount = document.querySelector(".ni-regulatory-affairs-body")
          .rows.length;
        if (raRowsCount === 0) {
          this.canLoadRegulatoryAffairsData = {
            loadDetails: true,
            generalQuestionRows: this.rows,
            actions: {
              fErrors: this.filterMapRAErrors,
              fLineErrors: this.filterMapRALineErrors
            },
            paginationParams: {
              pageIndex: this.raPageIndex,
              numberOfRAItems: this.numberOfRAItems
            }
          };
        }
      } else if (tabIndex === 4) {
        var psRowsCount = document.querySelector(".product-services-table-body")
          .rows.length;
        if (psRowsCount === 0) {
          this.canLoadProductServicesData = {
            loadDetails: true,
            generalQuestionRows: this.rows,
            actions: {
              fErrors: this.filterMapPSErrors,
              fLineErrors: this.filterMapPSLineErrors
            },
            paginationParams: {
              pageIndex: this.psPageIndex,
              numberOfPSItems: this.numberOfPSItems
            }
          };
        }
      }
    },
    selectAllChecked: function(isChecked) {
      if (isChecked) {
        this.checkboxGroup = this.rowIds;
      } else {
        this.checkboxGroup = [];
      }
    },
    eventType: function(value) {
      if (value === "createRequest") {
        this.isLoading = true;
        this.showSubmissionForSupplierUser = false;
        this.createNewSubmission();
        this.showExitButton = true;
      } else if (value.editRequest) {
        this.showSubmissionForSupplierUser = false;
        this.isLoading = true;
        this.openCurrentSubmission(value.editRequest);
        this.showExitButton = true;
        this.showSubmissionForSupplierUser = false;
      } else if (value.viewRequest) {
        this.isLoading = true;
        this.openCurrentSubmission(value.viewRequest);
        this.showCreateButtons = false;
        this.showApproveButtons = false;
        this.showReworkButton = false;
        this.showNextApprover = false;
        this.showExitButton = true;
        this.showSubmissionInReadOnly = true;
      } else if (value.reViewRequest) {
        this.isLoading = true;
        this.openCurrentSubmission(value.reViewRequest);
        this.showCreateButtons = false;
        this.showApproveButtons = false;
        this.showReworkButton = false;
        this.showNextApprover = false;
        this.showExitButton = true;
        this.showSubmissionInReadOnly = true;
      }
    }
  },
  mounted() {
    this.loginRole = window.$cookies.get("ni_key")
      ? window.$cookies.get("ni_key").roleKey
      : 0;
    if (window.$cookies.isKey("submissionObj")) {
      var submissionId = window.$cookies.get("submissionObj");
      this.openCurrentSubmission(submissionId);
      this.showForInternalUserOnly = true;
    }
  },
  methods: {
    onRowClick: function(event) {
      var tableRows = event.target.closest("tr").parentElement.rows;
      for (var row in tableRows) {
        if (
          tableRows[row].classList &&
          tableRows[row].classList.contains("highlight-row")
        ) {
          tableRows[row].classList.remove("highlight-row");
        }
      }
      event.target.closest("tr").classList.add("highlight-row");
    },
    addTwoZeros(value) {
      return parseFloat(value).toFixed(
        Math.max(((value + "").split(".")[1] || "").length, 2)
      );
    },
    addThreeZeros(value) {
      return parseFloat(value).toFixed(
        Math.max(((value + "").split(".")[1] || "").length, 3)
      );
    },
    addFourZeros(value) {
      return parseFloat(value).toFixed(
        Math.max(((value + "").split(".")[1] || "").length, 4)
      );
    },
    addPercentMode(value) {
      return Math.floor(value * 100) + "%";
    },
    checkEventTargetAndSave(event) {
      //allow save only for vn input change event(ignore event bubbling)
      //always ignore vnName manual change - field disabled
      //allow save from validateVendorChange method
      if (
        (event.target &&
          event.target.className !== "vs__search" &&
          event.target.parentNode.classList[
            event.target.parentNode.classList.length - 1
          ] !== "vn-name") ||
        event === undefined ||
        event instanceof Date
      ) {
        this.saveSubmission();
        //if target is fcatSugSeries
        if (event.target !== undefined && event.target.id === "fcatSugSeries") {
          window.reloadPMData = true;
        }
      }
    },
    checkRIFilterCriteria() {
      if (
        this.filterMapRIErrors ||
        this.filterMapCategory ||
        this.filterMapProp65 ||
        this.filterMapMedDevice
      ) {
        this.riFilterApplied = true;
      } else {
        this.riFilterApplied = false;
      }
    },
    checkPMFilterCriteria() {
      if (this.filterMapPMErrors) {
        this.pmFilterApplied = true;
      } else {
        this.pmFilterApplied = false;
      }
    },
    checkRAFilterCriteria() {
      if (this.filterMapRAErrors) {
        this.raFilterApplied = true;
      } else {
        this.raFilterApplied = false;
      }
    },
    checkPSFilterCriteria() {
      if (this.filterMapPSErrors) {
        this.psFilterApplied = true;
      } else {
        this.psFilterApplied = false;
      }
    },
    validateVendorChange(oldVn) {
      var scope = this;
      var requestPayload = {};
      requestPayload.vn = scope.vn;
      requestPayload.vnName = scope.vnName;
      requestPayload.website = scope.website;
      requestPayload.submissionDesc = scope.submissionDesc;
      requestPayload.user3P = scope.isUser3P;
      requestPayload.prodContactName = scope.prodContactName;
      requestPayload.prodContactEmail = scope.prodContactEmail;
      requestPayload.regContactName = scope.regContactName;
      requestPayload.regContactPhone = scope.regContactPhone;
      requestPayload.regContactEmail = scope.regContactEmail;
      requestPayload.qualContactName = scope.qualContactName;
      requestPayload.qualContactPhone = scope.qualContactPhone;
      requestPayload.qualContactEmail = scope.qualContactEmail;
      requestPayload.tradeContactName = scope.tradeContactName;
      requestPayload.tradeContactPhone = scope.tradeContactPhone;
      requestPayload.tradeContactEmail = scope.tradeContactEmail;
      requestPayload.transContactName = scope.transContactName;
      requestPayload.transContactPhone = scope.transContactPhone;
      requestPayload.transContactEmail = scope.transContactEmail;
      requestPayload.supplierComments = scope.supplierComments;
      requestPayload.suppRewrkReason = scope.suppRewrkReason;
      requestPayload.internalComments = scope.internalComments;
      requestPayload.internalRewrkReason = scope.internalRewrkReason;
      requestPayload.priority = scope.priority;
      requestPayload.busUnit = scope.busUnit;
      requestPayload.promotion = scope.promotion;
      requestPayload.fcatSugSeries = scope.fcatSugSeries;
      requestPayload.fcatOther = scope.fcatOther;
      requestPayload.prodCount = scope.prodCount;
      requestPayload.launchDate = scope.launchDate;
      requestPayload.prodLineDesc = scope.prodLineDesc;
      requestPayload.approverEmail = scope.prodContactEmail;
      requestPayload.prefixSuffix = scope.prefixSuffix;

      scope.isLoading = true;
      scope.$http
        .post(
          `${process.env.VUE_APP_API_BASE_DOMAIN}submissionId/${scope.submissionID}/validateVendorChange`,
          requestPayload
        )
        .then(function(response) {
          scope.isLoading = false;
          scope.reloadSupplierFormData();
          //role based submit btn validation
          scope.validateSubmitWrtErrorCountAndRoles();
          //reload tab on VN change
          if (scope.loginRole === 0) {
            window.reloadSupplierTab = true;
          }
        })
        .catch(function(error) {
          scope.isLoading = false;
          var vnChangeAlert = "";
          if (scope.prodCount > 150) {
            vnChangeAlert =
              "Changing the Vendor Number may cause some of the supplier fields to be revisited/corrected by the Supplier. \n" +
              "Please send it to re-work for the supplier to make the edits. This change can take upto 6 minutes to validate all the fields in the submission.\n" +
              "Would you like to continue?";
          } else {
            vnChangeAlert =
              "Changing the Vendor Number may cause some of the supplier fields to be revisited/corrected by the Supplier. Please send it to re-work for the supplier to make the edits. Would you like to continue with this change?";
          }
          if (error.response.status === 400) {
            scope.$buefy.dialog.confirm({
              message: `${vnChangeAlert}`,
              confirmText: "OK",
              type: "is-danger",
              onConfirm: () => scope.saveSubmission("updateVN"),
              //reload form data to avoid vnName change on vn assignment
              onCancel: () => scope.reloadSupplierFormData()
            });
          } else {
            scope.$buefy.dialog.alert({
              message: `A problem occured with Vendor Number change. Please enter valid Vendor Number and/or clear the cache and try again. If problem persists, please contact the New Item Support at NewItem.IT.Support@thermofisher.com`,
              confirmText: "OK",
              type: "is-danger"
            });
          }
        });
    },
    enableApproverSubmit() {
      this.disableApproverSubmitBtn = false;
    },
    disableApproverSubmit() {
      this.disableApproverSubmitBtn = true;
    },
    validateSubmitWrtRegulatory(value) {
      if (
        document.querySelectorAll(".submitter-only-wrapper .us-region .invalid")
          .length === 0 &&
        value
      ) {
        this.disableCreatorSubmit = false;
        this.validateErrorObj.validateValue = "Y";
        this.validateErrorObj.errorCount = 0;
      } else {
        this.disableCreatorSubmit = true;
      }
    },
    downloadSubmissionFile(downloadType) {
      var submissionFormScope = this;
      var url = "";
      var filename = "";
      if (downloadType === "template") {
        url = `${process.env.VUE_APP_API_BASE_DOMAIN}exportUploadTemplate`;
        filename = "New Item Upload Template.xlsx";
      } else if (downloadType === "report") {
        url = `${process.env.VUE_APP_API_BASE_DOMAIN}downloadSubmissionStatusReport`;
        filename = "Submissions_Report.xlsx";
      } else if (downloadType === "caId") {
        url = `${process.env.VUE_APP_API_BASE_DOMAIN}downloadCaData/submissionId/${submissionFormScope.submissionID}`;
        filename = `Canada New Add Form - ${submissionFormScope.vn} ${submissionFormScope.vnName} - ${submissionFormScope.submissionID}.zip`;
      } else {
        if (this.eventType) {
          if (this.showProductServicesTab) {
            url = `${process.env.VUE_APP_API_BASE_DOMAIN}downloadRejectedSubmission/submissionId/${submissionFormScope.submissionID}`;
          } else {
            url = `${process.env.VUE_APP_API_BASE_DOMAIN}downloadSubmission/submissionId/${submissionFormScope.submissionID}`;
          }
          filename = `Submission_${submissionFormScope.submissionID}.xlsx`;
        } else {
          url = `${process.env.VUE_APP_API_BASE_DOMAIN}approverDownloadSubmission/submissionId/${submissionFormScope.submissionID}`;
          filename = `Submission_${submissionFormScope.submissionID}.xlsx`;
        }
      }

      submissionFormScope.isLoading = true;
      submissionFormScope
        .$http({
          url: url,
          method: "GET",
          responseType: "blob"
        })
        .then(function(response) {
          submissionFormScope.isLoading = false;
          var url = window.URL.createObjectURL(new Blob([response.data]));
          var link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          submissionFormScope.isLoading = false;
          submissionFormScope.$buefy.dialog.alert({
            message: `A problem occurred with file download. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    canEdit() {
      if (this.fromTable === "View All Submissions") {
        if (this.loginRole === 6) {
          return "";
        } else if (this.canUserEdit) {
          return "";
        } else {
          return "viewOnly";
        }
      } else {
        return "";
      }
    },
    submissionLevelEditAccess() {
      if (
        this.submissionStatusIsActive ||
        this.submissionStatusIsReworkForPM ||
        this.submissionStatusIsRejected ||
        this.submissionStatusIsComplete
      ) {
        switch (window.$cookies.get("ni_key").roleKey) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 6:
            return "viewOnly";
        }
      } else if (this.submissionStatusIsDraft) {
        switch (window.$cookies.get("ni_key").roleKey) {
          case 1:
          case 3:
          case 4:
          case 5:
          case 6:
            return "viewOnly";
          case 2:
            if (this.canPmEditSupplierEntry === false) {
              return "viewOnly";
            }
        }
      }
      //rules for view all - internal user or supplier user
      else if (this.showSubmissionInReadOnly) {
        return "viewOnly";
      } else if (this.showSubmissionForSupplierUser) {
        return "";
      }
    },
    generalInformationEditAccess() {
      if (
        this.submissionStatusIsActive ||
        this.submissionStatusIsReworkForPM ||
        this.submissionStatusIsRejected ||
        this.submissionStatusIsComplete
      ) {
        switch (window.$cookies.get("ni_key").roleKey) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            return "viewOnly";
          case 6:
            if (this.submissionStatusIsActive) {
              return "";
            } else {
              return "viewOnly";
            }
        }
      } else if (this.submissionStatusIsDraft) {
        switch (window.$cookies.get("ni_key").roleKey) {
          case 1:
          case 3:
          case 4:
          case 5:
          case 6:
            return "viewOnly";
          case 2:
            if (this.canPmEditSupplierEntry === false) {
              return "viewOnly";
            }
        }
      }
      //rules for view all - internal user or supplier user
      else if (this.showSubmissionInReadOnly) {
        return "viewOnly";
      } else if (this.showSubmissionForSupplierUser) {
        return "";
      }
    },
    regulatoryInformationEditAccess() {
      if (
        this.submissionStatusIsActive ||
        this.submissionStatusIsReworkForPM ||
        this.submissionStatusIsRejected ||
        this.submissionStatusIsComplete
      ) {
        switch (window.$cookies.get("ni_key").roleKey) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            return "viewOnly";
          case 6:
            if (this.submissionStatusIsActive) {
              return "";
            } else {
              return "viewOnly";
            }
        }
      } else if (this.submissionStatusIsDraft) {
        switch (window.$cookies.get("ni_key").roleKey) {
          case 1:
          case 3:
          case 4:
          case 5:
          case 6:
            return "viewOnly";
          case 2:
            if (this.canPmEditSupplierEntry === false) {
              return "viewOnly";
            }
        }
      }
      //rules for view all - internal user or supplier user
      else if (this.showSubmissionInReadOnly) {
        return "viewOnly";
      } else if (this.showSubmissionForSupplierUser) {
        return "";
      }
    },
    pmFieldsOnSubmissionLevelEditAccess() {
      if (this.submissionStatusIsActive || this.submissionStatusIsReworkForPM) {
        switch (window.$cookies.get("ni_key").roleKey) {
          case 1:
          case 2:
            return "status-active";
          case 3:
          case 4:
          case 5:
          case 6:
            return "viewOnly";
        }
      } else {
        return "viewOnly";
      }
    },
    portfolioManagementEditAccess() {
      if (this.submissionStatusIsActive || this.submissionStatusIsReworkForPM) {
        switch (window.$cookies.get("ni_key").roleKey) {
          case 1:
            this.showPortfolioManagementTab = true;
            this.showStatusActionButtons = true;
            this.showReworkButton = true;
            this.submissionStatusIsReworkForPM
              ? (window.psToRework = true)
              : (window.psToRework = false);
            //view and edit
            if (this.fromTable === "View All Submissions") {
              if (this.canUserEdit) {
                return "status-active";
              } else {
                return "viewOnly";
              }
            } else {
              return "status-active";
            }
          case 2:
            //view and edit
            this.showPortfolioManagementTab = true;
            this.showStatusActionButtons = true;
            this.showReworkButton = true;
            if (this.fromTable === "View All Submissions") {
              if (this.canUserEdit) {
                return "status-active";
              } else {
                return "viewOnly";
              }
            } else {
              return "status-active";
            }
          case 3:
          case 4:
          case 5:
            this.showPortfolioManagementTab = true;
            this.showReworkButton = false;
            return "viewOnly";
          case 6:
            this.showPortfolioManagementTab = true;
            this.showReworkButton = false;
            if (this.fromTable === "View All Submissions") {
              if (this.canUserEdit) {
                if (this.submissionStatusIsActive) {
                  return "status-active";
                } else {
                  //view only
                  return "viewOnly";
                }
              }
            } else {
              if (this.submissionStatusIsActive) {
                return "status-active";
              } else {
                //view only
                return "viewOnly";
              }
            }
        }
      } else if (this.submissionStatusIsDraft) {
        this.showPortfolioManagementTab = false;
        return "hideTab viewOnly";
      } else if (this.submissionStatusIsComplete) {
        this.showPortfolioManagementTab = true;
        return "viewOnly";
      } else if (this.submissionStatusIsRejected) {
        this.showPortfolioManagementTab = true;
        return "viewOnly";
      }
      //rules for view all - supplier user
      else if (
        this.showSubmissionForSupplierUser ||
        this.showSubmissionInReadOnly
      ) {
        this.showPortfolioManagementTab = false;
        return "hideTab";
      }
    },
    regulatoryAffairsEditAccess() {
      if (this.submissionStatusIsActive) {
        switch (window.$cookies.get("ni_key").roleKey) {
          case 1:
          case 2:
            this.showRegulatoryAffairsTab = false;
            return "hideTab";
          case 3:
          case 4:
          case 5:
            this.showRegulatoryAffairsTab = true;
            this.showReworkButton = true;
            this.showStatusActionButtons = true;
            if (this.fromTable === "View All Submissions") {
              if (this.canUserEdit) {
                return "status-active";
              } else {
                return "viewOnly";
              }
            } else {
              return "status-active";
            }
          case 6:
            //edit access
            this.showRegulatoryAffairsTab = true;
            return "viewOnly";
        }
      } else if (
        this.submissionStatusIsDraft ||
        this.submissionStatusIsReworkForPM
      ) {
        this.showRegulatoryAffairsTab = false;
        return "hideTab";
      } else if (this.submissionStatusIsComplete) {
        this.showRegulatoryAffairsTab = true;
        return "viewOnly";
      } else if (this.submissionStatusIsRejected && this.nbrOfTabs === 3) {
        //check if noTabs === 3
        this.showRegulatoryAffairsTab = true;
        return "viewOnly";
      } else if (this.submissionStatusIsRejected && this.nbrOfTabs === 4) {
        //check if noTabs === 3
        this.showRegulatoryAffairsTab = true;
        return "viewOnly";
      }
      if (this.showSubmissionForSupplierUser) {
        this.showRegulatoryAffairsTab = false;
        return "hideTab";
      }
    },
    productServicesEditAccess() {
      if (this.submissionStatusIsActive) {
        switch (window.$cookies.get("ni_key").roleKey) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            //tab is not visible
            window.isSubmissionActiveForPS = false;
            this.showProductServicesTab = false;
            this.showReworkButton = false;
            return "hideTab";
          case 6:
            //edit access
            this.showProductServicesTab = true;
            this.showStatusActionButtons = true;
            this.showReworkButton = true;
            if (this.fromTable === "View All Submissions") {
              if (this.canUserEdit) {
                window.isSubmissionActiveForPS = true;
                return "status-active";
              } else {
                window.isSubmissionActiveForPS = false;
                return "viewOnly";
              }
            } else {
              window.isSubmissionActiveForPS = true;
              return "status-active";
            }
        }
      } else if (
        this.submissionStatusIsDraft ||
        this.submissionStatusIsReworkForPM
      ) {
        this.showProductServicesTab = false;
        return "hideTab";
      } else if (this.submissionStatusIsComplete) {
        this.showProductServicesTab = true;
        return "viewOnly";
      } else if (this.submissionStatusIsRejected && this.nbrOfTabs === 3) {
        //check if noTabs === 3
        this.showProductServicesTab = true;
        return "viewOnly";
      } else if (this.submissionStatusIsRejected && this.nbrOfTabs === 4) {
        //check if noTabs === 3
        this.showProductServicesTab = true;
        return "viewOnly";
      }
      if (this.showSubmissionForSupplierUser) {
        if (window.showPSTabInReadOnly) {
          this.showProductServicesTab = true;
          return "viewOnly";
        } else {
          this.showProductServicesTab = false;
          return "hideTab";
        }
      }
    },
    exitForm: function() {
      this.$buefy.dialog.confirm({
        message: "Do you want to exit the form?",
        cancelText: "No",
        confirmText: "Yes",
        type: "is-success",
        onConfirm: () => window.close()
      });
    },
    // eslint-disable-next-line no-unused-vars
    isApiErrorField(errorFieldNames, className, value) {
      if (!window.rowCreated) {
        if (errorFieldNames && errorFieldNames.length > 0) {
          for (var i = 0; i < errorFieldNames.length; i++) {
            if (
              errorFieldNames[i].columnName.replace(/_/g, "").toLowerCase() ===
              className.toLowerCase()
            ) {
              return "is-danger";
            }
          }
        } else {
          return "";
        }
      }
    },
    isFieldEditable() {
      if (this.loginRole === 6 && this.submissionStatusIsActive) {
        return "edit-pkg-sz-fields";
      }
    },
    loadSubmissionView(submissionView) {
      if (submissionView === "Submission Detail") {
        this.showSubmissionDetail = true;
        this.showRegulatoryDetails = false;
        this.showItemDetail = false;
      } else {
        this.showItemDetail = true;
        this.showSubmissionDetail = false;
        //setting active tabs based on login role only if the submissions are opened from "My Submission Queue"
        if (this.loginRole === 1 || this.loginRole === 2) {
          if (
            (this.submissionStatusIsActive ||
              this.submissionStatusIsReworkForPM) &&
            this.canUserEdit
          ) {
            var pmRowsCount = document.querySelector(
              ".ni-app-portfolio-management-tbody"
            ).rows.length;
            if (pmRowsCount === 0) {
              this.activeTab = 2;
            } else {
              //if fcatSugSeries is changed
              if (window.reloadPMData === true) {
                //reload PM Tab
                this.canLoadPortfolioManagementData = {
                  loadDetails: true,
                  generalQuestionRows: this.rows,
                  actions: {
                    fErrors: this.filterMapPMErrors
                  },
                  paginationParams: {
                    pageIndex: this.pmPageIndex,
                    numberOfPMItems: this.numberOfPMItems
                  }
                };
                window.reloadPMData = false;
              }
            }
          } else {
            this.loadItemDetailsUnderSubmission();
          }
        } else if (
          this.loginRole === 3 ||
          this.loginRole === 4 ||
          this.loginRole === 5
        ) {
          if (this.submissionStatusIsActive && this.canUserEdit) {
            this.activeTab = 3;
          } else {
            this.loadItemDetailsUnderSubmission();
          }
        } else if (this.loginRole === 6) {
          if (this.submissionStatusIsActive && this.canUserEdit) {
            this.activeTab = 4;
          } else {
            this.loadItemDetailsUnderSubmission();
          }
        }
        //load GI,RI tab for suppliers
        else if (this.loginRole === 0) {
          if (this.activeTab === 0) {
            var giRowsCount = document.querySelector(
              ".ni-app-general-info-tbody"
            ).rows.length;
            if (giRowsCount === 0) {
              this.loadItemDetailsUnderSubmission();
            } else if (window.reloadSupplierTab) {
              this.loadItemDetailsUnderSubmission();
            }
          } else if (this.activeTab === 1) {
            var riRowsCount = document.querySelector(
              ".ni-app-regulatory-info-tbody"
            ).rows.length;
            if (riRowsCount === 0) {
              this.canLoadRegulatoryInformationData = {
                loadDetails: true,
                generalQuestionRows: this.rows,
                actions: {
                  fErrors: this.filterMapRIErrors,
                  fCategory: this.filterMapCategory,
                  fProp65: this.filterMapProp65,
                  fMedDevice: this.filterMapMedDevice,
                  soField: this.sortMapRegulatoryField,
                  soOrder: this.sortMapRegulatorySelectedOrder,
                  srFieldName: this.searchMapRegulatoryField,
                  srValue: this.searchMapRegulatoryInput
                },
                paginationParams: {
                  pageIndex: this.regulatoryPageIndex,
                  numberOfRegulatoryItems: this.numberOfRegulatoryItems
                }
              };
            } else if (window.reloadSupplierTab) {
              this.canLoadRegulatoryInformationData = {
                loadDetails: true,
                generalQuestionRows: this.rows,
                actions: {
                  fErrors: this.filterMapRIErrors,
                  fCategory: this.filterMapCategory,
                  fProp65: this.filterMapProp65,
                  fMedDevice: this.filterMapMedDevice,
                  soField: this.sortMapRegulatoryField,
                  soOrder: this.sortMapRegulatorySelectedOrder,
                  srFieldName: this.searchMapRegulatoryField,
                  srValue: this.searchMapRegulatoryInput
                },
                paginationParams: {
                  pageIndex: this.regulatoryPageIndex,
                  numberOfRegulatoryItems: this.numberOfRegulatoryItems
                }
              };
            }
          }
          //set reloadSupplierTab to default
          window.reloadSupplierTab = false;
        }
      }
    },
    rowsToMarkApprovedOrRejected(value) {
      this.selectedRows = value;
    },
    createNewSubmission() {
      var submissionFormScope = this;
      var args = {};
      args.headers = {
        "content-type": "application/json"
      };
      var usaVnsList = [];
      var requestPayload = {};
      var userData = JSON.parse(sessionStorage.getItem("se_ni_user"));
      requestPayload.createdBy = userData.networkId;
      requestPayload.suppNbr = userData.supplierId;
      requestPayload.suppName = userData.supplierName;
      requestPayload.nameUser = userData.nameUser;

      this.showCreateButtons = true;
      this.showActions = true;

      submissionFormScope.isLoading = true;
      submissionFormScope.$http
        .post(
          `${process.env.VUE_APP_API_BASE_DOMAIN}createNewItemSubmission`,
          requestPayload,
          args
        )
        .then(function(response) {
          submissionFormScope.isLoading = false;
          submissionFormScope.showActions = true;
          var submissionDetails = response.data;
          // submissionFormScope.from = tableView;
          submissionFormScope.submissionStatusIsActive = false;
          submissionFormScope.formType = "Create New Submission";
          submissionFormScope.submissionID = submissionDetails.nbrNewItemCrKey;
          submissionFormScope.showCreateButtons = true;
          submissionFormScope.showApproveButtons = false;
          // submissionFormScope.submissionStatusIsDraft = true;
          submissionFormScope.showSubmissionForSupplierUser = true;
          submissionFormScope.showReworkButton = false;
          submissionFormScope.$nextTick(function() {
            submissionFormScope.openCurrentSubmission(
              submissionFormScope.submissionID
            );
          });
          sessionStorage.removeItem("createRequestFromSe");
        })
        .catch(function(error) {
          submissionFormScope.isLoading = false;
          sessionStorage.removeItem("createRequestFromSe");
          window.$cookies.remove("createSubmission");
          submissionFormScope.$buefy.dialog.alert({
            message: `A problem occured with Create New Submission. Please clear the cache and try again. If problem persists, please contact the New Item Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger",
            onConfirm: () => window.close()
          });
        });
    },
    openCurrentSubmission(submissionId) {
      var submissionFormScope = this;
      // var submissionId = window.$cookies.get("editSubmissionId");
      var usaVnsList = [];
      var currentUser = "";
      if (JSON.parse(sessionStorage.getItem("se_ni_user"))) {
        currentUser = JSON.parse(sessionStorage.getItem("se_ni_user"))
          .networkId;
        JSON.parse(sessionStorage.getItem("se_ni_user")).userType !==
        "fs-external"
          ? (this.showInternalVNs = true)
          : (this.showInternalVNs = false);
      } else {
        currentUser = window.$cookies.get("ni_key").networkId;
        this.showInternalVNs = true;
      }
      var userData = JSON.parse(sessionStorage.getItem("se_ni_user"));

      if (userData) {
        this.showCreateButtons = true;
        this.showActions = true;
        //check if user from SE is internal
        if (!this.showInternalVNs) {
          //display only USA VN#s
          var vnListWithSupplier = userData.vnList;
          for (var vn in vnListWithSupplier) {
            if (vnListWithSupplier[vn].indexOf("VN") !== -1) {
              usaVnsList.push(vnListWithSupplier[vn]);
            }
          }
        }
      } else {
        //check if app user is internal
        var internalUser = window.$cookies.get("ni_key").internalUser;
        if (internalUser === "Y") {
          this.showCreateButtons = false;
          this.showActions = true;
          this.showReworkButton = true;
        }
      }
      submissionFormScope.isLoading = true;

      submissionFormScope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}getsupplierinfo/submissionId/${submissionId}/${currentUser}`
        )
        .then(function(response) {
          submissionFormScope.isLoading = false;
          var submissionDetails = response.data;
          //assign form data
          submissionFormScope.assignResponseDataToSupplierForm(response);
          if (
            window.$cookies.isKey("fromTable") &&
            window.$cookies.isKey("ni_key")
          ) {
            submissionFormScope.showFromTable = true;
            submissionFormScope.fromTable = window.$cookies.get("fromTable");
          } else {
            submissionFormScope.showFromTable = false;
          }
          submissionFormScope.formType = "Submission";
          submissionFormScope.submissionID = submissionId;
          if (!submissionFormScope.showInternalVNs) {
            submissionFormScope.vnList = usaVnsList;
          }
          if (submissionDetails.nextApproverName) {
            submissionFormScope.showNextApprover = true;
            submissionFormScope.nextApproverName =
              submissionDetails.nextApproverName;
          } else {
            submissionFormScope.showNextApprover = false;
          }
          submissionFormScope.canUserEdit = response.data.canEdit;
          if (window.$cookies.get("ni_key")) {
            submissionFormScope.showForInternalUserOnly = true;
            if (submissionFormScope.fromTable === "View All Submissions") {
              submissionFormScope.showSubmissionInReadOnly = true;
              switch (submissionDetails.status) {
                case "A":
                  submissionFormScope.submissionStatusIsActive = true;
                  submissionFormScope.submissionStatusIsDraft = false;
                  submissionFormScope.submissionStatusIsRejected = false;
                  submissionFormScope.submissionStatusIsReworkForPM = false;
                  submissionFormScope.submissionStatusIsComplete = false;
                  break;
                case "R":
                  submissionFormScope.submissionStatusIsActive = false;
                  submissionFormScope.submissionStatusIsDraft = false;
                  submissionFormScope.submissionStatusIsRejected = true;
                  submissionFormScope.submissionStatusIsReworkForPM = false;
                  submissionFormScope.submissionStatusIsComplete = false;
                  submissionFormScope.nbrOfTabs = submissionDetails.nbrOfTabs;
                  break;
                case "D":
                case "W1":
                case "N":
                  submissionFormScope.submissionStatusIsActive = false;
                  submissionFormScope.submissionStatusIsDraft = true;
                  submissionFormScope.submissionStatusIsRejected = false;
                  submissionFormScope.submissionStatusIsReworkForPM = false;
                  submissionFormScope.submissionStatusIsComplete = false;
                  break;
                case "W2":
                  submissionFormScope.submissionStatusIsActive = false;
                  submissionFormScope.submissionStatusIsDraft = false;
                  submissionFormScope.submissionStatusIsRejected = false;
                  submissionFormScope.submissionStatusIsReworkForPM = true;
                  submissionFormScope.submissionStatusIsComplete = false;
                  break;
                case "U":
                case "P":
                  submissionFormScope.submissionStatusIsActive = false;
                  submissionFormScope.submissionStatusIsDraft = false;
                  submissionFormScope.submissionStatusIsRejected = false;
                  submissionFormScope.submissionStatusIsReworkForPM = false;
                  submissionFormScope.submissionStatusIsComplete = true;
                  break;
              }
            } else {
              if (submissionDetails.status === "A") {
                submissionFormScope.submissionStatusIsActive = true;
                submissionFormScope.submissionStatusIsDraft = false;
                submissionFormScope.submissionStatusIsRejected = false;
                submissionFormScope.submissionStatusIsReworkForPM = false;
                submissionFormScope.submissionStatusIsComplete = false;
                submissionFormScope.showSubmissionInReadOnly = false;
              }
              if (submissionDetails.status === "W2") {
                submissionFormScope.submissionStatusIsActive = false;
                submissionFormScope.submissionStatusIsDraft = false;
                submissionFormScope.submissionStatusIsRejected = false;
                submissionFormScope.submissionStatusIsReworkForPM = true;
                submissionFormScope.submissionStatusIsComplete = false;
                submissionFormScope.showSubmissionInReadOnly = false;
              }
            }
          } else if (sessionStorage.getItem("se_ni_user")) {
            submissionFormScope.showSubmissionForSupplierUser = true;
            if (
              submissionDetails.status === "P" ||
              submissionDetails.status === "R"
            ) {
              window.showPSTabInReadOnly = true;
            }
          }
          //PM edit access on submission level details
          if (
            submissionDetails.status === "D" &&
            submissionFormScope.loginRole === 2 &&
            window.$cookies.get("ni_key").nameUser ===
              submissionDetails.internalPM
          ) {
            submissionFormScope.canPmEditSupplierEntry = true;
          } else {
            submissionFormScope.canPmEditSupplierEntry = false;
          }

          //if user in not from SEP and is NI user only with internalUser Y
          if (!userData && internalUser === "Y") {
            submissionFormScope.showCreateButtons = false;
            submissionFormScope.showApproveButtons = true;
            submissionFormScope.showActions = true;
            submissionFormScope.showReworkButton = true;
          }
          window.$cookies.remove("submissionObj");
          window.$cookies.remove("fromTable");
          sessionStorage.removeItem("editRequestFromSe");
          submissionFormScope.validateErrorObj = {
            validateValue: response.data.validateForm,
            errorCount: response.data.errorCount
          };
          submissionFormScope.$nextTick(function() {
            submissionFormScope.validateSubmitWrtErrorCountAndRoles();
          });
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          submissionFormScope.isLoading = false;
          window.$cookies.remove("submissionObj");
          sessionStorage.removeItem("editRequestFromSe");
          submissionFormScope.$buefy.dialog.alert({
            message: `Failed to load submission details. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger",
            onConfirm: () =>
              submissionFormScope.$emit("toggleSubmissionView", true)
          });
        });
    },
    //checked on load/edits of supplier form feilds
    validateSubmitWrtErrorCountAndRoles() {
      var supplierRequiredFieldsObjMap = {},
        supplierRequiredPMFieldsObjMap = {},
        scope = this;

      supplierRequiredPMFieldsObjMap = {
        key1: scope.priority,
        key2: scope.busUnit,
        key3: scope.fcatSugSeries
      };
      if (
        scope.fcatSugSeries === "Prefix to VCAT" ||
        scope.fcatSugSeries === "Suffix to VCAT"
      ) {
        supplierRequiredPMFieldsObjMap.key5 = scope.prefixSuffix;
      } else if (scope.fcatSugSeries === "Other") {
        supplierRequiredPMFieldsObjMap.key6 = scope.fcatOther;
      }
      if (scope.isUser3P) {
        supplierRequiredFieldsObjMap = {
          key1: scope.vn,
          key2: scope.vnName,
          key3: scope.website,
          key4: scope.submissionDesc,
          key5: scope.prodContactName,
          key6: scope.prodContactEmail,
          key7: scope.regContactName,
          key8: scope.regContactPhone,
          key9: scope.regContactEmail
        };
      } else {
        supplierRequiredFieldsObjMap = {
          key1: scope.vn,
          key2: scope.vnName,
          key3: scope.website,
          key4: scope.submissionDesc,
          key5: scope.prodContactName,
          key6: scope.prodContactEmail,
          key7: scope.launchDate,
          key8: scope.regContactName,
          key9: scope.regContactPhone,
          key10: scope.regContactEmail,
          key11: scope.qualContactName,
          key12: scope.qualContactPhone,
          key13: scope.qualContactEmail,
          key14: scope.tradeContactName,
          key15: scope.tradeContactPhone,
          key16: scope.tradeContactEmail,
          key17: scope.transContactName,
          key18: scope.transContactPhone,
          key19: scope.transContactEmail
        };
      }

      for (var index in supplierRequiredFieldsObjMap) {
        if (
          supplierRequiredFieldsObjMap[index] &&
          supplierRequiredFieldsObjMap[index] !== "" &&
          supplierRequiredFieldsObjMap[index] !== " " &&
          supplierRequiredFieldsObjMap[index] !== undefined &&
          supplierRequiredFieldsObjMap[index] !== null
        ) {
          //check if all entries have value
          var isSupplierReqFieldsValid = true;
        } else {
          var isSupplierReqFieldsValid = false;
          break;
        }
      }

      for (var key in supplierRequiredPMFieldsObjMap) {
        if (
          supplierRequiredPMFieldsObjMap[key] &&
          supplierRequiredPMFieldsObjMap[key] !== "" &&
          supplierRequiredPMFieldsObjMap[key] !== " " &&
          supplierRequiredPMFieldsObjMap[key] !== undefined &&
          supplierRequiredPMFieldsObjMap[key] !== null
        ) {
          //check if all entries have value
          var isSupplierPMReqFieldsValid = true;
        } else {
          var isSupplierPMReqFieldsValid = false;
          break;
        }
      }

      //role based submit btn validation
      switch (scope.loginRole) {
        case 0:
          scope.validateErrorObj.validateValue === "Y" &&
          scope.validateErrorObj.errorCount === 0 &&
          isSupplierReqFieldsValid
            ? (scope.disableCreatorSubmit = false)
            : (scope.disableCreatorSubmit = true);
          break;
        case 1:
          scope.enableApproverSubmit();
          break;
        case 2:
          scope.validateErrorObj.validateValue === "Y" &&
          scope.validateErrorObj.errorCount === 0 &&
          scope.vn &&
          scope.vn.trim() !== "" &&
          scope.vnName &&
          scope.vnName.trim() !== "" &&
          isSupplierPMReqFieldsValid
            ? scope.enableApproverSubmit()
            : scope.disableApproverSubmit();
          break;
        case 3:
        case 4:
        case 5:
          scope.validateErrorObj.validateValue === "Y" &&
          scope.validateErrorObj.errorCount === 0
            ? scope.enableApproverSubmit()
            : scope.disableApproverSubmit();
        case 6:
          //submit must be disabled for super user on load from Queue
          scope.validateErrorObj.validateValue === "Y" &&
          scope.validateErrorObj.errorCount === 0 &&
          scope.supplierErrorCount === 0
            ? scope.enableApproverSubmit()
            : scope.disableApproverSubmit();
          break;
      }
    },
    assignResponseDataToSupplierForm(response) {
      var submissionFormScope = this;
      var submissionDetails = response.data;
      submissionFormScope.vn = submissionDetails.vn;
      submissionFormScope.vnName = submissionDetails.vnName;
      submissionFormScope.website = submissionDetails.website;
      submissionFormScope.submissionDesc = submissionDetails.submissionDesc;
      submissionFormScope.createdBy = submissionDetails.createdBy;
      submissionFormScope.createdDate = submissionDetails.createDate;
      submissionFormScope.isUser3P = submissionDetails.user3P;
      submissionFormScope.supplierErrorCount =
        submissionDetails.supplierErrorCount;
      submissionFormScope.prodContactName = submissionDetails.prodContactName;
      submissionFormScope.prodContactEmail = submissionDetails.prodContactEmail;
      submissionFormScope.regContactName = submissionDetails.regContactName;
      submissionFormScope.regContactPhone = submissionDetails.regContactPhone;
      submissionFormScope.regContactEmail = submissionDetails.regContactEmail;
      submissionFormScope.qualContactName = submissionDetails.qualContactName;
      submissionFormScope.qualContactPhone = submissionDetails.qualContactPhone;
      submissionFormScope.qualContactEmail = submissionDetails.qualContactEmail;
      submissionFormScope.tradeContactName = submissionDetails.tradeContactName;
      submissionFormScope.tradeContactPhone =
        submissionDetails.tradeContactPhone;
      submissionFormScope.tradeContactEmail =
        submissionDetails.tradeContactEmail;
      submissionFormScope.transContactName = submissionDetails.transContactName;
      submissionFormScope.transContactPhone =
        submissionDetails.transContactPhone;
      submissionFormScope.transContactEmail =
        submissionDetails.transContactEmail;
      submissionFormScope.supplierComments = submissionDetails.supplierComments;
      submissionFormScope.suppRewrkReason = submissionDetails.suppRewrkReason;
      submissionFormScope.isFirstApprover = submissionDetails.firstApproverFlag;
      submissionFormScope.createdDate = submissionFormScope.createdDate
        .replace("T", " ")
        .split(".")[0];

      //PM header fields
      submissionFormScope.internalComments = submissionDetails.internalComments;
      submissionFormScope.internalRewrkReason =
        submissionDetails.internalRewrkReason;
      submissionFormScope.priority = submissionDetails.priority;
      submissionFormScope.busUnit = submissionDetails.busUnit;
      submissionFormScope.promotion = submissionDetails.promotion;
      submissionFormScope.fcatSugSeries = submissionDetails.fcatSugSeries;
      //fcatSugSeries logic for user3P
      if (
        submissionFormScope.isUser3P &&
        (submissionFormScope.loginRole === 1 ||
          submissionFormScope.loginRole === 2)
      ) {
        submissionFormScope.fcatSugSeries === undefined ||
        submissionFormScope.fcatSugSeries === "" ||
        submissionFormScope.fcatSugSeries === " "
          ? (submissionFormScope.fcatSugSeries = "50-")
          : "";
      }
      submissionFormScope.fcatOther = submissionDetails.fcatOther;
      submissionFormScope.prodCount = submissionDetails.prodCount;
      if (submissionDetails.launchDate) {
        submissionFormScope.launchDate = new Date(submissionDetails.launchDate);
      }
      submissionFormScope.prodLineDesc = submissionDetails.prodLineDesc;
      submissionFormScope.approverEmail = submissionDetails.prodContactEmail;
      submissionFormScope.prefixSuffix = submissionDetails.prefixSuffix;
    },
    reloadSupplierFormData() {
      var submissionFormScope = this;
      var currentUser = "";
      if (JSON.parse(sessionStorage.getItem("se_ni_user"))) {
        currentUser = JSON.parse(sessionStorage.getItem("se_ni_user"))
          .networkId;
      } else if (window.$cookies.get("ni_key")) {
        currentUser = window.$cookies.get("ni_key").networkId;
      }

      submissionFormScope.isLoading = true;
      submissionFormScope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}getsupplierinfo/submissionId/${submissionFormScope.submissionID}/${currentUser}`
        )
        .then(function(response) {
          submissionFormScope.isLoading = false;
          submissionFormScope.assignResponseDataToSupplierForm(response);

          //update nextApproverName on vnChange for Roles 1 & 2
          if (
            response.data.nextApproverName &&
            (submissionFormScope.loginRole === 1 ||
              submissionFormScope.loginRole === 2)
          ) {
            submissionFormScope.nextApproverName =
              response.data.nextApproverName;
          }

          submissionFormScope.validateErrorObj = {
            validateValue: response.data.validateForm,
            errorCount: response.data.errorCount
          };
          //role based submit btn validation
          submissionFormScope.validateSubmitWrtErrorCountAndRoles();
        })
        .catch(function(error) {
          submissionFormScope.isLoading = false;
          submissionFormScope.$buefy.dialog.alert({
            message: `Failed to load submission details. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    fetchVendorIds(search, loading) {
      if (search.length > 3) {
        var submissionFormScope = this;

        loading(true);
        submissionFormScope.$http
          .get(
            `${process.env.VUE_APP_API_BASE_DOMAIN}submissionDetail/vendorNumbers/${search}`
          )
          .then(function(response) {
            loading(false);
            submissionFormScope.vendorIds = response.data;
          })
          // eslint-disable-next-line no-unused-vars
          .catch(function(error) {
            loading(false);
            submissionFormScope.$buefy.dialog.alert({
              message: `Failed to load Vendor Numbers matching search criteria. Please enter valid Vendor Numbers and/or clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
              confirmText: "OK",
              type: "is-danger"
            });
          });
      }
    },
    fetchCountryOrigin(search, loading) {
      if (search.length > 0) {
        var submissionFormScope = this;

        loading(true);
        submissionFormScope.$http
          .get(
            `${process.env.VUE_APP_API_BASE_DOMAIN}loadCountryCodes/${search}`
          )
          .then(function(response) {
            loading(false);
            submissionFormScope.countryOriginOptions = response.data;
          })
          // eslint-disable-next-line no-unused-vars
          .catch(function(error) {
            loading(false);
            submissionFormScope.$buefy.dialog.alert({
              message: `Failed to load Country of Origin matching search criteria. Please enter valid Country of Origin and/or clear the cache and try again. If the problem persists, please contact the New Item Support at NewItem.IT.Support@thermofisher.com`,
              confirmText: "OK",
              type: "is-danger"
            });
          });
      }
    },
    uploadItemSubmission() {
      var submissionFormScope = this;
      var networkId = JSON.parse(sessionStorage.getItem("se_ni_user"))
        .networkId;
      var isUploadFormatValid = /^.*\.(xls|xlsx)$/.test(
        submissionFormScope.file.name
      );
      if (isUploadFormatValid) {
        submissionFormScope.showValidationErrorMessage = false;
        submissionFormScope.validationErrorDescription = "";

        var args = {
          headers: {
            "content-type": "multipart/form-data"
          }
        };
        var uploadData = new FormData();
        uploadData.append("file", submissionFormScope.file);

        submissionFormScope.isLoading = true;
        submissionFormScope.$http
          .post(
            `${process.env.VUE_APP_API_BASE_DOMAIN}excel/uploadItemSubmissions?nbrNewItemCrKey=${submissionFormScope.submissionID}&networkId=${networkId}`,
            uploadData,
            args
          )
          .then(function(response) {
            submissionFormScope.isLoading = false;
            submissionFormScope.file = null;
            if (submissionFormScope.vcatRequired) {
              submissionFormScope.vcatRequired = false;
              submissionFormScope.tooltipIndex = "";
            }
            if (response.data.toLowerCase() === "background") {
              submissionFormScope.$buefy.dialog.alert({
                message: `File is being processed for upload in the background. You will be notified via email once it is complete.`,
                confirmText: "OK",
                type: "is-success",
                onConfirm: () => window.close()
              });
            } else if (response.data.toLowerCase() === "failure") {
              submissionFormScope.$buefy.dialog.alert({
                message: `A problem occurred with the upload file used. Please remove any special characters or extra line breaks on the description fields and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
                confirmText: "OK",
                type: "is-danger"
              });
            } else {
              submissionFormScope.$buefy.dialog.alert({
                message: `Upload successful for Submission - ${submissionFormScope.submissionID}.`,
                confirmText: "OK",
                type: "is-success",
                onConfirm: () => (
                  (window.uploadComplete = true),
                  //reset GI filter for upload callback
                  submissionFormScope.resetInputs(),
                  submissionFormScope.loadItemDetailsUnderSubmission(),
                  //reset RI filter for upload callback
                  submissionFormScope.resetRegulatoryInputs(),
                  submissionFormScope.checkRIFilterCriteria(),
                  (submissionFormScope.canLoadRegulatoryInformationData = {
                    loadDetails: true,
                    generalQuestionRows: submissionFormScope.rows,
                    actions: {
                      fErrors: submissionFormScope.filterMapRIErrors,
                      fCategory: submissionFormScope.filterMapCategory,
                      fProp65: submissionFormScope.filterMapProp65,
                      fMedDevice: submissionFormScope.filterMapMedDevice,
                      soField: submissionFormScope.sortMapRegulatoryField,
                      soOrder:
                        submissionFormScope.sortMapRegulatorySelectedOrder,
                      srFieldName: submissionFormScope.searchMapRegulatoryField,
                      srValue: submissionFormScope.searchMapRegulatoryInput
                    },
                    paginationParams: {
                      pageIndex: submissionFormScope.regulatoryPageIndex,
                      numberOfRegulatoryItems:
                        submissionFormScope.numberOfRegulatoryItems
                    }
                  })
                )
              });
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch(function(error) {
            submissionFormScope.isLoading = false;
            if (error.response.status === 400) {
              submissionFormScope.$buefy.dialog.alert({
                message: error.response.data,
                confirmText: "OK",
                type: "is-danger"
              });
            } else {
              submissionFormScope.$buefy.dialog.alert({
                message: `A problem occurred with the upload file used. Please remove any special characters or extra line breaks on the description fields and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
                confirmText: "OK",
                type: "is-danger"
              });
            }
          });
      } else {
        submissionFormScope.showValidationErrorMessage = true;
        submissionFormScope.validationErrorDescription = `${submissionFormScope.file.name} - Invalid file type, system accepts only .xls(x) extension.`;
      }
    },
    updateRegulatoryPaginationWrapper(params) {
      params.startIndex
        ? (this.regulatoryMinPageIndex = params.startIndex)
        : (this.regulatoryMinPageIndex = 0);
      params.endIndex !== undefined
        ? (this.regulatoryMaxPageIndex = params.endIndex)
        : (this.regulatoryMaxPageIndex = 0);
      params.totalCount !== undefined
        ? (this.regulatoryTotalResults = params.totalCount)
        : (this.totalResults = 0);
      params.totalPages !== undefined
        ? (this.regulatoryTotalPages = params.totalPages)
        : (this.regulatoryTotalPages = 0);
      if (params.startIndex <= 1) {
        this.regulatoryShowPreviousButton = false;
        this.regulatoryShowFirstButton = false;
      } else {
        this.regulatoryShowPreviousButton = true;
        this.regulatoryShowFirstButton = true;
      }
      if (this.regulatoryPageIndex >= this.regulatoryTotalPages) {
        this.regulatoryShowNextButton = false;
        this.regulatoryShowLastButton = false;
      } else {
        this.regulatoryShowNextButton = true;
        this.regulatoryShowLastButton = true;
      }
    },
    updatePMPaginationWrapper(params) {
      params.startIndex
        ? (this.pmMinPageIndex = params.startIndex)
        : (this.pmMinPageIndex = 0);
      params.endIndex !== undefined
        ? (this.pmMaxPageIndex = params.endIndex)
        : (this.pmMaxPageIndex = 0);
      params.totalCount !== undefined
        ? (this.pmTotalResults = params.totalCount)
        : (this.totalResults = 0);
      params.totalPages !== undefined
        ? (this.pmTotalPages = params.totalPages)
        : (this.pmTotalPages = 0);
      if (params.startIndex <= 1) {
        this.pmShowPreviousButton = false;
        this.pmShowFirstButton = false;
      } else {
        this.pmShowPreviousButton = true;
        this.pmShowFirstButton = true;
      }
      if (this.pmPageIndex >= this.pmTotalPages) {
        this.pmShowNextButton = false;
        this.pmShowLastButton = false;
      } else {
        this.pmShowNextButton = true;
        this.pmShowLastButton = true;
      }
    },
    updatePSPaginationWrapper(params) {
      params.startIndex
        ? (this.psMinPageIndex = params.startIndex)
        : (this.psMinPageIndex = 0);
      params.endIndex !== undefined
        ? (this.psMaxPageIndex = params.endIndex)
        : (this.psMaxPageIndex = 0);
      params.totalCount !== undefined
        ? (this.psTotalResults = params.totalCount)
        : (this.totalResults = 0);
      params.totalPages !== undefined
        ? (this.psTotalPages = params.totalPages)
        : (this.psTotalPages = 0);
      if (params.startIndex <= 1) {
        this.psShowPreviousButton = false;
        this.psShowFirstButton = false;
      } else {
        this.psShowPreviousButton = true;
        this.psShowFirstButton = true;
      }
      if (this.psPageIndex >= this.psTotalPages) {
        this.psShowNextButton = false;
        this.psShowLastButton = false;
      } else {
        this.psShowNextButton = true;
        this.psShowLastButton = true;
      }
    },
    updateRAPaginationWrapper(params) {
      params.startIndex
        ? (this.raMinPageIndex = params.startIndex)
        : (this.raMinPageIndex = 0);
      params.endIndex !== undefined
        ? (this.raMaxPageIndex = params.endIndex)
        : (this.raMaxPageIndex = 0);
      params.totalCount !== undefined
        ? (this.raTotalResults = params.totalCount)
        : (this.totalResults = 0);
      params.totalPages !== undefined
        ? (this.raTotalPages = params.totalPages)
        : (this.raTotalPages = 0);
      if (params.startIndex <= 1) {
        this.raShowPreviousButton = false;
        this.raShowFirstButton = false;
      } else {
        this.raShowPreviousButton = true;
        this.raShowFirstButton = true;
      }
      if (this.raPageIndex >= this.raTotalPages) {
        this.raShowNextButton = false;
        this.raShowLastButton = false;
      } else {
        this.raShowNextButton = true;
        this.raShowLastButton = true;
      }
    },
    downloadImageAttachment(imageAttachmentName, genlQstnId) {
      var submissionFormScope = this;
      submissionFormScope.isLoading = true;
      submissionFormScope
        .$http({
          url: `${process.env.VUE_APP_API_BASE_DOMAIN}downloadImageAttachment?genlQstnId=${genlQstnId}`,
          method: "GET",
          responseType: "blob"
        })
        .then(function(response) {
          submissionFormScope.isLoading = false;
          var url = window.URL.createObjectURL(new Blob([response.data]));
          var link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", imageAttachmentName);
          document.body.appendChild(link);
          link.click();
        })
        .catch(function(error) {
          submissionFormScope.isLoading = false;
          submissionFormScope.$buefy.dialog.alert({
            message: `A problem occurred with file download. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    uploadImageAttachment(file, genlQstnId) {
      var submissionFormScope = this;
      var isUploadValid = /^.*\.(pdf|png|jpg|eps|tiff)$/.test(
        file.name.toLowerCase()
      );
      if (isUploadValid) {
        var args = {
          headers: {
            "content-type": "multipart/form-data"
          }
        };
        var uploadData = new FormData();
        uploadData.append(
          "imageAttachment",
          submissionFormScope.imageAttachment
        );

        submissionFormScope.isLoading = true;
        submissionFormScope.$http
          .post(
            `${process.env.VUE_APP_API_BASE_DOMAIN}uploadItemLevelAttachments?genlQstnId=${genlQstnId}&nbrNewItemCrKey=${submissionFormScope.submissionID}`,
            uploadData,
            args
          )
          // eslint-disable-next-line no-unused-vars
          .then(function(response) {
            submissionFormScope.isLoading = false;
            submissionFormScope.imageAttachment = null;
            submissionFormScope.$buefy.dialog.alert({
              message: `Image Attachment upload successful.`,
              confirmText: "OK",
              type: "is-success",
              onConfirm: () =>
                submissionFormScope.loadItemDetailsUnderSubmission()
            });
          })
          .catch(function(error) {
            submissionFormScope.isLoading = false;
            submissionFormScope.$buefy.dialog.alert({
              message: `A problem occurred with the attachment used. Please ensure attachment has the one of the following extensions: pdf, png, jpg, eps, tiff and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
              confirmText: "OK",
              type: "is-danger",
              onConfirm: () => (submissionFormScope.imageAttachment = null)
            });
          });
      } else {
        submissionFormScope.$buefy.dialog.alert({
          message: `"${file.name}" - Invalid file type, system accepts only pdf, png, jpg, eps, tiff image types.`,
          confirmText: "OK",
          type: "is-danger",
          onConfirm: () => (submissionFormScope.imageAttachment = null)
        });
      }
    },
    deleteImageAttachment(genlQstnId) {
      var submissionFormScope = this;
      submissionFormScope.isLoading = true;
      submissionFormScope
        .$http({
          url: `${process.env.VUE_APP_API_BASE_DOMAIN}deleteImageAttachment?genlQstnId=${genlQstnId}`,
          method: "delete"
        })
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          submissionFormScope.isLoading = false;
          submissionFormScope.$buefy.dialog.alert({
            message: `Delete Attachment action successful.`,
            confirmText: "OK",
            type: "is-success",
            onConfirm: () =>
              submissionFormScope.loadItemDetailsUnderSubmission()
          });
        })
        .catch(function(error) {
          submissionFormScope.isLoading = false;
          submissionFormScope.$buefy.dialog.alert({
            message: `A problem occured with delete operation. Please clear the cache and try again. If the problems persists, please contact the New Item Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    promptReworkComments() {
      var role = window.$cookies.get("ni_key").roleKey;
      if (this.showApproveButtons && role) {
        switch (window.$cookies.get("ni_key").roleKey) {
          case 1:
            this.$buefy.dialog.prompt({
              message: `Supplier Rework Reason`,
              trapFocus: true,
              type: "is-info",
              onConfirm: value => (
                this.suppRewrkReason
                  ? (this.suppRewrkReason = this.suppRewrkReason + "." + value)
                  : (this.suppRewrkReason = value),
                this.saveSubmission(),
                this.submitBySubmissionId("W1")
              )
            });
            break;
          case 2:
            if (
              this.submissionStatusIsReworkForPM ||
              this.submissionStatusIsActive
            ) {
              this.$buefy.dialog.prompt({
                message: `Supplier Rework Reason`,
                trapFocus: true,
                type: "is-info",
                onConfirm: value => (
                  this.suppRewrkReason
                    ? (this.suppRewrkReason =
                        this.suppRewrkReason + "." + value)
                    : (this.suppRewrkReason = value),
                  this.saveSubmission(),
                  this.submitBySubmissionId("W1")
                )
              });
            }
            break;
          case 3:
          case 4:
          case 5:
          case 6:
            this.$buefy.dialog.prompt({
              message: `Internal Rework Reason`,
              trapFocus: true,
              type: "is-info",
              onConfirm: value => (
                this.internalRewrkReason
                  ? (this.internalRewrkReason =
                      this.internalRewrkReason + "." + value)
                  : (this.internalRewrkReason = value),
                this.saveSubmission(),
                this.submitBySubmissionId("W1")
              )
            });
            break;
        }
      }
    },
    showReassignButton() {
      if (this.submissionStatusIsActive || this.submissionStatusIsReworkForPM) {
        switch (window.$cookies.get("ni_key").roleKey) {
          case 1:
            return this.isFirstApprover;
          case 2:
            return this.isFirstApprover;
          case 3:
          case 4:
          case 5:
          case 6:
            return false;
        }
      }
    },
    saveSubmission(event) {
      var submissionFormScope = this;
      var args = {};
      args.headers = {
        "content-type": "application/json"
      };
      var requestPayload = {};
      if (sessionStorage.getItem("se_ni_user")) {
        requestPayload.createdBy = JSON.parse(
          sessionStorage.getItem("se_ni_user")
        ).networkId;
        requestPayload.updatedBy = JSON.parse(
          sessionStorage.getItem("se_ni_user")
        ).networkId;
      } else if (window.$cookies.get("ni_key")) {
        requestPayload.createdBy = window.$cookies.get("ni_key").networkId;
        requestPayload.updatedBy = window.$cookies.get("ni_key").networkId;
      }

      requestPayload.vn = submissionFormScope.vn;
      requestPayload.vnName = submissionFormScope.vnName;
      requestPayload.website = submissionFormScope.website;
      requestPayload.submissionDesc = submissionFormScope.submissionDesc;
      requestPayload.user3P = submissionFormScope.isUser3P;
      requestPayload.prodContactName = submissionFormScope.prodContactName;
      requestPayload.prodContactEmail = submissionFormScope.prodContactEmail;
      requestPayload.regContactName = submissionFormScope.regContactName;
      requestPayload.regContactPhone = submissionFormScope.regContactPhone;
      requestPayload.regContactEmail = submissionFormScope.regContactEmail;
      requestPayload.qualContactName = submissionFormScope.qualContactName;
      requestPayload.qualContactPhone = submissionFormScope.qualContactPhone;
      requestPayload.qualContactEmail = submissionFormScope.qualContactEmail;
      requestPayload.tradeContactName = submissionFormScope.tradeContactName;
      requestPayload.tradeContactPhone = submissionFormScope.tradeContactPhone;
      requestPayload.tradeContactEmail = submissionFormScope.tradeContactEmail;
      requestPayload.transContactName = submissionFormScope.transContactName;
      requestPayload.transContactPhone = submissionFormScope.transContactPhone;
      requestPayload.transContactEmail = submissionFormScope.transContactEmail;
      requestPayload.supplierComments = submissionFormScope.supplierComments;
      requestPayload.suppRewrkReason = submissionFormScope.suppRewrkReason;
      requestPayload.internalComments = submissionFormScope.internalComments;
      requestPayload.internalRewrkReason =
        submissionFormScope.internalRewrkReason;
      requestPayload.priority = submissionFormScope.priority;
      requestPayload.busUnit = submissionFormScope.busUnit;
      requestPayload.promotion = submissionFormScope.promotion;
      requestPayload.fcatSugSeries = submissionFormScope.fcatSugSeries;
      requestPayload.fcatOther = submissionFormScope.fcatOther;
      requestPayload.prodCount = submissionFormScope.prodCount;
      requestPayload.launchDate = submissionFormScope.launchDate;
      requestPayload.prodLineDesc = submissionFormScope.prodLineDesc;
      requestPayload.approverEmail = submissionFormScope.prodContactEmail;
      requestPayload.prefixSuffix = submissionFormScope.prefixSuffix;

      submissionFormScope.isLoading = true;
      submissionFormScope.$http
        .post(
          `${process.env.VUE_APP_API_BASE_DOMAIN}submissionId/${this.submissionID}/updateItemSubmission/${requestPayload.updatedBy}`,
          requestPayload,
          args
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          submissionFormScope.isLoading = false;
          //validate on put supplier api if event from 3p change
          if (event !== undefined && event === "updateVN") {
            submissionFormScope.vn = response.data.vn;
            submissionFormScope.vnName = response.data.vnName;
            submissionFormScope.isUser3P = response.data.user3P;
            submissionFormScope.nextApproverName =
              response.data.nextApproverName;
            submissionFormScope.supplierErrorCount =
              response.data.supplierErrorCount;
            window.reloadPMData = true;
          } else if (event !== undefined && event === "saveLaunchDateOnly") {
          } else {
            submissionFormScope.reloadSupplierFormData();
          }
          //role based submit btn validation
          submissionFormScope.validateSubmitWrtErrorCountAndRoles();
        })
        .catch(function(error) {
          submissionFormScope.isLoading = false;
          if (error.response.status === 400) {
            submissionFormScope.$buefy.dialog.alert({
              message: `The Vendor Number you have selected is not currently valid for new item entry. Please reach out to the Portfolio Manager for further assistance.`,
              confirmText: "OK",
              type: "is-danger"
            });
          } else {
            submissionFormScope.$buefy.dialog.alert({
              message: `A problem occured with Save and Submit operation. Please ensure valid data is entered and try again. If problem persists, please ensure Please contact the New Item Support at NewItem.IT.Support@thermofisher.com`,
              confirmText: "OK",
              type: "is-danger"
            });
          }
        });
    },
    cancelSubmission() {
      this.$buefy.dialog.confirm({
        message: "Are you sure you want to Cancel?",
        cancelText: "No",
        confirmText: "Yes",
        type: "is-success",
        onConfirm: () => this.actOnCurrentSubmission("N")
      });
    },
    submitBySubmissionId(status) {
      if (status === "S" || status === "w1") {
        var submissionFormScope = this;
        var userData = "";
        if (sessionStorage.getItem("se_ni_user")) {
          userData = JSON.parse(sessionStorage.getItem("se_ni_user"));
        } else {
          userData = window.$cookies.get("ni_key");
        }
        submissionFormScope.isLoading = true;
        submissionFormScope.$http
          .get(
            `${process.env.VUE_APP_API_BASE_DOMAIN}validateCasData?nbrNewItemCrKey=${this.submissionID}&nameUser=${userData.networkId}&status=${status}`
          )
          // eslint-disable-next-line no-unused-vars
          .then(function(response) {
            submissionFormScope.isLoading = false;
            submissionFormScope.$buefy.dialog.alert({
              message: `Action on Submission ID - ${submissionFormScope.submissionID} is successful.`,
              confirmText: "OK",
              type: "is-success",
              onConfirm: () => submissionFormScope.closeFormAfterSubmit()
            });
            //submissionFormScope.$emit("toggleSubmissionView", true);
          })
          // eslint-disable-next-line no-unused-vars
          .catch(function(error) {
            submissionFormScope.isLoading = false;
            if (error.response.status === 406) {
              submissionFormScope.getCASRejectedItems(error.response.data);
            } else {
              //undefined check
              if (
                error.response.data === undefined ||
                error.response === undefined ||
                error === undefined
              ) {
                //check submission status
                submissionFormScope.checkSubmissionStatus();
              } else if (error.response.data) {
                submissionFormScope.$buefy.dialog.alert({
                  message: `${error.response.data}`,
                  confirmText: "OK",
                  type: "is-danger"
                });
              }
              //unhandled exceptions
              else {
                //check submission status
                submissionFormScope.checkSubmissionStatus();
              }
            }
          });
      } else {
        var submissionFormScope = this;
        var userData = "";
        if (sessionStorage.getItem("se_ni_user")) {
          userData = JSON.parse(sessionStorage.getItem("se_ni_user"));
        } else {
          userData = window.$cookies.get("ni_key");
        }
        if (
          submissionFormScope.loginRole === 1 &&
          submissionFormScope.validateErrorObj.validateValue === "Y" &&
          submissionFormScope.validateErrorObj.errorCount === 0 &&
          document.querySelectorAll(
            ".portfolio-management-submission-level-div .invalid"
          ).length !== 0
        ) {
          submissionFormScope.$buefy.dialog.alert({
            message: `Please fill out the required fields on the Submission Detail page and try again.`,
            confirmText: "OK",
            type: "is-info"
          });
        } else {
          submissionFormScope.isLoading = true;
          submissionFormScope.$http
            .post(
              `${process.env.VUE_APP_API_BASE_DOMAIN}submitCancelWorkflow?nbrNewItemCrKey=${this.submissionID}&nameUser=${userData.networkId}&status=${status}`
            )
            // eslint-disable-next-line no-unused-vars
            .then(function(response) {
              submissionFormScope.isLoading = false;
              submissionFormScope.$buefy.dialog.alert({
                message: `Action on Submission ID - ${submissionFormScope.submissionID} is successful.`,
                confirmText: "OK",
                type: "is-success",
                onConfirm: () => submissionFormScope.closeFormAfterSubmit()
              });
              //submissionFormScope.$emit("toggleSubmissionView", true);
            })
            // eslint-disable-next-line no-unused-vars
            .catch(function(error) {
              submissionFormScope.isLoading = false;
              if (
                error.response.data ===
                "A valid comment is required to submit with items marked for rejection"
              ) {
                submissionFormScope.errorClass = "invalid";
              } else {
                submissionFormScope.errorClass = "";
              }
              submissionFormScope.$buefy.dialog.alert({
                message: `${error.response.data}`,
                confirmText: "OK",
                type: "is-danger"
              });
            });
        }
      }
    },
    checkSubmissionStatus() {
      var submissionFormScope = this;
      submissionFormScope.isLoading = true;

      submissionFormScope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}getSubmissionById?submissionId=${submissionFormScope.submissionId}`
        )
        .then(function(response) {
          submissionFormScope.isLoading = false;
          if (response.data.status === "A") {
            submissionFormScope.$buefy.dialog.alert({
              message: `Action on Submission ID - ${submissionFormScope.submissionID} is successful.`,
              confirmText: "OK",
              type: "is-success",
              onConfirm: () => submissionFormScope.closeFormAfterSubmit()
            });
          } else {
            submissionFormScope.$buefy.dialog.alert({
              message: `A problem occured with Submit. Please check for invalid data and/or clear the cache and try again. If problem persists, please contact the New Item Support at NewItem.IT.Support@thermofisher.com`,
              confirmText: "OK",
              type: "is-danger"
            });
          }
        })
        .catch(function(error) {
          submissionFormScope.isLoading = false;
          submissionFormScope.$buefy.dialog.alert({
            message: `A problem occured with Submit. Please check for invalid data and/or clear the cache and try again. If problem persists, please contact the New Item Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    getCASRejectedItems(msg) {
      var submissionFormScope = this;
      submissionFormScope.isCasConfirmationModalActive = true;
      //pass rejection reason error to comp
      submissionFormScope.rejectionReason = msg;
    },
    submitByCasConfirmation(status) {
      var submissionFormScope = this;
      var userData = "";
      if (sessionStorage.getItem("se_ni_user")) {
        userData = JSON.parse(sessionStorage.getItem("se_ni_user"));
      } else {
        userData = window.$cookies.get("ni_key");
      }
      submissionFormScope.isLoading = true;
      submissionFormScope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}casDataConformation?nbrNewItemCrKey=${this.submissionID}&nameUser=${userData.networkId}&status=${status}`
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          submissionFormScope.isLoading = false;
          submissionFormScope.$buefy.dialog.alert({
            message: `Action on Submission ID - ${submissionFormScope.submissionID} is successful.`,
            confirmText: "OK",
            type: "is-success",
            onConfirm: () => submissionFormScope.closeFormAfterSubmit()
          });
          //submissionFormScope.$emit("toggleSubmissionView", true);
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          submissionFormScope.isLoading = false;
          submissionFormScope.$buefy.dialog.alert({
            message: error.response.data,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    submitSubmissionId(status) {
      var submissionFormScope = this;
      var userData = "";
      if (sessionStorage.getItem("se_ni_user")) {
        userData = JSON.parse(sessionStorage.getItem("se_ni_user"));
      } else {
        userData = window.$cookies.get("ni_key");
      }

      submissionFormScope.isLoading = true;
      submissionFormScope.$http
        .post(
          `${process.env.VUE_APP_API_BASE_DOMAIN}submitCancelWorkflow?nbrNewItemCrKey=${this.submissionID}&nameUser=${userData.networkId}&status=${status}`
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          submissionFormScope.isLoading = false;
          submissionFormScope.$buefy.dialog.alert({
            message: `Submit action on Submission ID - ${submissionFormScope.submissionID} successful.`,
            confirmText: "OK",
            type: "is-success",
            onConfirm: () => submissionFormScope.closeFormAfterSubmit()
          });
          //submissionFormScope.$emit("toggleSubmissionView", true);
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          submissionFormScope.isLoading = false;
          if (status === "S") {
            submissionFormScope.$buefy.dialog.alert({
              message: error.response.data,
              confirmText: "OK",
              type: "is-danger"
            });
          } else {
            if (
              error.response.data ===
              "A valid comment is required to submit with items marked for rejection"
            ) {
              submissionFormScope.errorClass = "invalid";
            } else {
              submissionFormScope.errorClass = "";
            }
            submissionFormScope.$buefy.dialog.alert({
              message: `${error.response.data}`,
              confirmText: "OK",
              type: "is-danger"
            });
          }
        });
    },
    closeFormAfterSubmit() {
      if (sessionStorage.getItem("se_ni_user")) {
        window.close();
      } else {
        this.$emit("refreshGrid", true);
        this.$emit("toggleSubmissionView", true);
      }
    },
    actOnCurrentSubmission(action) {
      var submissionFormScope = this;
      var userData = "";
      if (sessionStorage.getItem("se_ni_user")) {
        userData = JSON.parse(sessionStorage.getItem("se_ni_user"));
      } else {
        userData = window.$cookies.get("ni_key");
      }
      var statusAction = "";
      switch (action) {
        case "N":
          statusAction = "Cancel";
          break;
        case "A":
          statusAction = "Approve";
          break;
        case "R":
          statusAction = "Reject";
          break;
      }
      submissionFormScope.$http
        .post(
          `${process.env.VUE_APP_API_BASE_DOMAIN}submitCancelWorkflow?nbrNewItemCrKey=${this.submissionID}&nameUser=${userData.networkId}&status=${action}`
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          switch (action) {
            case "N":
              submissionFormScope.$emit("refreshDraftGrid", true);
              break;
            case "A":
              submissionFormScope.$emit("refreshGrid", true);
              break;
            case "R":
              submissionFormScope.$emit("refreshGrid", true);
              break;
          }
          submissionFormScope.$buefy.dialog.alert({
            message: `${statusAction} action on Submission ID - ${submissionFormScope.submissionID} successful.`,
            confirmText: "OK",
            type: "is-success",
            onConfirm: () => window.close()
          });
          //submissionFormScope.$emit("toggleSubmissionView", true);
        })
        .catch(function(error) {
          var errMsg = "";
          if (statusAction === "Submit") {
            errMsg = error.response.data;
          } else {
            errMsg = `A problem occured with ${statusAction} operation. Please check for invalid data and/or clear the cache and try again. If problem persists, please contact the New Item Support at NewItem.IT.Support@thermofisher.com`;
          }
          submissionFormScope.$buefy.dialog.alert({
            message: errMsg,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    toggleSubmissionView() {
      this.$buefy.dialog.confirm({
        message: "Are you sure you want to leave the form?",
        cancelText: "No",
        confirmText: "Yes",
        type: "is-success",
        onConfirm: () => (
          sessionStorage.removeItem("rows"),
          sessionStorage.removeItem("regulatoryRows"),
          this.$emit("toggleSubmissionView", true)
        )
      });
    },
    createNewItem(requestPayload, noOfRows, index) {
      if (
        requestPayload.vcat === undefined ||
        requestPayload.vcat.trim() === "" ||
        requestPayload.vcat === null
      ) {
        this.vcatRequired = true;
        this.tooltipIndex = index;
      } else {
        this.vcatRequired = false;
        this.tooltipIndex = "";
        var submissionFormScope = this;
        var args = {
          headers: {
            "content-type": "application/json"
          }
        };
        if (sessionStorage.getItem("se_ni_user")) {
          requestPayload.createdBy = JSON.parse(
            sessionStorage.getItem("se_ni_user")
          ).networkId;
        } else {
          requestPayload.createdBy = window.$cookies.get("ni_key").networkId;
        }

        submissionFormScope.isLoading = true;
        submissionFormScope.$http
          .post(
            `${process.env.VUE_APP_API_BASE_DOMAIN}submissionId/${submissionFormScope.submissionID}/createLineInfo?noOfRows=${noOfRows}`,
            requestPayload,
            args
          )
          // eslint-disable-next-line no-unused-vars
          .then(function(response) {
            submissionFormScope.isLoading = false;
            submissionFormScope.loadItemDetailsUnderSubmission();
            if (noOfRows > 1) {
              submissionFormScope.$buefy.snackbar.open({
                duration: 5000,
                message: `Copied selected item succesfully.`,
                type: "is-success",
                position: "is-top",
                queue: false
              });
            }
          })
          .catch(function(error) {
            submissionFormScope.isLoading = false;
            submissionFormScope.$buefy.snackbar.open({
              duration: 5000,
              message: `A problem occured while saving item on Submission - ${submissionFormScope.submissionID}. Please check for invalid data and/or clear the cache and try again. If problem persists, please contact the New Item Support at NewItem.IT.Support@thermofisher.com`,
              type: "is-danger",
              position: "is-top",
              queue: false
            });
          });
      }
    },
    updateItem(requestPayload, index) {
      var submissionFormScope = this;
      var args = {
        headers: {
          "content-type": "application/json"
        }
      };

      var updatedRowData = {};

      for (var key in requestPayload) {
        var prop = "";
        prop = requestPayload[key];
        if (typeof prop === "string") {
          if (prop.trim() !== "") {
            updatedRowData[key] = requestPayload[key];
          }
        } else {
          updatedRowData[key] = requestPayload[key];
        }
      }

      submissionFormScope.isLoading = true;
      submissionFormScope.$http
        .put(
          `${process.env.VUE_APP_API_BASE_DOMAIN}submissionId/${submissionFormScope.submissionID}/genlQstnId/${requestPayload.genlQstnId}/updateLineInfo`,
          updatedRowData,
          args
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          submissionFormScope.isLoading = false;
          var apiRow = response.data;
          apiRow.lineNumber = submissionFormScope.rows[index].lineNumber;
          submissionFormScope.rows[index] = apiRow;
          var giRows = JSON.parse(sessionStorage.getItem("rows"));
          giRows.splice(index, 1, response.data);
          sessionStorage.setItem("rows", JSON.stringify(giRows));
          submissionFormScope.validateErrorObj.validateValue =
            response.data.validateForm;
          submissionFormScope.validateErrorObj.errorCount =
            response.data.errorCount;
          submissionFormScope.giTabErrorCount = response.data.errorCount;
          //enable/disable creator submit button
          document.querySelectorAll(
            ".submitter-only-wrapper .us-region .invalid"
          ).length === 0 &&
          submissionFormScope.validateErrorObj.validateValue &&
          submissionFormScope.validateErrorObj.validateValue === "Y" &&
          submissionFormScope.validateErrorObj.errorCount === 0
            ? (submissionFormScope.disableCreatorSubmit = false)
            : (submissionFormScope.disableCreatorSubmit = true);
          //emit errorCount for super user when isSubmissionActiveForPS is true
          if (submissionFormScope.loginRole === 6) {
            if (window.isSubmissionActiveForPS) {
              submissionFormScope.supplierTabsErrorCountForSuperUser =
                response.data.errorCount;
              submissionFormScope.validateSubmitForSuperUser();
            }
          }
        })
        .catch(function(error) {
          submissionFormScope.isLoading = false;
          submissionFormScope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to update item information for Submission - ${submissionFormScope.submissionID}. Please check for invalid data and/or clear the cache and try again. If problem persists, please contact the New Item Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            queue: false
          });
        })
        .then(function() {
          var tableRows = document.querySelector(".ni-app-general-info-tbody")
            .rows;
          for (var row in tableRows) {
            if (
              tableRows[row].classList &&
              tableRows[row].classList.contains("highlight-row")
            ) {
              tableRows[row].classList.remove("highlight-row");
            }
          }
          //add highlight-row class
          document
            .querySelector(".ni-app-general-info-tbody")
            .rows[index].classList.add("highlight-row");
          //blur select event on active element wrt index
          if (
            document.activeElement.closest("tr") &&
            document.activeElement.closest("tr").rowIndex !== index + 1
          ) {
            document.activeElement.blur();
          }
        });
    },
    addRowPOC() {
      try {
        this.rows.splice(this.rows.length + 1, 0, {});
        this.regulatoryRows.splice(this.regulatoryRows.length + 1, 0, {});
      } catch (e) {
        this.$buefy.dialog.alert({
          message:
            "Failed to add item. Please contact the New Item Support at NewItem.IT.Support@thermofisher.com",
          confirmText: "OK",
          type: "is-danger"
        });
      }
    },
    changeOnRow(event, index, rowData) {
      var rowArrayFromResponse = JSON.parse(sessionStorage.getItem("rows"));
      if (
        (!rowArrayFromResponse || index === rowArrayFromResponse.length) &&
        Object.keys(rowData).length > 0
      ) {
        for (var prop in rowData) {
          rowData[prop] = rowData[prop].trim();
        }
        this.createNewItem(rowData, "1", index);
      } else if (rowArrayFromResponse && rowArrayFromResponse.length > 0) {
        var rowDataFromResponseObj = JSON.parse(sessionStorage.getItem("rows"))[
          index
        ];
        for (var key in (rowDataFromResponseObj, rowData)) {
          if (
            key !== "psfsNewItemGenlQstnErrTbs" &&
            key !== "imageAttachmentName" &&
            key !== "lineNumber" &&
            rowDataFromResponseObj[key] !== rowData[key]
          ) {
            //logic for ncExpDt field
            if (key === "ncExpDt" && rowDataFromResponseObj[key]) {
              var date = rowDataFromResponseObj[key].split("T")[0];
              rowDataFromResponseObj[key] = new Date(
                date.split("-")[1] +
                  "-" +
                  date.split("-")[2] +
                  "-" +
                  date.split("-")[0]
              );
              if (
                !(
                  rowDataFromResponseObj[key] !== rowData[key] &&
                  new Date(rowDataFromResponseObj[key]).toDateString() ===
                    new Date(rowData[key]).toDateString()
                )
              ) {
                this.updateItem(rowData, index);
                break;
              }
            } else {
              //logic for other fields
              if (
                !(
                  rowDataFromResponseObj[key] === undefined &&
                  rowData[key] === " "
                )
              ) {
                if (rowData[key] === " ") {
                  rowData[key] = "";
                }
                this.updateItem(rowData, index);
                break;
              }
            }
          }
        }
      }
    },
    loadItemDetailsUnderSubmission() {
      var submissionFormScope = this;
      submissionFormScope.isLoading = true;
      var args = {
        headers: {
          "content-type": "application/json"
        }
      };

      var requestPayload = {};
      requestPayload.actions = [];
      requestPayload.filterMap = {};
      requestPayload.searchMap = {};
      requestPayload.sortMap = {};
      if (
        submissionFormScope.filterMapErrors ||
        submissionFormScope.filterMapVcat ||
        submissionFormScope.filterMapManufacturerName ||
        submissionFormScope.filterMapPricingExpDate ||
        submissionFormScope.filterMapUnspscCode
      ) {
        requestPayload.actions.push("Filter");
        requestPayload.filterMap = {};
        if (submissionFormScope.filterMapErrors) {
          requestPayload.filterMap.ErroredItems =
            submissionFormScope.filterMapErrors;
        }
        if (submissionFormScope.filterMapVcat) {
          requestPayload.filterMap.VCAT = submissionFormScope.filterMapVcat;
        }
        if (submissionFormScope.filterMapManufacturerName) {
          requestPayload.filterMap.MNAME =
            submissionFormScope.filterMapManufacturerName;
        }
        if (submissionFormScope.filterMapUnspscCode) {
          requestPayload.filterMap.UNSPSC =
            submissionFormScope.filterMapUnspscCode;
        }
        if (submissionFormScope.filterMapPricingExpDate) {
          requestPayload.filterMap.PRCEXPDATE =
            submissionFormScope.filterMapPricingExpDate;
        }
      }
      if (
        submissionFormScope.searchMapInput ||
        submissionFormScope.pricingExpDate
      ) {
        requestPayload.actions.push("Search");
        requestPayload.searchMap = {};
        if (submissionFormScope.searchMapFieldName === "PRCEXPDATE") {
          requestPayload.searchMap[submissionFormScope.searchMapFieldName] =
            submissionFormScope.pricingExpDate;
        } else {
          requestPayload.searchMap[submissionFormScope.searchMapFieldName] =
            submissionFormScope.searchMapInput;
        }
      }
      if (submissionFormScope.sortMapSelectedOrder) {
        requestPayload.actions.push("Sort");
        requestPayload.sortMap = {};
        requestPayload.sortMap[submissionFormScope.sortMapFieldName] =
          submissionFormScope.sortMapSelectedOrder;
      }

      submissionFormScope.$http
        .post(
          `${process.env.VUE_APP_API_BASE_DOMAIN}getAllGenlQtns?nbrNewItemCrKey=${submissionFormScope.submissionID}&pageIndex=${submissionFormScope.pageIndex}&noOfRecords=${submissionFormScope.numberOfGeneralQuestionItems}`,
          requestPayload,
          args
        )
        .then(function(response) {
          response.data.startIndex
            ? (submissionFormScope.minPageIndex = response.data.startIndex)
            : (submissionFormScope.minPageIndex = 0);
          response.data.endIndex !== undefined
            ? (submissionFormScope.maxPageIndex = response.data.endIndex)
            : (submissionFormScope.maxPageIndex = 0);
          response.data.totalCount !== undefined
            ? (submissionFormScope.totalResults = response.data.totalCount)
            : (submissionFormScope.totalResults = 0);
          response.data.totalPages
            ? (submissionFormScope.totalPages = response.data.totalPages)
            : (submissionFormScope.totalPages = 0);
          if (response.data.startIndex <= 1) {
            submissionFormScope.showPreviousButton = false;
            submissionFormScope.showFirstButton = false;
          } else {
            submissionFormScope.showPreviousButton = true;
            submissionFormScope.showFirstButton = true;
          }
          if (submissionFormScope.pageIndex >= submissionFormScope.totalPages) {
            submissionFormScope.showNextButton = false;
            submissionFormScope.showLastButton = false;
          } else {
            submissionFormScope.showNextButton = true;
            submissionFormScope.showLastButton = true;
          }

          //logic for filter applied prompt
          if (requestPayload.actions.includes("Filter") > 0) {
            submissionFormScope.giFilterApplied = true;
          } else {
            submissionFormScope.giFilterApplied = false;
          }

          submissionFormScope.isUser3PGQtab = response.data.user3P;
          if (submissionFormScope.loginRole === 0) {
            submissionFormScope.validateErrorObj = {
              validateValue: response.data.validateForm,
              errorCount: response.data.errorCount
            };
          }

          //enable/disable creator submit button
          document.querySelectorAll(
            ".submitter-only-wrapper .us-region .invalid"
          ).length === 0 &&
          submissionFormScope.validateErrorObj.validateValue === "Y" &&
          submissionFormScope.validateErrorObj.errorCount === 0
            ? (submissionFormScope.disableCreatorSubmit = false)
            : (submissionFormScope.disableCreatorSubmit = true);

          response.data.validateForm === "Y"
            ? (submissionFormScope.disableValidateButton = true)
            : (submissionFormScope.disableValidateButton = false);

          //emit errorCount for super user when isSubmissionActiveForPS is true
          if (submissionFormScope.loginRole === 6) {
            if (window.isSubmissionActiveForPS) {
              submissionFormScope.supplierTabsErrorCountForSuperUser =
                response.data.errorCount;
              submissionFormScope.validateSubmitForSuperUser();
            }
          }
          submissionFormScope.giTabErrorCount = response.data.errorCount;
          submissionFormScope.isLoading = false;
          if (response.data.psfsNewItemGenlQstnsTbs.length > 0) {
            submissionFormScope.rows = [];
            submissionFormScope.rowIds = [];
            submissionFormScope.rows = response.data.psfsNewItemGenlQstnsTbs;
            sessionStorage.setItem(
              "rows",
              JSON.stringify(response.data.psfsNewItemGenlQstnsTbs)
            );
            for (
              var i = 0, lineNumber = submissionFormScope.minPageIndex;
              i < submissionFormScope.rows.length && lineNumber > 0;
              i++, lineNumber++
            ) {
              submissionFormScope.rowIds.push(
                submissionFormScope.rows[i].genlQstnId
              );
              submissionFormScope.rows[i].lineNumber = lineNumber;
              if (submissionFormScope.rows[i].ncExpDt) {
                var date = submissionFormScope.rows[i].ncExpDt.split("T")[0];
                submissionFormScope.rows[i].ncExpDt = new Date(
                  date.split("-")[1] +
                    "-" +
                    date.split("-")[2] +
                    "-" +
                    date.split("-")[0]
                );
              }
            }
          } else {
            if (requestPayload.actions.length === 0) {
              submissionFormScope.rows = [];
              sessionStorage.removeItem("rows");
              submissionFormScope.addRowPOC();
            } else {
              submissionFormScope.rows = [];
              submissionFormScope.rows = response.data.psfsNewItemGenlQstnsTbs;
            }
          }
          //set to false after render complete
          window.uploadComplete = false;
        })
        .catch(function(error) {
          submissionFormScope.isLoading = false;
          submissionFormScope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to load items for Submission - ${submissionFormScope.submissionID}. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            queue: false
          });
        })
        .then(function() {
          //focus on first editable category field
          if (!$(".ni-app-general-info-tab").hasClass("viewOnly")) {
            $(".ni-app-general-info-tbody")
              .children("tr")
              .first()
              .find("td:has(.vcat input)")
              .find("input")
              .focus();
          }

          //custom navigator plugin using jquery
          (function($) {
            $.fn.enableCellNavigation = function() {
              var arrow = {
                left: 37,
                up: 38,
                right: 39,
                down: 40
              };
              var esc = 27;

              // select all on focus
              // works for input elements, and will put focus into
              // adjacent input or textarea. once in a textarea,
              // however, it will not attempt to break out because
              // that just seems too messy imho.
              $(".ni-app-general-info-tbody")
                .find("input,select,a")
                .keydown(function(e) {
                  // shortcut for key other than arrow keys
                  if (
                    $.inArray(e.which, [
                      arrow.left,
                      arrow.up,
                      arrow.right,
                      arrow.down,
                      esc
                    ]) < 0
                  ) {
                    return;
                  }

                  var input = e.target;
                  var td = $(e.target).closest("td");
                  var moveTo = null;

                  switch (e.which) {
                    case arrow.left: {
                      if (
                        ($(input).is("input:text") &&
                          input.selectionStart !== 0) === false
                      ) {
                        //left on manufacturer name
                        if (td.index() === 15) {
                          //go to keyword5 field
                          moveTo = td.prevAll("td:has(.key5 input)");
                        } else {
                          //if current filed disabled go to prev input, select that are not disabled
                          if (
                            td.prev("td:has(input,select)").has(":disabled")
                          ) {
                            //go to prev field
                            moveTo = td.prevAll(
                              "td:has(input:not(:disabled),select:not(:disabled))"
                            );
                            //if no fields to left
                            if (moveTo.length === 0) {
                              //go to cAuList on prev row
                              moveTo = td
                                .parents("tr")
                                .prev("tr")
                                .find("td:has(.caAuList input)");
                            }
                          } else {
                            //go to prev input, select
                            moveTo = td.prev("td:has(input,select)");
                          }
                        }
                      }
                      break;
                    }
                    case arrow.right: {
                      if (
                        ($(input).is("input:text") &&
                          input.selectionStart !== input.value.length) === false
                      ) {
                        //left on key5
                        if (td.index() === 13) {
                          //go to manufacturer name
                          moveTo = td.nextAll(
                            "td:has(.manufacturerName input)"
                          );
                        } else {
                          //if current field disabled go to prev input, select that are not disabled
                          if (
                            td.next("td:has(input,select)").has(":disabled")
                          ) {
                            //go to next field
                            moveTo = td.nextAll(
                              "td:has(input:not(:disabled),select:not(:disabled))"
                            );
                            //if no fields to right
                            if (moveTo.length === 0) {
                              //go to checkbox on next row
                              moveTo = td
                                .parents("tr")
                                .next("tr")
                                .find("td:has(input:checkbox)");
                            }
                          } else {
                            //go to next input, select
                            moveTo = td.next("td:has(input,select)");
                          }
                        }
                      }
                      break;
                    }

                    case arrow.up:
                    case arrow.down: {
                      e.preventDefault();
                      var tr = td.closest("tr");
                      var pos = td.index();

                      var moveToRow = null;
                      //go to row cells on up/down
                      if (e.which == arrow.down) {
                        moveToRow = tr.next("tr");
                      } else if (e.which == arrow.up) {
                        moveToRow = tr.prev("tr");
                      }

                      if (moveToRow.length) {
                        moveTo = $(moveToRow[0].children[0].children[pos]);
                      }

                      break;
                    }
                  }

                  if (moveTo && moveTo.length) {
                    e.preventDefault();
                    var input = $(moveTo[0]).find("input")[0];
                    if (arrow.right === e.which && $(input).is("input:text")) {
                      // var input = $(moveTo[0]).find("input")[0];
                      input.focus();
                      $(input)
                        .get(0)
                        .setSelectionRange(0, 0);
                    } else if (
                      arrow.left === e.which &&
                      $(input).is("input:text")
                    ) {
                      // var input = $(moveTo[0]).find("input")[0];
                      if (typeof input.selectionStart == "number") {
                        input.selectionStart = input.selectionEnd =
                          input.value.length;
                      } else if (typeof input.createTextRange != "undefined") {
                        var range = input.createTextRange();
                        range.collapse(false);
                        range.select();
                      }
                      input.focus();
                    } else if ($(input).is("input:text")) {
                      // var input = $(moveTo[0]).find("input")[0];
                      input.focus();
                    } else {
                      //focus on input, select
                      var input = $(moveTo[0]).find("input,select")[0];
                      input.focus();
                    }
                  }
                });
            };
          })($);

          // use the plugin
          $(function() {
            $("#ni-general-info-table").enableCellNavigation();
          });
        });
    },
    generateDeletePayload() {
      if (this.selectAllChecked) {
        this.deleteItems("All");
      } else {
        if (this.checkboxGroup.length > 0) {
          this.deleteItems(null);
        } else {
          this.$buefy.dialog.alert({
            message: `Please select at least one item.`,
            confirmText: "OK",
            type: "is-info"
          });
        }
      }
    },
    deleteItems(param) {
      var submissionFormScope = this;
      var args = {
        headers: {
          "content-type": "application/json"
        }
      };

      submissionFormScope.isLoading = true;
      submissionFormScope.$http
        .put(
          `${process.env.VUE_APP_API_BASE_DOMAIN}multiselect/delete?flag=${param}&submissionId=${submissionFormScope.submissionID}`,
          submissionFormScope.checkboxGroup,
          args
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          submissionFormScope.isLoading = false;
          submissionFormScope.rowIds = [];
          submissionFormScope.selectAllChecked = false;
          submissionFormScope.checkboxGroup = [];
          submissionFormScope.loadItemDetailsUnderSubmission();
          submissionFormScope.$buefy.snackbar.open({
            message: `Delete successful on selected items under Submission ID - ${submissionFormScope.submissionID}.`,
            type: "is-success",
            position: "is-top",
            actionText: "OK"
          });
        })
        .catch(function(error) {
          submissionFormScope.isLoading = false;
          submissionFormScope.$buefy.snackbar.open({
            message: `Failed to delete selected items under Submission ID - ${submissionFormScope.submissionID}. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            actionText: "OK"
          });
        });
    },
    markSelectedAction(param) {
      if (this.selectedRows.length > 0) {
        var submissionFormScope = this;
        var userCookie = window.$cookies.get("ni_key");
        var approverRoleKey = userCookie.roleKey;
        var approverNetworkId = userCookie.networkId;
        var params = {};
        var args = {
          headers: {
            "content-type": "application/json"
          }
        };
        params.submissionId = submissionFormScope.submissionID;
        if (param === "All") {
          params.flag = param;
        } else {
          params.flag = null;
        }

        submissionFormScope.isLoading = true;
        submissionFormScope.$http
          .put(
            `${process.env.VUE_APP_API_BASE_DOMAIN}multiselect/${param}?flag=${params.flag}&submissionId=${submissionFormScope.submissionID}&roleKey=${approverRoleKey}&updatedBy=${approverNetworkId}`,
            submissionFormScope.selectedRows,
            args
          )
          // eslint-disable-next-line no-unused-vars
          .then(function(response) {
            submissionFormScope.isLoading = false;
            submissionFormScope.rowIds = [];
            submissionFormScope.selectAllChecked = false;
            submissionFormScope.selectedRows = [];
            //submissionFormScope.activeTab = 2;
            submissionFormScope.$buefy.snackbar.open({
              message: `Marked selected items under Submission ID - ${submissionFormScope.submissionID} successfully.`,
              type: "is-success",
              position: "is-top",
              actionText: "OK"
            });
            if (submissionFormScope.activeTab === 2) {
              submissionFormScope.canLoadPortfolioManagementData = {
                loadDetails: true,
                generalQuestionRows: submissionFormScope.rows,
                actions: {
                  fErrors: submissionFormScope.filterMapPMErrors,
                  fLineErrors: submissionFormScope.filterMapPMLineErrors
                },
                paginationParams: {
                  pageIndex: submissionFormScope.pmPageIndex,
                  numberOfPMItems: submissionFormScope.numberOfPMItems
                }
              };
            } else if (submissionFormScope.activeTab === 3) {
              submissionFormScope.canLoadRegulatoryAffairsData = {
                loadDetails: true,
                generalQuestionRows: submissionFormScope.rows,
                actions: {
                  fErrors: submissionFormScope.filterMapRAErrors,
                  fLineErrors: submissionFormScope.filterMapRALineErrors
                },
                paginationParams: {
                  pageIndex: submissionFormScope.raPageIndex,
                  numberOfRAItems: submissionFormScope.numberOfRAItems
                }
              };
            } else if (submissionFormScope.activeTab === 4) {
              submissionFormScope.canLoadProductServicesData = {
                loadDetails: true,
                generalQuestionRows: submissionFormScope.rows,
                actions: {
                  fErrors: submissionFormScope.filterMapPSErrors,
                  fLineErrors: submissionFormScope.filterMapPSLineErrors
                },
                paginationParams: {
                  pageIndex: submissionFormScope.psPageIndex,
                  numberOfPSItems: submissionFormScope.numberOfPSItems
                }
              };
            }
          })
          .catch(function(error) {
            submissionFormScope.isLoading = false;
            submissionFormScope.$buefy.snackbar.open({
              message: `Failed to mark selected items under Submission ID - ${submissionFormScope.submissionID}. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
              type: "is-danger",
              position: "is-top",
              actionText: "OK"
            });
          });
      } else {
        this.$buefy.dialog.alert({
          message: `Please select at least one item.`,
          confirmText: "OK",
          type: "is-info"
        });
      }
    },
    copySelectedItemToSubmission(row) {
      this.$buefy.dialog.prompt({
        message: `Enter number of Items to copy:`,
        inputAttrs: {
          type: "number",
          max: 100,
          min: 1
        },
        trapFocus: true,
        onConfirm: value => this.copyItems(value, row)
      });
    },
    copyItems(number, rowData) {
      var submissionFormScope = this;

      var createdBy = JSON.parse(sessionStorage.getItem("se_ni_user"))
        .networkId;

      submissionFormScope.$http
        .post(
          `${process.env.VUE_APP_API_BASE_DOMAIN}copyLineInfo?submissionId=${submissionFormScope.submissionID}&noOfRows=${number}&genlQstnId=${rowData.genlQstnId}&createdBy=${createdBy}`
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          submissionFormScope.loadItemDetailsUnderSubmission();
          submissionFormScope.$buefy.snackbar.open({
            duration: 5000,
            message: `Copied selected item succesfully.`,
            type: "is-success",
            position: "is-top",
            queue: false
          });
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          submissionFormScope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to Copy item information for Submission - ${submissionFormScope.submissionID}. Please check for invalid data and/or clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            queue: false
          });
        });
    },
    resetInputs() {
      this.rows = [];
      this.checkboxGroup = [];
      this.rowIds = [];
      (this.filterMapErrors = ""),
        (this.filterMapVcat = ""),
        (this.filterMapManufacturerName = ""),
        (this.filterMapPricingExpDate = null),
        (this.filterMapUnspscCode = ""),
        (this.sortMapFieldName = ""),
        (this.sortMapSelectedOrder = ""),
        (this.searchMapInput = ""),
        (this.searchMapFieldName = ""),
        (this.pricingExpDate = null);
    },
    resetRegulatoryInputs() {
      this.rows = [];
      this.checkboxGroup = [];
      this.rowIds = [];
      (this.filterMapRIErrors = ""),
        (this.filterMapCategory = ""),
        (this.filterMapProp65 = ""),
        (this.filterMapMedDevice = ""),
        (this.sortMapRegulatoryField = ""),
        (this.sortMapRegulatorySelectedOrder = ""),
        (this.searchMapRegulatoryField = ""),
        (this.searchMapRegulatoryInput = "");
    },
    getSubmissionHistory() {
      var submissionFormScope = this;
      var args = {};
      args.headers = {
        "content-type": "application/json"
      };
      submissionFormScope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}submissionLevelHistory/${submissionFormScope.submissionID}`,
          null,
          args
        )
        .then(function(response) {
          submissionFormScope.formProps.historyData = response.data;
          submissionFormScope.isComponentModalActive = true;
        })
        .catch(function(error) {
          submissionFormScope.$buefy.dialog.alert({
            message: `Failed to load history for Submission ID - ${submissionFormScope.submissionID}. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    validateItemsUnderSubmission() {
      var submissionFormScope = this;
      submissionFormScope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}genlQstn/validate?nbrNewItemCrKey=${submissionFormScope.submissionID}&pageIndex=${submissionFormScope.pageIndex}&noOfRecords=${submissionFormScope.numberOfGeneralQuestionItems}`
        )
        .then(function(response) {
          if (submissionFormScope.activeTab === 1) {
            submissionFormScope.canLoadRegulatoryInformationData = {
              loadDetails: true,
              generalQuestionRows: submissionFormScope.rows,
              actions: {
                fErrors: submissionFormScope.filterMapRIErrors,
                fCategory: submissionFormScope.filterMapCategory,
                fProp65: submissionFormScope.filterMapProp65,
                fMedDevice: submissionFormScope.filterMapMedDevice,
                soField: submissionFormScope.sortMapRegulatoryField,
                soOrder: submissionFormScope.sortMapRegulatorySelectedOrder,
                srFieldName: submissionFormScope.searchMapRegulatoryField,
                srValue: submissionFormScope.searchMapRegulatoryInput
              },
              paginationParams: {
                pageIndex: submissionFormScope.regulatoryPageIndex,
                numberOfRegulatoryItems:
                  submissionFormScope.numberOfRegulatoryItems
              }
            };
          } else {
            if (response.data.errorCount) {
              submissionFormScope.giTabErrorCount = response.data.errorCount;
              submissionFormScope.rows = [];
              submissionFormScope.rows = response.data.psfsNewItemGenlQstnsTbs;
              response.data.validateForm === "Y"
                ? (submissionFormScope.disableValidateButton = true)
                : (submissionFormScope.disableValidateButton = false);
              sessionStorage.setItem(
                "rows",
                JSON.stringify(response.data.psfsNewItemGenlQstnsTbs)
              );
              for (var i = 0; i < submissionFormScope.rows.length; i++) {
                submissionFormScope.rowIds.push(
                  submissionFormScope.rows[i].genlQstnId
                );
                if (submissionFormScope.rows[i].ncExpDt) {
                  var date = submissionFormScope.rows[i].ncExpDt.split("T")[0];
                  submissionFormScope.rows[i].ncExpDt = new Date(
                    date.split("-")[1] +
                      "-" +
                      date.split("-")[2] +
                      "-" +
                      date.split("-")[0]
                  );
                }
              }
            } else {
              submissionFormScope.loadItemDetailsUnderSubmission();
            }
          }
        })
        .catch(function(error) {
          submissionFormScope.$buefy.dialog.alert({
            message: `Failed to validate items for Submission ID - ${submissionFormScope.submissionID}. Please check for invalid data and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    updateSuDependentValues(rowData) {
      if (rowData.su === "EA" || rowData.su === "PR") {
        rowData.suQty = "1";
      } else if (rowData.su === "DZ") {
        rowData.suQty = "12";
      }
      // this.disableSuQty();
      return rowData;
    },
    updateAuDependentValues(rowData) {
      if (rowData.au === "DZ") {
        rowData.auQty = "12";
      }
      return rowData;
    },
    updateShlfLf(rowData) {
      if (rowData.serLot === "L") {
        rowData.shlfLf = "Yes";
      }
      return rowData;
    },
    disableBasedOnSu(suVal) {
      if (suVal === "EA" || suVal === "PR" || suVal === "DZ") {
        return true;
      } else {
        return false;
      }
    },
    disableIfSuIsCs(suVal) {
      if (suVal === "CS") {
        return true;
      } else {
        return false;
      }
    },
    disableAuQtyIf(suVal, auVal) {
      if (
        suVal === "CS" ||
        auVal === "DZ" ||
        auVal.trim() === "" ||
        auVal === undefined
      ) {
        return true;
      } else {
        return false;
      }
    },
    calculateDiscount(rowData) {
      if (rowData.suList && rowData.suCost) {
        rowData.discnt = (
          (rowData.suList - rowData.suCost) /
          rowData.suList
        ).toFixed(2);
      }
      return rowData;
    },
    reassignSubmission() {
      var submissionFormScope = this;
      var args = {};
      args.headers = {
        "content-type": "application/json"
      };
      submissionFormScope.isLoading = true;
      submissionFormScope.$http
        .get(`${process.env.VUE_APP_API_BASE_DOMAIN}loadMCSCode`, null, args)
        .then(function(response) {
          submissionFormScope.isLoading = false;
          submissionFormScope.reAssignSubmisionProps.mcsList = response.data;
          submissionFormScope.reassignSubmissionId =
            submissionFormScope.submissionID;
          submissionFormScope.isReassignComponentModalActive = true;
        })
        .catch(function(error) {
          submissionFormScope.isLoading = false;
          submissionFormScope.$buefy.dialog.alert({
            message: `Failed to load MCS Code - ${submissionFormScope.submissionID}. Please check for invalid MCS Code and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    cooCodes() {
      var submissionFormScope = this;
      var args = {};
      args.headers = {
        "content-type": "application/json"
      };
      submissionFormScope.isLoading = true;
      submissionFormScope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}countryOfOriginCodes`,
          null,
          args
        )
        .then(function(response) {
          submissionFormScope.isLoading = false;
          submissionFormScope.cooProps.cooList = response.data;
          submissionFormScope.isCooComponentModalActive = true;
        })
        .catch(function(error) {
          submissionFormScope.isLoading = false;
          submissionFormScope.$buefy.dialog.alert({
            message: `Failed to load Country Codes. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    uploadPortfolioManagement() {
      var submissionFormScope = this;
      var networkId = window.$cookies.get("ni_key").networkId;
      var isUploadFormatValid = /^.*\.(xls|xlsx)$/.test(
        submissionFormScope.file.name
      );
      if (isUploadFormatValid) {
        submissionFormScope.showValidationErrorMessage = false;
        submissionFormScope.validationErrorDescription = "";
        var args = {
          headers: {
            "content-type": "multipart/form-data"
          }
        };
        var uploadData = new FormData();
        uploadData.append("file", submissionFormScope.file);
        submissionFormScope.isLoading = true;
        submissionFormScope.$http
          .post(
            `${process.env.VUE_APP_API_BASE_DOMAIN}excel/uploadPMData?nbrNewItemCrKey=${submissionFormScope.submissionID}&networkId=${networkId}`,
            uploadData,
            args
          )
          .then(function(response) {
            submissionFormScope.isLoading = false;
            submissionFormScope.file = null;
            if (response.data.toLowerCase() === "background") {
              submissionFormScope.$buefy.dialog.alert({
                message: `File is being processed for upload in the background. You will be notified via email once it is complete.`,
                confirmText: "OK",
                type: "is-success",
                onConfirm: () =>
                  submissionFormScope.$emit("toggleSubmissionView", true)
              });
            } else if (response.data.toLowerCase() === "failure") {
              submissionFormScope.$buefy.dialog.alert({
                message: `A problem occurred with the upload file used. Please remove any special characters or extra line breaks on the description fields and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
                confirmText: "OK",
                type: "is-danger"
              });
            } else {
              submissionFormScope.$buefy.dialog.alert({
                message: `Upload successful for Submission - ${submissionFormScope.submissionID}.`,
                confirmText: "OK",
                type: "is-success",
                onConfirm: () => (
                  (window.uploadPMComplete = true),
                  //reset filter on upload callback
                  ((submissionFormScope.filterMapPMErrors = ""),
                  (submissionFormScope.filterMapPMLineErrors = "")),
                  submissionFormScope.checkPMFilterCriteria(),
                  (submissionFormScope.canLoadPortfolioManagementData = {
                    loadDetails: true,
                    generalQuestionRows: submissionFormScope.rows,
                    actions: {
                      fErrors: submissionFormScope.filterMapPMErrors,
                      fLineErrors: submissionFormScope.filterMapPMLineErrors
                    },
                    paginationParams: {
                      pageIndex: submissionFormScope.pmPageIndex,
                      numberOfPMItems: submissionFormScope.numberOfPMItems
                    }
                  })
                )
              });
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch(function(error) {
            submissionFormScope.isLoading = false;
            if (error.response.status === 400) {
              submissionFormScope.$buefy.dialog.alert({
                message: error.response.data,
                confirmText: "OK",
                type: "is-danger"
              });
            } else {
              submissionFormScope.$buefy.dialog.alert({
                message: `A problem occurred with the upload file used. Please remove any special characters or extra line breaks on the description fields and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
                confirmText: "OK",
                type: "is-danger"
              });
            }
          });
      } else {
        submissionFormScope.showValidationErrorMessage = true;
        submissionFormScope.validationErrorDescription = `${submissionFormScope.file.name} - Invalid file type, system accepts only .xls(x) extension.`;
      }
    },
    showPMUploadButton() {
      if (window.$cookies.get("ni_key")) {
        switch (window.$cookies.get("ni_key").roleKey) {
          case 1:
          case 2:
            return true;
          case 3:
          case 4:
          case 5:
          case 6:
            return false;
        }
      } else {
        return false;
      }
    },
    uploadRegulatoryAffairs() {
      var submissionFormScope = this;
      var networkId = window.$cookies.get("ni_key").networkId;
      var isUploadFormatValid = /^.*\.(xls|xlsx)$/.test(
        submissionFormScope.file.name
      );
      if (isUploadFormatValid) {
        submissionFormScope.showValidationErrorMessage = false;
        submissionFormScope.validationErrorDescription = "";
        var args = {
          headers: {
            "content-type": "multipart/form-data"
          }
        };
        var uploadData = new FormData();
        uploadData.append("file", submissionFormScope.file);
        submissionFormScope.isLoading = true;
        submissionFormScope.$http
          .post(
            `${process.env.VUE_APP_API_BASE_DOMAIN}excel/uploadRAData?nbrNewItemCrKey=${submissionFormScope.submissionID}&networkId=${networkId}`,
            uploadData,
            args
          )
          .then(function(response) {
            submissionFormScope.isLoading = false;
            submissionFormScope.file = null;
            if (response.data.toLowerCase() === "background") {
              submissionFormScope.$buefy.dialog.alert({
                message: `File is being processed for upload in the background. You will be notified via email once it is complete.`,
                confirmText: "OK",
                type: "is-success",
                onConfirm: () =>
                  submissionFormScope.$emit("toggleSubmissionView", true)
              });
            } else if (response.data.toLowerCase() === "failure") {
              submissionFormScope.$buefy.dialog.alert({
                message: `A problem occurred with the upload file used. Please remove any special characters or extra line breaks on the description fields and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
                confirmText: "OK",
                type: "is-danger"
              });
            } else {
              submissionFormScope.$buefy.dialog.alert({
                message: `Upload successful for Submission - ${submissionFormScope.submissionID}.`,
                confirmText: "OK",
                type: "is-success",
                onConfirm: () => (
                  (window.uploadRAComplete = true),
                  //reset filter on upload callback
                  ((submissionFormScope.filterMapRAErrors = ""),
                  (submissionFormScope.filterMapRALineErrors = "")),
                  submissionFormScope.checkRAFilterCriteria(),
                  (submissionFormScope.canLoadRegulatoryAffairsData = {
                    loadDetails: true,
                    generalQuestionRows: submissionFormScope.rows,
                    actions: {
                      fErrors: submissionFormScope.filterMapRAErrors,
                      fLineErrors: submissionFormScope.filterMapRALineErrors
                    },
                    paginationParams: {
                      pageIndex: submissionFormScope.raPageIndex,
                      numberOfRAItems: submissionFormScope.numberOfRAItems
                    }
                  })
                )
              });
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch(function(error) {
            submissionFormScope.isLoading = false;
            if (error.response.status === 400) {
              submissionFormScope.$buefy.dialog.alert({
                message: error.response.data,
                confirmText: "OK",
                type: "is-danger"
              });
            } else {
              submissionFormScope.$buefy.dialog.alert({
                message: `A problem occurred with the upload file used. Please remove any special characters or extra line breaks on the description fields and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
                confirmText: "OK",
                type: "is-danger"
              });
            }
          });
      } else {
        submissionFormScope.showValidationErrorMessage = true;
        submissionFormScope.validationErrorDescription = `${submissionFormScope.file.name} - Invalid file type, system accepts only .xls(x) extension.`;
      }
    },
    uploadProductServices() {
      var submissionFormScope = this;
      var networkId = window.$cookies.get("ni_key").networkId;
      var isUploadFormatValid = /^.*\.(xls|xlsx)$/.test(
        submissionFormScope.file.name
      );
      if (isUploadFormatValid) {
        submissionFormScope.showValidationErrorMessage = false;
        submissionFormScope.validationErrorDescription = "";
        var args = {
          headers: {
            "content-type": "multipart/form-data"
          }
        };
        var uploadData = new FormData();
        uploadData.append("file", submissionFormScope.file);
        submissionFormScope.isLoading = true;
        submissionFormScope.$http
          .post(
            `${process.env.VUE_APP_API_BASE_DOMAIN}excel/uploadPSData?nbrNewItemCrKey=${submissionFormScope.submissionID}&networkId=${networkId}`,
            uploadData,
            args
          )
          .then(function(response) {
            submissionFormScope.isLoading = false;
            submissionFormScope.file = null;
            if (response.data.toLowerCase() === "background") {
              submissionFormScope.$buefy.dialog.alert({
                message: `File is being processed for upload in the background. You will be notified via email once it is complete.`,
                confirmText: "OK",
                type: "is-success",
                onConfirm: () =>
                  submissionFormScope.$emit("toggleSubmissionView", true)
              });
            } else if (response.data.toLowerCase() === "failure") {
              submissionFormScope.$buefy.dialog.alert({
                message: `A problem occurred with the upload file used. Please remove any special characters or extra line breaks on the description fields and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
                confirmText: "OK",
                type: "is-danger"
              });
            } else {
              submissionFormScope.$buefy.dialog.alert({
                message: `Upload successful for Submission - ${submissionFormScope.submissionID}.`,
                confirmText: "OK",
                type: "is-success",
                onConfirm: () => (
                  (window.uploadPSComplete = true),
                  //reset filter on upload callback
                  ((submissionFormScope.filterMapPSErrors = ""),
                  (submissionFormScope.filterMapPSLineError = "")),
                  submissionFormScope.checkPSFilterCriteria(),
                  (submissionFormScope.canLoadProductServicesData = {
                    loadDetails: true,
                    generalQuestionRows: submissionFormScope.rows,
                    actions: {
                      fErrors: submissionFormScope.filterMapPSErrors,
                      fLineErrors: submissionFormScope.filterMapPSLineError
                    },
                    paginationParams: {
                      pageIndex: submissionFormScope.psPageIndex,
                      numberOfPSItems: submissionFormScope.numberOfPSItems
                    }
                  })
                )
              });
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch(function(error) {
            submissionFormScope.isLoading = false;
            if (error.response.status === 400) {
              submissionFormScope.$buefy.dialog.alert({
                message: error.response.data,
                confirmText: "OK",
                type: "is-danger"
              });
            } else {
              submissionFormScope.$buefy.dialog.alert({
                message: `A problem occurred with the upload file used. Please remove any special characters or extra line breaks on the description fields and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
                confirmText: "OK",
                type: "is-danger"
              });
            }
          });
      } else {
        submissionFormScope.showValidationErrorMessage = true;
        submissionFormScope.validationErrorDescription = `${submissionFormScope.file.name} - Invalid file type, system accepts only .xls(x) extension.`;
      }
    },
    showPSUploadButton() {
      if (window.$cookies.get("ni_key")) {
        switch (window.$cookies.get("ni_key").roleKey) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            return false;
          case 6:
            return true;
          default:
            return false;
        }
      } else {
        return false;
      }
    },
    updateRIFields() {
      var submissionFormScope = this;
      var requestPayload = {};
      requestPayload = submissionFormScope.update;
      submissionFormScope.$http
        .post(
          `${process.env.VUE_APP_API_BASE_DOMAIN}regltryInfo/massUpdate/submissionId/${submissionFormScope.submissionID}`,
          requestPayload
        )
        .then(function(response) {
          submissionFormScope.canLoadRegulatoryInformationData = {
            loadDetails: true,
            generalQuestionRows: submissionFormScope.rows,
            actions: {
              fErrors: submissionFormScope.filterMapRIErrors,
              fCategory: submissionFormScope.filterMapCategory,
              fProp65: submissionFormScope.filterMapProp65,
              fMedDevice: submissionFormScope.filterMapMedDevice,
              soField: submissionFormScope.sortMapRegulatoryField,
              soOrder: submissionFormScope.sortMapRegulatorySelectedOrder,
              srFieldName: submissionFormScope.searchMapRegulatoryField,
              srValue: submissionFormScope.searchMapRegulatoryInput
            },
            paginationParams: {
              pageIndex: submissionFormScope.regulatoryPageIndex,
              numberOfRegulatoryItems:
                submissionFormScope.numberOfRegulatoryItems
            }
          };
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          submissionFormScope.$buefy.dialog.alert({
            message: `Failed to update field values. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    updateRAFields() {
      var submissionFormScope = this;
      var requestPayload = {};
      requestPayload = submissionFormScope.updateRA;
      requestPayload.updatedBy = window.$cookies.get("ni_key").networkId;
      submissionFormScope.$http
        .put(
          `${process.env.VUE_APP_API_BASE_DOMAIN}regulatoryAffairs/massUpdate/submissionId/${submissionFormScope.submissionID}`,
          requestPayload
        )
        .then(function(response) {
          submissionFormScope.canLoadRegulatoryAffairsData = {
            loadDetails: true,
            generalQuestionRows: submissionFormScope.rows,
            actions: {
              fErrors: submissionFormScope.filterMapRAErrors,
              fLineErrors: submissionFormScope.filterMapRALineErrors
            },
            paginationParams: {
              pageIndex: submissionFormScope.raPageIndex,
              numberOfRAItems: submissionFormScope.numberOfRAItems
            }
          };
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          submissionFormScope.$buefy.dialog.alert({
            message: `Failed to update field values. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            confirmText: "OK",
            type: "is-danger"
          });
        });
    },
    fetchBolValues(search, loading) {
      if (search.length > 0) {
        var scope = this;

        loading(true);
        scope.$http
          .get(
            `${process.env.VUE_APP_API_BASE_DOMAIN}regulatoryAffairs/ctrlCodes/${search}`
          )
          .then(function(response) {
            loading(false);
            scope.bolOptions = response.data;
          })
          // eslint-disable-next-line no-unused-vars
          .catch(function(error) {
            loading(false);
            scope.$buefy.dialog.alert({
              message: `Failed to load Bill of Lading Code. Please enter valid search criteria and/or clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
              confirmText: "OK",
              type: "is-danger"
            });
          });
      }
    },
    massUploadAttachment(attachmentName) {
      var submissionFormScope = this;
      var networkId = JSON.parse(sessionStorage.getItem("se_ni_user"))
        .networkId;
      var file = "";
      var url = "";
      switch (attachmentName) {
        case "msdsAttachment":
          file = submissionFormScope.msdsAttachment;
          break;
        case "batteryAttachment":
          file = submissionFormScope.batteryAttachment;
          break;
        case "insertAttach":
          file = submissionFormScope.insertAttach;
          break;
      }

      var isUploadValid = /^.*\.(pdf|png|jpg|eps|tiff)$/.test(
        file.name.toLowerCase()
      );
      if (isUploadValid) {
        var args = {
          headers: {
            "content-type": "multipart/form-data"
          }
        };
        var uploadData = new FormData();
        uploadData.append(attachmentName, file);
        submissionFormScope.isLoading = true;
        if (submissionFormScope.prodCount >= 100) {
          url = `${process.env.VUE_APP_API_BASE_DOMAIN}uploadAttachments?nbrNewItemCrKey=${submissionFormScope.submissionID}&currentUser=${networkId}`;
        } else {
          url = `${process.env.VUE_APP_API_BASE_DOMAIN}uploadItemLevelAttachments?nbrNewItemCrKey=${submissionFormScope.submissionID}`;
        }
        submissionFormScope.$http
          .post(url, uploadData, args)
          // eslint-disable-next-line no-unused-vars
          .then(function(response) {
            submissionFormScope.isLoading = false;
            submissionFormScope.msdsAttachment = null;
            submissionFormScope.batteryAttachment = null;
            submissionFormScope.insertAttach = null;
            if (response.data === "BACKGROUND") {
              submissionFormScope.$buefy.dialog.alert({
                message: `Attachment is being processed for upload in the background. You will be notified via email once it is complete.`,
                confirmText: "OK",
                type: "is-success",
                onConfirm: () =>
                  (submissionFormScope.canLoadRegulatoryInformationData = {
                    loadDetails: true,
                    generalQuestionRows: submissionFormScope.rows,
                    actions: {
                      fErrors: submissionFormScope.filterMapRIErrors,
                      fCategory: submissionFormScope.filterMapCategory,
                      fProp65: submissionFormScope.filterMapProp65,
                      fMedDevice: submissionFormScope.filterMapMedDevice,
                      soField: submissionFormScope.sortMapRegulatoryField,
                      soOrder:
                        submissionFormScope.sortMapRegulatorySelectedOrder,
                      srFieldName: submissionFormScope.searchMapRegulatoryField,
                      srValue: submissionFormScope.searchMapRegulatoryInput
                    },
                    paginationParams: {
                      pageIndex: submissionFormScope.regulatoryPageIndex,
                      numberOfRegulatoryItems:
                        submissionFormScope.numberOfRegulatoryItems
                    }
                  })
              });
            } else {
              submissionFormScope.$buefy.dialog.alert({
                message: `Attachment upload successful.`,
                confirmText: "OK",
                type: "is-success",
                onConfirm: () =>
                  (submissionFormScope.canLoadRegulatoryInformationData = {
                    loadDetails: true,
                    generalQuestionRows: submissionFormScope.rows,
                    actions: {
                      fErrors: submissionFormScope.filterMapRIErrors,
                      fCategory: submissionFormScope.filterMapCategory,
                      fProp65: submissionFormScope.filterMapProp65,
                      fMedDevice: submissionFormScope.filterMapMedDevice,
                      soField: submissionFormScope.sortMapRegulatoryField,
                      soOrder:
                        submissionFormScope.sortMapRegulatorySelectedOrder,
                      srFieldName: submissionFormScope.searchMapRegulatoryField,
                      srValue: submissionFormScope.searchMapRegulatoryInput
                    },
                    paginationParams: {
                      pageIndex: submissionFormScope.regulatoryPageIndex,
                      numberOfRegulatoryItems:
                        submissionFormScope.numberOfRegulatoryItems
                    }
                  })
              });
            }
          })
          // eslint-disable-next-line no-unused-vars
          .catch(function(error) {
            submissionFormScope.isLoading = false;
            submissionFormScope.$buefy.dialog.alert({
              message: `A problem occurred with the attachment used. Please ensure attachment has the one of the following extensions: pdf, png, jpg, eps, tiff and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
              confirmText: "OK",
              type: "is-danger",
              onConfirm: () => {
                switch (attachmentName) {
                  case "msdsAttachment":
                    submissionFormScope.msdsAttachment = null;
                    break;
                  case "batteryAttachment":
                    submissionFormScope.batteryAttachment = null;
                    break;
                  case "insertAttach":
                    submissionFormScope.insertAttach = null;
                    break;
                }
              }
            });
          });
      } else {
        submissionFormScope.$buefy.dialog.alert({
          message: `"${file.name}" - Invalid file type, system accepts only pdf, png, jpg, eps, tiff image types.`,
          confirmText: "OK",
          type: "is-danger",
          onConfirm: () => {
            switch (attachmentName) {
              case "msdsAttachment":
                submissionFormScope.msdsAttachment = null;
                break;
              case "batteryAttachment":
                submissionFormScope.batteryAttachment = null;
                break;
              case "insertAttach":
                submissionFormScope.insertAttach = null;
                break;
            }
          }
        });
      }
    },
    resetRIUpdateFields() {
      this.update = {
        mercury: "N",
        benzene: "N",
        asbestos: "N",
        iodine: "N",
        radioActive: "N",
        pesticide: "N",
        alcohol: "N"
      };
    },
    resetRAUpdateFields() {
      this.updateRA = {
        ctrlCode: "",
        msds: "",
        bolCode: ""
      };
    },
    setValidateErrorCountForPS(errorCount) {
      this.validateErrorObj.errorCount = errorCount;
    },
    isSuListValueValid(rowData) {
      if (rowData.suList < rowData.suCost) {
        return "is-danger";
      }
    },
    isAuListValueValid(rowData) {
      var auCost = rowData.suCost * rowData.auQty;
      if (rowData.auList < auCost) {
        return "is-danger";
      }
    },
    updateSupplierTabsErrorCountForSuperUser(value) {
      this.supplierTabsErrorCountForSuperUser = value;
      this.validateSubmitForSuperUser();
    },
    updatePmErrorCountForSuperUser(value) {
      this.pmErrorCountForSuperUser = value;
      this.validateSubmitForSuperUser();
    },
    updatePmErrorCount(value) {
      this.pmTabErrorCount = value;
    },
    updateRiErrorCount(value) {
      this.riTabErrorCount = value;
    },
    updateGiErrorCount(value) {
      this.riTabErrorCount = value;
    },
    updateRaErrorCount(value) {
      this.raTabErrorCount = value;
    },
    updatePSTabErrorCountForSuperUser(value) {
      this.psTabErrorCount = value;
      this.validateSubmitForSuperUser();
    },
    validateApproverAlert() {
      var durationAlert = "";
      if (this.activeTab === 2) {
        if (this.prodCount < 1000) {
          durationAlert =
            "Validation process might take longer, please expect a delay of 1 to 5 minutes.";
        } else if (this.prodCount <= 2500) {
          durationAlert =
            "Validation process might take longer, please expect a delay of 5 to 15 minutes.";
        } else if (this.prodCount > 2500) {
          durationAlert =
            "Validation process might take longer, please expect a delay of 15 to 30 minutes.";
        }
      } else if (this.activeTab === 3 || this.activeTab === 4) {
        if (this.prodCount < 1000) {
          durationAlert =
            "System will process your request, it might take 1 to 3 minutes to complete the process.";
        } else {
          durationAlert =
            "System will process your request, it might take 1 to 8 minutes to complete the process.";
        }
      }
      this.$buefy.dialog.alert({
        message: durationAlert,
        confirmText: "OK",
        type: "is-info",
        onConfirm: () => {
          this.validateApproverTab();
        }
      });
    },
    validateApproverTab() {
      var submissionFormScope = this;
      var args = {};
      args.headers = {
        "content-type": "application/json"
      };

      var tabEndpoint = "",
        approverTabPageIndex = "",
        approverTabNoOfRecords = "";
      switch (submissionFormScope.activeTab) {
        case 2:
          tabEndpoint = "portfolioManagement";
          approverTabPageIndex = submissionFormScope.pmMinPageIndex;
          approverTabNoOfRecords = submissionFormScope.numberOfPMItems;
          break;
        case 3:
          tabEndpoint = "regulatoryAffairs";
          approverTabPageIndex = submissionFormScope.raMinPageIndex;
          approverTabNoOfRecords = submissionFormScope.numberOfRAItems;
          break;
        case 4:
          tabEndpoint = "productService";
          approverTabPageIndex = submissionFormScope.psMinPageIndex;
          approverTabNoOfRecords = submissionFormScope.numberOfPSItems;
          break;
      }

      submissionFormScope.isLoading = true;
      submissionFormScope.$http
        .get(
          `${process.env.VUE_APP_API_BASE_DOMAIN}${tabEndpoint}/validate?nbrNewItemCrKey=${submissionFormScope.submissionID}&pageIndex=${approverTabPageIndex}&noOfRecords=${approverTabNoOfRecords}`,
          args
        )
        .then(function(response) {
          submissionFormScope.isLoading = false;
          switch (submissionFormScope.activeTab) {
            case 2:
              submissionFormScope.canLoadPortfolioManagementData = {
                loadDetails: true,
                generalQuestionRows: submissionFormScope.rows,
                actions: {
                  fErrors: submissionFormScope.filterMapPMErrors,
                  fLineErrors: submissionFormScope.filterMapPMLineErrors
                },
                paginationParams: {
                  pageIndex: submissionFormScope.pmPageIndex,
                  numberOfPMItems: submissionFormScope.numberOfPMItems
                },
                validatePMData: response.data
              };
              break;
            case 3:
              submissionFormScope.canLoadRegulatoryAffairsData = {
                loadDetails: true,
                generalQuestionRows: submissionFormScope.rows,
                actions: {
                  fErrors: submissionFormScope.filterMapRAErrors,
                  fLineErrors: submissionFormScope.filterMapRALineErrors
                },
                paginationParams: {
                  pageIndex: submissionFormScope.raPageIndex,
                  numberOfRAItems: submissionFormScope.numberOfRAItems
                },
                validateRAData: response.data
              };
              break;
            case 4:
              submissionFormScope.canLoadProductServicesData = {
                loadDetails: true,
                generalQuestionRows: submissionFormScope.rows,
                actions: {
                  fErrors: submissionFormScope.filterMapPSErrors,
                  fLineErrors: submissionFormScope.filterMapPSLineErrors
                },
                paginationParams: {
                  pageIndex: submissionFormScope.psPageIndex,
                  numberOfPSItems: submissionFormScope.numberOfPSItems
                },
                validatePSData: response.data
              };
              break;
          }
        })
        .catch(function(error) {
          submissionFormScope.isLoading = false;
          submissionFormScope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to validate data for Submission - ${submissionFormScope.submissionID}. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            position: "is-top",
            queue: false
          });
        });
    },
    validateSubmitForSuperUser() {
      if (this.psTabErrorCount === 0) {
        this.enableApproverSubmit();
      } else {
        this.disableApproverSubmit();
      }
    }
  }
};
</script>

<style>
.view-always {
  display: inline;
}
</style>
